/* CUSTOM_AGENTPANELS_BY_CLAUDE (AIOPS 5110be2bd2b7 + d24e8a003b71 + ce9ba172b794, Ryan 2026-09-04)
   ─────────────────────────────────────────────────────────────────────────────
   Settings → Admin: Vendor Reply SLA and Admin: Inbound Replies (orders@) — the JS half.

   ⛔ ITS OWN ASSET BECAUSE THE SECTION IS FULL. rep-quote-settings.liquid sits at ~254 KB of
   Shopify's 256 KB template limit; the first push with these panels inline was refused with
   "Template content exceeds 256 KB limit". The markup lives in
   snippets/rep-settings-agent-panels.liquid for the same reason. Anything else added to the
   Settings page from here on goes the same way: snippet + asset, not more section.

   Loaded deferred from the section, after custom-rep-portal.js (which defines
   window.RepPortal.API); runs on DOMContentLoaded exactly like the section's own initSettings,
   so every deferred script has executed by then. showMsg / hideMsg are the section's two
   helpers, copied because they are IIFE-local there. */
(function() {
  'use strict';
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }

  function initAgentPanels() {
    if (!window.RepPortal || !window.RepPortal.API) return;
/* CUSTOM_VENDORASKSLA_BY_CLAUDE (AIOPS ea06c70f11a9 + 5110be2bd2b7, Ryan 2026-09-04) —
   Admin: Vendor Reply SLA. Same load-from-server rule as the panels above: nothing is
   defaulted in the markup. */
var vslaEnabled = document.getElementById('settings-vsla-enabled');
var vslaThreshold = document.getElementById('settings-vsla-threshold');
var vslaCutoff = document.getElementById('settings-vsla-cutoff');
var vslaDigest = document.getElementById('settings-vsla-digest');
var vslaUnmatchable = document.getElementById('settings-vsla-unmatchable');
var vslaBtn = document.getElementById('settings-vsla-btn');
var vslaMsg = document.getElementById('settings-vsla-msg');
var vslaStatus = document.getElementById('settings-vsla-status');

function vslaEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function vslaWhen(iso) { if (!iso) return 'never'; var d = new Date(iso); return isNaN(d.getTime()) ? String(iso) : d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); }

function vslaRender(data) {
  if (!vslaStatus) return;
  var sw = data && data.lastSweep;
  var dg = data && data.lastDigest;
  if (!sw) { vslaStatus.innerHTML = 'The sweep has not run yet. It runs every three hours; the first pass shows here.'; return; }
  var html = '<div>Ran <strong>' + vslaEsc(vslaWhen(sw.at)) + '</strong>' + (sw.enabled === false ? ' &mdash; <strong>switched off</strong>' : '') + ': '
    + vslaEsc(sw.scanned) + ' deals scanned, ' + vslaEsc(sw.openAsks) + ' open asks, <strong>' + vslaEsc(sw.late) + ' late</strong>'
    + (sw.preCutoffLate ? ' (' + vslaEsc(sw.preCutoffLate) + ' from before the cutoff, digested rather than woken)' : '')
    + (sw.unmatchableSkipped ? ', ' + vslaEsc(sw.unmatchableSkipped) + ' skipped as unmatchable' : '')
    + ', ' + vslaEsc(sw.stale) + ' stale.' + (sw.error ? ' <strong style="color:#f87171;">Error: ' + vslaEsc(sw.error) + '</strong>' : '') + '</div>';
  if (sw.flagged && sw.flagged.length) {
    html += '<div style="margin-top: 6px;">Newly flagged: ' + sw.flagged.map(function(f) { return vslaEsc(f.ref) + ' (' + vslaEsc(f.vendor) + ', ' + vslaEsc(f.kind) + ', ' + vslaEsc(f.workdaysWaiting) + ' workdays)'; }).join('; ') + '</div>';
  }
  if (sw.cleared && sw.cleared.length) {
    html += '<div style="margin-top: 6px;">Cleared: ' + sw.cleared.map(function(f) { return vslaEsc(f.ref) + ' (' + vslaEsc(f.vendor) + ', ' + vslaEsc(f.why) + ')'; }).join('; ') + '</div>';
  }
  html += '<div style="margin-top: 6px;">Pre-cutoff digest: ' + (dg ? 'last sent ' + vslaEsc(vslaWhen(dg.at)) + ' with ' + vslaEsc(dg.count) + ' ask(s)' : 'never sent') + '.</div>';
  vslaStatus.innerHTML = html;
}

if (vslaBtn && vslaEnabled) {
  (async function loadVsla() {
    try {
      var data = await window.RepPortal.API.get('/admin/vendor-ask-sla-config');
      var cfg = data.config || {};
      vslaEnabled.checked = cfg.enabled !== false;
      vslaThreshold.value = cfg.thresholdWorkdays;
      vslaCutoff.value = cfg.cutoffAt || '';
      vslaDigest.checked = cfg.preCutoffDigest !== false;
      vslaUnmatchable.checked = cfg.wakeUnmatchable !== false;
      vslaRender(data);
    } catch (e) {
      showMsg(vslaMsg, 'Could not load the current SLA rules — reload before saving.', 'error');
      if (vslaStatus) vslaStatus.textContent = 'Could not load the last sweep.';
    }
  })();

  vslaBtn.addEventListener('click', async function() {
    hideMsg(vslaMsg);
    var t = parseInt(vslaThreshold.value, 10);
    if (!isFinite(t) || t < 1 || t > 10) { showMsg(vslaMsg, 'Enter a whole number of workdays from 1 to 10.', 'error'); return; }
    var cut = (vslaCutoff.value || '').trim();
    if (cut && isNaN(new Date(cut).getTime())) { showMsg(vslaMsg, 'The cutoff must be an ISO date-time, e.g. 2026-08-29T12:00:00-06:00, or empty for the default.', 'error'); return; }
    vslaBtn.disabled = true;
    var orig = vslaBtn.textContent;
    vslaBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/vendor-ask-sla-config', {
        enabled: !!vslaEnabled.checked,
        thresholdWorkdays: t,
        cutoffAt: cut || null,
        preCutoffDigest: !!vslaDigest.checked,
        wakeUnmatchable: !!vslaUnmatchable.checked,
      });
      if (res && res.config) vslaCutoff.value = res.config.cutoffAt || '';
      showMsg(vslaMsg, res && res.config && res.config.enabled
        ? 'Saved — late supplier asks wake the agent after ' + res.config.thresholdWorkdays + ' workday(s); asks from before ' + res.config.cutoffAt + ' go in the daily digest.'
        : 'Saved — the vendor reply SLA is switched off.', 'success');
    } catch (e) {
      showMsg(vslaMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      vslaBtn.disabled = false;
      vslaBtn.textContent = orig;
    }
  });
}
/* CUSTOM_ASKPARK_BY_CLAUDE (AIOPS e701757de90f + facf1e051d77, Ryan 2026-09-17) — the do-not-chase
   door, on the panel that owns the sweep it silences.

   ⛔ THE LIST IS THE POINT, NOT THE FORM. A park that could only be created and never SEEN would
   turn a chase going quiet into a mystery three months later, which is the same shape as the bug
   this fixes. Every parked ask is listed with who parked it, when, and why, and every one can be
   lifted from the same row. */
var apRef = document.getElementById('settings-askpark-ref');
var apVendor = document.getElementById('settings-askpark-vendor');
var apKind = document.getElementById('settings-askpark-kind');
var apReason = document.getElementById('settings-askpark-reason');
var apBtn = document.getElementById('settings-askpark-btn');
var apMsg = document.getElementById('settings-askpark-msg');
var apList = document.getElementById('settings-askpark-list');

var AP_KIND_WORDS = { freight: 'freight rate', dims: 'weight and dims', 'payment-link': 'payment link',
  /* CUSTOM_WAITJUDGE_BY_CLAUDE (AIOPS 3b40cb7b6ea2) - "handled by me" and an agent's close share this list. */
  'abby-external': 'reply to an email Abby started', all: 'every ask (handled)' };

async function apRefresh() {
  if (!apList) return;
  try {
    var d = await window.RepPortal.API.get('/admin/vendor-ask-park');
    var rows = (d && d.parked) || [];
    if (!rows.length) {
      apList.innerHTML = 'Nothing is parked. Every open supplier ask counts towards the SLA.';
      return;
    }
    apList.innerHTML = '<div style="margin-bottom: 6px;"><strong>' + rows.length + '</strong> ask'
      + (rows.length === 1 ? '' : 's') + ' parked as do-not-chase:</div>'
      + rows.map(function(r) {
        return '<div style="padding: 8px 0; border-top: 1px solid var(--rq-border, #1e2a42);">'
          + '<strong>' + vslaEsc(r.ref) + '</strong> &middot; ' + vslaEsc(r.vendor) + ' &middot; '
          + vslaEsc(AP_KIND_WORDS[r.kind] || r.kind)
          + '<br>' + vslaEsc(r.reason || '')
          + '<br><span style="opacity: 0.75;">' + (r.source === 'agent' ? 'Closed by the AI agent ' : (r.kind === 'all' ? 'Marked handled ' : 'Parked ')) + vslaEsc(vslaWhen(r.parkedAt)) + ' by ' + vslaEsc(r.parkedBy || 'an admin') + '.</span> '
          + '<button type="button" class="rep-settings__submit" data-unpark-ref="' + vslaEsc(r.ref) + '" data-unpark-vendor="' + vslaEsc(r.vendor) + '" data-unpark-kind="' + vslaEsc(r.kind) + '" style="margin-left: 6px; padding: 2px 10px; font-size: 12px; opacity: 0.85;">Chase it again</button>'
          + '</div>';
      }).join('');
  } catch (e) {
    /* ⛔ A failed load says so. "Nothing is parked" would be a lie that hides a live park. */
    apList.textContent = 'Could not load the parked asks — reload before parking anything.';
  }
}

if (apBtn && apRef) {
  apRefresh();

  apBtn.addEventListener('click', async function() {
    hideMsg(apMsg);
    var ref = (apRef.value || '').trim().toUpperCase();
    var vendor = (apVendor.value || '').trim();
    var reason = (apReason.value || '').trim();
    if (!ref) { showMsg(apMsg, 'Name the deal, for example SHOP-2000.', 'error'); return; }
    if (!vendor) { showMsg(apMsg, 'Name the supplier — a park silences one supplier ask, not the whole deal.', 'error'); return; }
    if (reason.length < 4) { showMsg(apMsg, 'Say why it is not being chased. Whoever finds this in three months needs to know.', 'error'); return; }
    apBtn.disabled = true;
    var orig = apBtn.textContent;
    apBtn.textContent = 'Parking...';
    try {
      var res = await window.RepPortal.API.post('/admin/vendor-ask-park', {
        ref: ref, vendor: vendor, kind: apKind ? apKind.value : 'freight', reason: reason,
      });
      showMsg(apMsg, (apKind && apKind.value === 'all' ? 'Marked handled — every ' + vslaEsc(vendor) + ' ask' : 'Parked — the ' + vslaEsc(vendor) + ' ask') + ' on ' + vslaEsc(ref) + ' stops counting as late'
        + (res && res.flagCleared ? ' and the late flag on it is cleared now, not at the next sweep' : '') + '.', 'success');
      apReason.value = '';
      apRefresh();
    } catch (e) {
      showMsg(apMsg, 'Could not park it: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { apBtn.disabled = false; apBtn.textContent = orig; }
  });
}

if (apList) {
  apList.addEventListener('click', async function(ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-unpark-ref]') : null;
    if (!btn) return;
    hideMsg(apMsg);
    btn.disabled = true;
    try {
      await window.RepPortal.API.post('/admin/vendor-ask-park', {
        ref: btn.getAttribute('data-unpark-ref'), vendor: btn.getAttribute('data-unpark-vendor'),
        kind: btn.getAttribute('data-unpark-kind'), action: 'unpark',
      });
      showMsg(apMsg, 'Unparked — that ask counts towards the SLA again from the next sweep.', 'success');
      apRefresh();
    } catch (e) {
      btn.disabled = false;
      showMsg(apMsg, 'Could not unpark it: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    }
  });
}
/* END CUSTOM_ASKPARK_BY_CLAUDE */

/* END CUSTOM_VENDORASKSLA_BY_CLAUDE */

/* CUSTOM_LAUNCHGRANTS_BY_CLAUDE (AIOPS 691e85351bc1, Ryan 2026-09-10) — Admin: Launch Grants at
   Ship. One switch over GET/POST /admin/launch-grants-config; loaded from the server, never
   defaulted in the markup, and the confirm names what arming it actually does. */
var lgArmed = document.getElementById('settings-launchgrants-armed');
var lgBtn = document.getElementById('settings-launchgrants-btn');
var lgMsg = document.getElementById('settings-launchgrants-msg');
var lgState = document.getElementById('settings-launchgrants-state');

function lgRenderState(cfg) {
  if (!lgState) return;
  if (!cfg) { lgState.textContent = ''; return; }
  lgState.textContent = cfg.updatedBy
    ? 'Last changed by ' + cfg.updatedBy + (cfg.updatedAt ? ' on ' + String(cfg.updatedAt).replace('T', ' ').slice(0, 16) : '') + '.'
    : 'Never changed \u2014 this is the shipped default (off).';
}

if (lgBtn && lgArmed) {
  (async function loadLg() {
    try {
      var data = await window.RepPortal.API.get('/admin/launch-grants-config');
      var cfg = (data && data.config) || null;
      lgArmed.checked = !!(cfg && cfg.armed === true);
      lgRenderState(cfg);
    } catch (e) {
      showMsg(lgMsg, 'Could not load the current setting \u2014 reload before saving.', 'error');
    }
  })();
  lgBtn.addEventListener('click', async function() {
    hideMsg(lgMsg);
    /* \u26d4 THE CONFIRM IS ON ARMING ONLY, and it says what the click really does. Widening
       confirms, narrowing does not \u2014 the house rule from the automation-audience dropdown. */
    if (lgArmed.checked && !confirm('Arm launch grants at ship?\n\nFrom now on, when a build session marks a Suggestion "Built it", the agents that suggestion names will be granted the new capability automatically. You can still revoke any of it on the Agents tab.\n\nOff, every grant waits for your click.')) {
      lgArmed.checked = false;
      return;
    }
    lgBtn.disabled = true;
    var orig = lgBtn.textContent;
    lgBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/launch-grants-config', { armed: !!lgArmed.checked });
      var cfg = res && res.config;
      showMsg(lgMsg, cfg && cfg.armed
        ? 'Saved \u2014 a card marked Built it now grants the agents it names.'
        : 'Saved \u2014 a card marked Built it records what it would grant, and waits for your click on the Suggestions tab.', 'success');
      lgRenderState(cfg);
    } catch (e) {
      showMsg(lgMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      lgBtn.disabled = false;
      lgBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_LAUNCHGRANTS_BY_CLAUDE */

/* CUSTOM_SAMPLEORDERED_BY_CLAUDE (AIOPS cef17ade5a86, Ryan 2026-09-10) — Admin: Samples Ordered
   Note to the Rep. One switch over GET/POST /admin/sample-ordered-notice-config. Ships ON, so an
   absent record reads as on \u2014 the markup still never defaults it; the server does. */
var soEnabled = document.getElementById('settings-sampleordered-enabled');
var soBtn = document.getElementById('settings-sampleordered-btn');
var soMsg = document.getElementById('settings-sampleordered-msg');
if (soBtn && soEnabled) {
  (async function loadSo() {
    try {
      var data = await window.RepPortal.API.get('/admin/sample-ordered-notice-config');
      soEnabled.checked = !!(data && data.config && data.config.enabled === true);
    } catch (e) {
      showMsg(soMsg, 'Could not load the current setting \u2014 reload before saving.', 'error');
    }
  })();
  soBtn.addEventListener('click', async function() {
    hideMsg(soMsg);
    soBtn.disabled = true;
    var orig = soBtn.textContent;
    soBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/sample-ordered-notice-config', { enabled: !!soEnabled.checked });
      showMsg(soMsg, res && res.config && res.config.enabled
        ? 'Saved \u2014 the rep hears back on their own thread when the ECORE request goes out.'
        : 'Saved \u2014 nothing is sent to the rep; the request still goes to ECORE as normal.', 'success');
    } catch (e) {
      showMsg(soMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      soBtn.disabled = false;
      soBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_SAMPLEORDERED_BY_CLAUDE */

/* CUSTOM_SUPPLIERTHANKS_BY_CLAUDE (ONYX 67aa1ab4517a, Ryan 2026-10-15) - Admin: Thank-You Emails. Two switches over
   GET/POST /admin/deal-thanks-config and /admin/supplier-thanks-config; the server reads an absent record as off. */
var tyCustomer = document.getElementById('settings-thankyou-customer');
var tySupplier = document.getElementById('settings-thankyou-supplier');
var tyConcession = document.getElementById('settings-thankyou-concession'); // CUSTOM_CONCESSIONTHANKS_BY_CLAUDE (ONYX 3c47d889a121)
var tyBtn = document.getElementById('settings-thankyou-btn');
var tyMsg = document.getElementById('settings-thankyou-msg');
if (tyBtn && tyCustomer && tySupplier) {
  (async function loadTy() {
    try {
      var c = await window.RepPortal.API.get('/admin/deal-thanks-config');
      var s = await window.RepPortal.API.get('/admin/supplier-thanks-config');
      tyCustomer.checked = !!(c && c.enabled === true);
      tySupplier.checked = !!(s && s.enabled === true);
      if (tyConcession) tyConcession.checked = !!(s && s.concessions === true); // CUSTOM_CONCESSIONTHANKS_BY_CLAUDE
    } catch (e) {
      showMsg(tyMsg, 'Could not load the current settings — reload before saving.', 'error');
    }
  })();
  tyBtn.addEventListener('click', async function() {
    hideMsg(tyMsg);
    tyBtn.disabled = true;
    var orig = tyBtn.textContent;
    tyBtn.textContent = 'Saving...';
    try {
      await window.RepPortal.API.post('/admin/deal-thanks-config', { enabled: !!tyCustomer.checked });
      await window.RepPortal.API.post('/admin/supplier-thanks-config', tyConcession ? { enabled: !!tySupplier.checked, concessions: !!tyConcession.checked } : { enabled: !!tySupplier.checked }); // concessions: CUSTOM_CONCESSIONTHANKS_BY_CLAUDE
      showMsg(tyMsg, 'Saved — customer thanks ' + (tyCustomer.checked ? 'on' : 'off') + ', supplier thanks ' + (tySupplier.checked ? 'on' : 'off') + (tyConcession ? ', concession thanks ' + (tyConcession.checked ? 'on' : 'off') : '') + '. Each one still comes to you as a [TEST] first.', 'success');
    } catch (e) {
      showMsg(tyMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      tyBtn.disabled = false;
      tyBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_SUPPLIERTHANKS_BY_CLAUDE */

/* CUSTOM_INBOUNDREPLY_BY_CLAUDE (AIOPS d24e8a003b71, Ryan 2026-09-04) — Admin: Inbound
   Replies (orders@). The switch, the subscription's health, Subscribe now, the recent list. */
var ibEnabled = document.getElementById('settings-inbound-enabled');
var ibAgentOnly = document.getElementById('settings-inbound-agentonly');
var ibAutoReply = document.getElementById('settings-inbound-autoreply');
/* CUSTOM_INBOXWAKE_BY_CLAUDE (AIOPS 2d73abf91f88, Ryan 2026-09-10) */
var ibBackstop = document.getElementById('settings-inbound-backstop');
var ibBtn = document.getElementById('settings-inbound-btn');
var ibMsg = document.getElementById('settings-inbound-msg');
var ibSub = document.getElementById('settings-inbound-sub');
var ibSubscribe = document.getElementById('settings-inbound-subscribe');
var ibRefresh = document.getElementById('settings-inbound-refresh');
var ibSubMsg = document.getElementById('settings-inbound-submsg');
var ibRecent = document.getElementById('settings-inbound-recent');

function ibRenderSub(data) {
  if (!ibSub) return;
  var sub = data && data.subscription;
  var c = data && data.counts;
  var line;
  if (!sub || sub.status === 'none') line = '<strong>Not subscribed.</strong> Nothing is listening to orders@ yet — press Subscribe now, or wait for the two-hourly check.';
  else if (sub.status === 'expired') line = '<strong style="color:#f87171;">Expired</strong> at ' + vslaEsc(vslaWhen(sub.expiresAt)) + '. Replies since then were not heard; Subscribe now re-creates it and catches up.';
  else line = '<strong>' + (sub.status === 'live' ? 'Live' : 'Live, renewal due') + '</strong> — expires ' + vslaEsc(vslaWhen(sub.expiresAt)) + ' (' + vslaEsc(sub.minutesLeft) + ' min), renewed ' + vslaEsc(vslaWhen(sub.renewedAt || sub.createdAt)) + '.';
  if (c) line += '<div style="margin-top: 4px;">Notifications: ' + vslaEsc(c.notified) + ' &middot; processed ' + vslaEsc(c.processed) + ' &middot; matched ' + vslaEsc(c.matched) + ' &middot; woke the agent ' + vslaEsc(c.woke) + ' &middot; unmatched ' + vslaEsc(c.unmatched) + ' &middot; rejected (wrong clientState) ' + vslaEsc(c.rejected) + '.</div>';
  if (data && data.lastCron) line += '<div style="margin-top: 4px;">Last check ' + vslaEsc(vslaWhen(data.lastCron.at)) + ': ' + vslaEsc(data.lastCron.action) + (data.lastCron.error ? ' — ' + vslaEsc(data.lastCron.error) : '') + '.</div>';
  if (data && data.lastNotifyAt) line += '<div style="margin-top: 4px;">Last notification from Microsoft ' + vslaEsc(vslaWhen(data.lastNotifyAt)) + '.</div>';
  ibSub.innerHTML = line;
}

function ibRenderRecent(data) {
  if (!ibRecent) return;
  var rows = (data && data.recent) || [];
  if (!rows.length) { ibRecent.innerHTML = '<div style="color: var(--rq-text-secondary);">Nothing has come through yet.</div>'; return; }
  var html = '<table style="width: 100%; border-collapse: collapse; font-size: 12px;"><thead><tr style="text-align: left; color: var(--rq-text-secondary);"><th style="padding: 4px;">When</th><th style="padding: 4px;">Deal</th><th style="padding: 4px;">From</th><th style="padding: 4px;">Subject</th><th style="padding: 4px;">Kind</th><th style="padding: 4px;">Agent</th></tr></thead><tbody>';
  rows.forEach(function(r) {
    var fig = r.extracted ? Object.keys(r.extracted).map(function(k) { var v = r.extracted[k]; return k + '=' + (typeof v === 'object' ? JSON.stringify(v) : v); }).join(' ') : '';
    html += '<tr style="border-top: 1px solid var(--rq-border, #1e2a42);">'
      + '<td style="padding: 4px; white-space: nowrap;">' + vslaEsc(vslaWhen(r.receivedAt || r.at)) + '</td>'
      + '<td style="padding: 4px;">' + (r.ref ? '<strong>' + vslaEsc(r.ref) + '</strong><div style="color: var(--rq-text-secondary);">' + vslaEsc(r.matchedBy) + '</div>' : '<span style="color: var(--rq-text-secondary);">no deal (' + vslaEsc(r.reason) + ')</span>') + '</td>'
      + '<td style="padding: 4px;">' + vslaEsc(r.from) + '</td>'
      + '<td style="padding: 4px;">' + vslaEsc(r.subject) + '</td>'
      + '<td style="padding: 4px;">' + vslaEsc(r.replyKind || '') + (fig ? '<div style="color: var(--rq-text-secondary);">' + vslaEsc(fig) + '</div>' : '') + '</td>'
      + '<td style="padding: 4px;">' + (r.woke ? 'woken' : (r.ref ? 'filed only (' + vslaEsc(r.reason) + ')' : '')) + '</td>'
      + '</tr>';
  });
  ibRecent.innerHTML = html + '</tbody></table>';
}

async function ibLoad() {
  try {
    var data = await window.RepPortal.API.get('/inbound-replies');
    var cfg = data.config || {};
    if (ibEnabled) ibEnabled.checked = cfg.enabled !== false;
    if (ibAgentOnly) ibAgentOnly.checked = cfg.wakeOnlyAgentDeals !== false;
    if (ibAutoReply) ibAutoReply.checked = cfg.wakeOnAutoReply === true;
    /* absent reads as ON, which is what the worker's default is */
    if (ibBackstop) ibBackstop.checked = cfg.wakeOnEveryInboxMessage !== false;
    ibRenderSub(data);
    ibRenderRecent(data);
  } catch (e) {
    showMsg(ibMsg, 'Could not load the inbound-reply settings — reload before saving.', 'error');
    if (ibSub) ibSub.textContent = 'Could not load the subscription state.';
  }
}

if (ibBtn && ibEnabled) {
  ibLoad();
  ibBtn.addEventListener('click', async function() {
    hideMsg(ibMsg);
    ibBtn.disabled = true;
    var orig = ibBtn.textContent;
    ibBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/inbound-replies-config', {
        enabled: !!ibEnabled.checked,
        wakeOnlyAgentDeals: !!ibAgentOnly.checked,
        wakeOnAutoReply: !!ibAutoReply.checked,
        wakeOnEveryInboxMessage: !!(ibBackstop && ibBackstop.checked),
      });
      var act = res && res.subscription && res.subscription.action;
      showMsg(ibMsg, res && res.config && res.config.enabled
        ? 'Saved — orders@ is being watched' + (act === 'created' ? ' (subscription created).' : act === 'no-token' ? ', but orders@ is not connected to Outlook, so nothing can be heard yet.' : '.')
        : 'Saved — inbound replies are switched off and the Microsoft subscription was removed.', res && res.subscription && res.subscription.ok === false ? 'error' : 'success');
      ibLoad();
    } catch (e) {
      showMsg(ibMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ibBtn.disabled = false;
      ibBtn.textContent = orig;
    }
  });
}
if (ibSubscribe) {
  ibSubscribe.addEventListener('click', async function() {
    hideMsg(ibSubMsg);
    ibSubscribe.disabled = true;
    var orig = ibSubscribe.textContent;
    ibSubscribe.textContent = 'Subscribing...';
    try {
      var res = await window.RepPortal.API.post('/admin/inbound-replies/subscribe', {});
      var cu = res && res.caughtUp;
      showMsg(ibSubMsg, res && res.ok
        ? 'Subscription ' + res.action + '.' + (cu ? ' Caught up ' + cu.listed + ' message(s) that arrived while it was down; ' + cu.matched + ' matched, ' + cu.woke + ' woke the agent.' : '')
        : 'Could not subscribe: ' + ((res && (res.error || res.action)) || 'unknown'), res && res.ok ? 'success' : 'error');
      ibLoad();
    } catch (e) {
      showMsg(ibSubMsg, 'Could not subscribe: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ibSubscribe.disabled = false;
      ibSubscribe.textContent = orig;
    }
  });
}
if (ibRefresh) ibRefresh.addEventListener('click', ibLoad);
/* END CUSTOM_INBOUNDREPLY_BY_CLAUDE */

/* CUSTOM_POTHREAD_BY_CLAUDE (AIOPS 4da52e6a59c6, Ryan 2026-09-04) — Admin: PO Replies on the
   Rate Thread. One switch, loaded from the server, never defaulted in the markup. */
var ptEnabled = document.getElementById('settings-pothread-enabled');
var ptBtn = document.getElementById('settings-pothread-btn');
var ptMsg = document.getElementById('settings-pothread-msg');
if (ptBtn && ptEnabled) {
  (async function loadPt() {
    try {
      var data = await window.RepPortal.API.get('/admin/po-thread-config');
      ptEnabled.checked = !!(data && data.config && data.config.enabled === true);
    } catch (e) {
      showMsg(ptMsg, 'Could not load the current setting — reload before saving.', 'error');
    }
  })();
  ptBtn.addEventListener('click', async function() {
    hideMsg(ptMsg);
    ptBtn.disabled = true;
    var orig = ptBtn.textContent;
    ptBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/po-thread-config', { enabled: !!ptEnabled.checked });
      showMsg(ptMsg, res && res.config && res.config.enabled
        ? 'Saved — live PO sends now reply on the supplier\'s rate thread when one is on file.'
        : 'Saved — PO sends start a new email. Test sends still thread.', 'success');
    } catch (e) {
      showMsg(ptMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ptBtn.disabled = false;
      ptBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_POTHREAD_BY_CLAUDE */

/* CUSTOM_REFUNDOWED_BY_CLAUDE (ONYX 91d311965e9d, Ryan 2026-10-01) — Admin: Refund Owed Reminders. One switch over
   GET/POST /admin/refund-owed-config ({enabled}; the GET also answers the open items), and a Dismiss per item
   (POST /admin/refund-owed-dismiss {ref, reason}). Loaded from the server, never defaulted in the markup. */
var roEnabled = document.getElementById('settings-refundowed-enabled');
var roBtn = document.getElementById('settings-refundowed-btn');
var roMsg = document.getElementById('settings-refundowed-msg');
var roList = document.getElementById('settings-refundowed-list');
function roEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function roRender(open) {
  if (!roList) return;
  if (!open || !open.length) { roList.innerHTML = '<span style="color: var(--rq-text-secondary);">No refunds are owed right now.</span>'; return; }
  roList.innerHTML = '<div style="font-weight: 600; margin-bottom: 6px;">Owed now</div>' + open.map(function(r) {
    var amt = (r.amount != null) ? '$' + Number(r.amount).toFixed(2) : 'no figure stated';
    var since = r.openedAt ? new Date(r.openedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';
    return '<div style="display: flex; gap: 10px; align-items: center; padding: 6px 0; border-top: 1px solid var(--rq-border, #e5e7eb);">'
      + '<span style="flex: 1;"><strong>' + roEsc(r.ref) + '</strong> · ' + roEsc(amt) + (since ? ' · since ' + roEsc(since) : '') + '</span>'
      + '<button type="button" class="rep-settings__submit" data-refundowed-dismiss="' + roEsc(r.ref) + '" style="margin: 0; padding: 4px 10px;">Dismiss</button>'
      + '</div>';
  }).join('');
}
if (roBtn && roEnabled) {
  (async function loadRo() {
    try {
      var data = await window.RepPortal.API.get('/admin/refund-owed-config');
      roEnabled.checked = !!(data && data.enabled === true);
      roRender(data && data.open);
    } catch (e) {
      showMsg(roMsg, 'Could not load the current setting — reload before saving.', 'error');
    }
  })();
  roBtn.addEventListener('click', async function() {
    hideMsg(roMsg);
    roBtn.disabled = true;
    var orig = roBtn.textContent;
    roBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/refund-owed-config', { enabled: !!roEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      roEnabled.checked = !!(res && res.enabled === true);
      showMsg(roMsg, res && res.enabled
        ? 'Saved — a refund promised in a live reply now opens an item and emails you until it is refunded.'
        : 'Saved — refund promises are not tracked and nobody is emailed.', 'success');
    } catch (e) {
      showMsg(roMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      roBtn.disabled = false;
      roBtn.textContent = orig;
    }
  });
  if (roList) roList.addEventListener('click', async function(ev) {
    var b = ev.target.closest('[data-refundowed-dismiss]');
    if (!b) return;
    var ref = b.getAttribute('data-refundowed-dismiss');
    var reason = window.prompt('Why is no refund owed on ' + ref + '? (shown on the deal feed)', '');
    if (reason === null) return;
    b.disabled = true;
    try {
      var res = await window.RepPortal.API.post('/admin/refund-owed-dismiss', { ref: ref, reason: reason });
      if (res && res.error) throw new Error(res.error);
      var data = await window.RepPortal.API.get('/admin/refund-owed-config');
      roRender(data && data.open);
      showMsg(roMsg, 'Dismissed ' + ref + '. No more reminders for it.', 'success');
    } catch (e) {
      b.disabled = false;
      showMsg(roMsg, 'Could not dismiss: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    }
  });
}
/* END CUSTOM_REFUNDOWED_BY_CLAUDE */

/* CUSTOM_REFUNDAFTEREMAIL_BY_CLAUDE (ONYX 06a820791f3b, Ryan 2026-10-17) - the refund-after-email switch, in the Refund Owed
   panel. GET/POST /admin/refund-after-email-config ({enabled}). Loaded from the server, never defaulted in the markup. */
var raeEnabled = document.getElementById('settings-refundafteremail-enabled');
var raeBtn = document.getElementById('settings-refundafteremail-btn');
var raeMsg = document.getElementById('settings-refundafteremail-msg');
if (raeBtn && raeEnabled) {
  (async function loadRae() {
    try {
      var data = await window.RepPortal.API.get('/admin/refund-after-email-config');
      raeEnabled.checked = !!(data && data.enabled === true);
    } catch (e) {
      showMsg(raeMsg, 'Could not load the current setting, reload before saving.', 'error');
    }
  })();
  raeBtn.addEventListener('click', async function() {
    hideMsg(raeMsg);
    raeBtn.disabled = true;
    var orig = raeBtn.textContent;
    raeBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/refund-after-email-config', { enabled: !!raeEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      raeEnabled.checked = !!(res && res.enabled === true);
      showMsg(raeMsg, res && res.enabled
        ? 'Saved. ONYX is woken the moment a held email goes out, and you are emailed if the refund has not gone through 30 minutes later.'
        : 'Saved. Refund holds are off: none can be recorded, nobody is woken and nobody is emailed.', 'success');
    } catch (e) {
      showMsg(raeMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      raeBtn.disabled = false;
      raeBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_REFUNDAFTEREMAIL_BY_CLAUDE */

/* CUSTOM_SUPPORTREFUND_BY_CLAUDE (cards 4d96463ed8c4 + f1bec8bc83cf, Ryan 2026-10-20) - the support@ refund-promise switch, in
   the Refund Owed panel. GET/POST /admin/refund-owed-support-config ({enabled}; the GET also says refundOwedEnabled).
   Loaded from the server, never defaulted in the markup. */
var rosEnabled = document.getElementById('settings-refundowedsupport-enabled');
var rosBtn = document.getElementById('settings-refundowedsupport-btn');
var rosMsg = document.getElementById('settings-refundowedsupport-msg');
if (rosBtn && rosEnabled) {
  (async function loadRos() {
    try {
      var data = await window.RepPortal.API.get('/admin/refund-owed-support-config');
      rosEnabled.checked = !!(data && data.enabled === true);
    } catch (e) {
      showMsg(rosMsg, 'Could not load the current setting, reload before saving.', 'error');
    }
  })();
  rosBtn.addEventListener('click', async function() {
    hideMsg(rosMsg);
    rosBtn.disabled = true;
    var orig = rosBtn.textContent;
    rosBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/refund-owed-support-config', { enabled: !!rosEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      rosEnabled.checked = !!(res && res.enabled === true);
      var mainOn = roEnabled && roEnabled.checked;
      showMsg(rosMsg, res && res.enabled
        ? (mainOn ? 'Saved. A refund promised in a support@ email you send now opens a refund owed item.' : 'Saved, but the refund reminder switch above is off, so nothing is tracked until it is on too.')
        : 'Saved. Refund promises in support@ emails are not read or tracked.', 'success');
    } catch (e) {
      showMsg(rosMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      rosBtn.disabled = false;
      rosBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_SUPPORTREFUND_BY_CLAUDE */

/* CUSTOM_REFUNDOKONLY_BY_CLAUDE (Ryan 2026-10-30, SHOP-2168) - the "Refund on my written OK alone" switch, in the Refund Owed
   panel. GET/POST /admin/refund-ok-only-config ({enabled}). Loaded from the server, never defaulted in the markup. */
var rokEnabled = document.getElementById('settings-refundokonly-enabled');
var rokBtn = document.getElementById('settings-refundokonly-btn');
var rokMsg = document.getElementById('settings-refundokonly-msg');
if (rokBtn && rokEnabled) {
  (async function loadRok() {
    try {
      var data = await window.RepPortal.API.get('/admin/refund-ok-only-config');
      rokEnabled.checked = !!(data && data.enabled === true);
    } catch (e) {
      showMsg(rokMsg, 'Could not load the current setting, reload before saving.', 'error');
    }
  })();
  rokBtn.addEventListener('click', async function() {
    hideMsg(rokMsg);
    rokBtn.disabled = true;
    var orig = rokBtn.textContent;
    rokBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/refund-ok-only-config', { enabled: !!rokEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      rokEnabled.checked = !!(res && res.enabled === true);
      showMsg(rokMsg, res && res.enabled
        ? 'Saved. ONYX and Brendon refund exactly what you OK in writing, even with no recorded promise.'
        : 'Saved. A refund still needs a recorded customer promise as well as your OK.', 'success');
    } catch (e) {
      showMsg(rokMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      rokBtn.disabled = false;
      rokBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_REFUNDOKONLY_BY_CLAUDE */

/* CUSTOM_VENDORETAWATCH_BY_CLAUDE (ONYX c19949dd770b, Ryan 2026-10-08) - Admin: Late Supplier Watch. The switch and two dials
   over GET/POST /admin/vendor-eta-watch-config; "Show who it would chase today" is the dry run (GET /admin/vendor-eta-watch),
   which wakes nobody and writes nothing. Loaded from the server, never defaulted in the markup. */
var vewEnabled = document.getElementById('settings-vendoretawatch-enabled');
var vewAutoStage = document.getElementById('settings-vendoretawatch-autostage'); // CUSTOM_VEWAUTOSTAGE_BY_CLAUDE
var vewGrace = document.getElementById('settings-vendoretawatch-grace');
var vewWait = document.getElementById('settings-vendoretawatch-replywait');
var vewBtn = document.getElementById('settings-vendoretawatch-btn');
var vewDry = document.getElementById('settings-vendoretawatch-dry');
var vewMsg = document.getElementById('settings-vendoretawatch-msg');
var vewList = document.getElementById('settings-vendoretawatch-list');
function vewEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function vewApply(c) {
  if (!c) return;
  vewEnabled.checked = c.enabled === true;
  if (vewAutoStage) vewAutoStage.checked = c.autoStage === true; // CUSTOM_VEWAUTOSTAGE_BY_CLAUDE
  vewGrace.value = c.graceBusinessDays != null ? c.graceBusinessDays : '';
  vewWait.value = c.replyWaitWorkdays != null ? c.replyWaitWorkdays : '';
}
if (vewBtn && vewEnabled) {
  (async function loadVew() {
    try {
      var data = await window.RepPortal.API.get('/admin/vendor-eta-watch-config');
      vewApply(data && data.config);
    } catch (e) {
      showMsg(vewMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  vewBtn.addEventListener('click', async function() {
    hideMsg(vewMsg);
    vewBtn.disabled = true;
    var orig = vewBtn.textContent;
    vewBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/vendor-eta-watch-config', {
        enabled: !!vewEnabled.checked,
        ...(vewAutoStage ? { autoStage: !!vewAutoStage.checked } : {}), // CUSTOM_VEWAUTOSTAGE_BY_CLAUDE
        graceBusinessDays: parseInt(vewGrace.value, 10),
        replyWaitWorkdays: parseInt(vewWait.value, 10),
      });
      if (res && res.error) throw new Error(res.error);
      vewApply(res && res.config);
      showMsg(vewMsg, res && res.config && res.config.enabled
        ? (res.config.autoStage
          ? 'Saved - late suppliers are checked once a weekday at about 9 AM MT and the follow-up is staged as a [TEST] to you.'
          : 'Saved - late suppliers are checked once a weekday at about 9 AM MT and Onyx is woken to stage the follow-up.')
        : 'Saved - the watch is off; nobody is woken.', 'success');
    } catch (e) {
      showMsg(vewMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      vewBtn.disabled = false;
      vewBtn.textContent = orig;
    }
  });
  if (vewDry) vewDry.addEventListener('click', async function() {
    hideMsg(vewMsg);
    vewDry.disabled = true;
    vewList.innerHTML = 'Looking...';
    try {
      var data = await window.RepPortal.API.get('/admin/vendor-eta-watch');
      var run = (data && data.run) || {};
      var rows = run.rows || [];
      var ryan = run.ryanRows || [];
      if (!rows.length && !ryan.length) { vewList.innerHTML = 'Nobody is late today.'; return; }
      var html = '';
      if (rows.length) {
        /* CUSTOM_VEWAUTOSTAGE_BY_CLAUDE - each row says who stages it: the watch itself, or Onyx (and why). */
        var vewWhy = { 'switch-off': 'automatic staging is off', 'no-vendor-address': 'no supplier email on file', 'no-thread': 'no PO email on file' };
        html += '<strong>Would follow up with:</strong><ul style="margin: 4px 0 10px 18px;">' + rows.map(function(r) {
          var who = r.stage === 'silent' ? 'Onyx stages it' : r.onyxStages ? 'Onyx stages it: ' + (vewWhy[r.parkWhy] || 'could not stage it automatically') : 'staged as a [TEST] to you';
          return '<li>' + vewEsc(r.ref) + ' - ' + vewEsc(r.vendor) + ' (' + (r.stage === 'silent' ? 'no ship date, no tracking yet' : 'expected ' + vewEsc(r.etaWords || r.etaYmd) + ', ' + (r.stage === 'second' ? 'second follow-up' : 'first follow-up')) + '; ' + vewEsc(who) + ')</li>';
        }).join('') + '</ul>';
      }
      if (ryan.length) {
        html += '<strong>On your morning digest:</strong><ul style="margin: 4px 0 0 18px;">' + ryan.map(function(r) {
          return '<li>' + vewEsc(r.ref) + ' - ' + vewEsc(r.vendor) + ' (' + (r.why === 'not-sent' ? 'the follow-up never went out' : 'no answer to the follow-ups') + ')</li>';
        }).join('') + '</ul>';
      }
      vewList.innerHTML = html;
    } catch (e) {
      vewList.innerHTML = '';
      showMsg(vewMsg, 'Could not run the check: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      vewDry.disabled = false;
    }
  });
}
/* END CUSTOM_VENDORETAWATCH_BY_CLAUDE */

/* CUSTOM_REPLYTRACKER_BY_CLAUDE (ONYX b635ef2b9801, Ryan 2026-10-13) - Admin: Unanswered Email Tracker. The switch and two dials
   over GET/POST /admin/reply-tracker-config; "Show what's waiting now" is the dry run (GET /admin/reply-tracker), which wakes
   nobody and writes nothing. Loaded from the server, never defaulted in the markup. */
var rtEnabled = document.getElementById('settings-replytracker-enabled');
var rtWait = document.getElementById('settings-replytracker-wait');
var rtLookback = document.getElementById('settings-replytracker-lookback');
var rtBtn = document.getElementById('settings-replytracker-btn');
var rtDry = document.getElementById('settings-replytracker-dry');
var rtMsg = document.getElementById('settings-replytracker-msg');
var rtList = document.getElementById('settings-replytracker-list');
function rtEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function rtApply(c) {
  if (!c) return;
  rtEnabled.checked = c.enabled === true;
  rtWait.value = c.waitDays != null ? c.waitDays : '';
  rtLookback.value = c.lookbackDays != null ? c.lookbackDays : '';
}
if (rtBtn && rtEnabled) {
  (async function loadRt() {
    try {
      var data = await window.RepPortal.API.get('/admin/reply-tracker-config');
      rtApply(data && data.config);
    } catch (e) {
      showMsg(rtMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  rtBtn.addEventListener('click', async function() {
    hideMsg(rtMsg);
    rtBtn.disabled = true;
    var orig = rtBtn.textContent;
    rtBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/reply-tracker-config', {
        enabled: !!rtEnabled.checked,
        waitDays: parseInt(rtWait.value, 10),
        lookbackDays: parseInt(rtLookback.value, 10),
      });
      if (res && res.error) throw new Error(res.error);
      rtApply(res && res.config);
      showMsg(rtMsg, res && res.config && res.config.enabled
        ? 'Saved - Onyx is told about unanswered emails once a day at about 8:40 AM MT.'
        : 'Saved - the tracker is off; nobody is woken.', 'success');
    } catch (e) {
      showMsg(rtMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      rtBtn.disabled = false;
      rtBtn.textContent = orig;
    }
  });
  if (rtDry) rtDry.addEventListener('click', async function() {
    hideMsg(rtMsg);
    rtDry.disabled = true;
    rtList.innerHTML = 'Looking...';
    try {
      var data = await window.RepPortal.API.get('/admin/reply-tracker');
      var run = (data && data.run) || {};
      if (run.skipped) { rtList.innerHTML = 'Could not check: ' + rtEsc(run.why); return; }
      var rows = run.rows || [];
      var c = run.counts || {};
      var head = 'Watching ' + (c.tracked || 0) + ' thread(s): ' + (c.notYet || 0) + ' not due yet, ' + (c.pinged || 0) + ' already listed this week, ' + (c.answered || 0) + ' answered.';
      if (!rows.length) { rtList.innerHTML = rtEsc(head) + '<br>Nothing would be listed this morning.'; return; }
      rtList.innerHTML = rtEsc(head) + '<br><strong>Onyx would list:</strong><ul style="margin: 4px 0 0 18px;">' + rows.map(function(r) {
        var who = (r.owedBy || []).map(function(p) { return p.name || p.email; }).join(', ');
        return '<li>' + rtEsc(r.subject || '(no subject)') + ' - waiting on ' + rtEsc(who) + ', ' + rtEsc(r.daysWaiting) + ' days' + (r.ask ? ' - ' + rtEsc(r.ask) : '') + '</li>';
      }).join('') + '</ul>';
    } catch (e) {
      rtList.innerHTML = '';
      showMsg(rtMsg, 'Could not run the check: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      rtDry.disabled = false;
    }
  });
}
/* END CUSTOM_REPLYTRACKER_BY_CLAUDE */



/* CUSTOM_ETANOTICE_BY_CLAUDE (AIOPS 29cf53be2a91 + 1ffd4cd57138 + 6aebd94cc2ae, Ryan 2026-09-17)
   Admin: Customer ETA Updates. Two switches over GET/POST /admin/eta-notice-config, which answers
   the config flat ({enabled, weekly}).
   ⛔ EACH BUTTON POSTS ITS OWN FIELD ALONE. The route treats an omitted field as "keep what is
   stored", so two buttons on one record cannot clobber each other — the rule the offline-freight
   panel above had to learn after one shared Save cleared the wrong switch. Loaded from the server,
   never defaulted in the markup. */
var etaEnabled = document.getElementById('settings-etanotice-enabled');
var etaBtn = document.getElementById('settings-etanotice-btn');
var etaMsg = document.getElementById('settings-etanotice-msg');
var etaWeekly = document.getElementById('settings-etanotice-weekly');
var etaWeeklyBtn = document.getElementById('settings-etanotice-weekly-btn');
var etaWeeklyMsg = document.getElementById('settings-etanotice-weekly-msg');
/* CUSTOM_ETATESTFIRST_BY_CLAUDE (ONYX c672522c50aa, Ryan 2026-09-28) - TEST first: loaded off the same GET
   (an absent value arrives as true, the worker's reading), saved by its own button posting only this field. */
var etaTestFirst = document.getElementById('settings-etanotice-testfirst');
var etaTestFirstBtn = document.getElementById('settings-etanotice-testfirst-btn');
var etaTestFirstMsg = document.getElementById('settings-etanotice-testfirst-msg');
/* CUSTOM_ETAQUIET_BY_CLAUDE (AIOPS 98180d1f9ac9 + 7b71b643f475, Ryan 2026-09-21) - the three day dials.
   Loaded off the SAME GET as the switches (one read); saved by their own button posting only the three
   fields, the rule the two switches already follow. */
var etaQuiet = document.getElementById('settings-etanotice-quiet');
var etaInStock = document.getElementById('settings-etanotice-instock'); // CUSTOM_ETAINSTOCK_BY_CLAUDE (Ryan 2026-10-29)
var etaCatchUp = document.getElementById('settings-etanotice-catchup');
var etaConvo = document.getElementById('settings-etanotice-convo');
var etaQuietBtn = document.getElementById('settings-etanotice-quiet-btn');
var etaQuietMsg = document.getElementById('settings-etanotice-quiet-msg');
/* CUSTOM_ETASLIP_BY_CLAUDE (AIOPS 145b6d55311e, Ryan 2026-09-28) - the two date-move dials, off the same GET,
   saved by their own button posting only these two fields. */
var etaSlipQuiet = document.getElementById('settings-etanotice-slipquiet');
var etaSlipLight = document.getElementById('settings-etanotice-sliplight');
var etaSlipBtn = document.getElementById('settings-etanotice-slip-btn');
var etaSlipMsg = document.getElementById('settings-etanotice-slip-msg');
/* CUSTOM_ETACADENCE_BY_CLAUDE (ONYX e950ab3676b4, Ryan 2026-09-26) - the "still on track" reminder:
   its switch and three gaps, off the same GET, saved by their own button posting only those four fields. */
var etaRem = document.getElementById('settings-etanotice-reminders');
var etaRemFar = document.getElementById('settings-etanotice-rfar');
/* CUSTOM_ETASPACING_BY_CLAUDE (ONYX 439128b68f8a, Ryan 2026-10-12) - the late-email window, the recent-email rule, the change-now line. */
var etaRemLo = document.getElementById('settings-etanotice-flo');
var etaRemHi = document.getElementById('settings-etanotice-fhi');
var etaRemRecent = document.getElementById('settings-etanotice-frecent');
var etaRemNow = document.getElementById('settings-etanotice-changenow');
var etaRemBtn = document.getElementById('settings-etanotice-reminders-btn');
var etaRemMsg = document.getElementById('settings-etanotice-reminders-msg');
function etaApplyReminders(data) {
  if (!data) return;
  if (etaRem) etaRem.checked = data.reminders === true;
  if (etaRemFar) etaRemFar.value = (data.reminderFarDays == null ? 14 : data.reminderFarDays);
  if (etaRemLo) etaRemLo.value = (data.finalWindowMinDays == null ? 4 : data.finalWindowMinDays);
  if (etaRemHi) etaRemHi.value = (data.finalWindowMaxDays == null ? 10 : data.finalWindowMaxDays);
  if (etaRemRecent) etaRemRecent.value = (data.finalRecentDays == null ? 5 : data.finalRecentDays);
  if (etaRemNow) etaRemNow.value = (data.changeNowDays == null ? 7 : data.changeNowDays);
}
function etaApplyDials(data) {
  if (!data) return;
  etaApplyReminders(data);
  if (etaInStock) etaInStock.value = (data.inStockQuietBusinessDays == null ? 7 : data.inStockQuietBusinessDays); // CUSTOM_ETAINSTOCK_BY_CLAUDE
  if (etaQuiet) etaQuiet.value = (data.customWithinBusinessDays == null ? 3 : data.customWithinBusinessDays); // CUSTOM_ETACLOSEFIRST_BY_CLAUDE (ONYX cd5fd26cbf77) - business days, replaces the 7-day silence
  if (etaCatchUp) etaCatchUp.value = (data.catchUpWithinDays == null ? 21 : data.catchUpWithinDays);
  if (etaConvo) etaConvo.value = (data.conversationQuietDays == null ? 7 : data.conversationQuietDays);
  if (etaSlipQuiet) etaSlipQuiet.value = (data.slipQuietDays == null ? 2 : data.slipQuietDays);
  if (etaSlipLight) etaSlipLight.value = (data.lightSlipDays == null ? 4 : data.lightSlipDays);
}
if (etaSlipBtn && etaSlipQuiet && etaSlipLight) {
  etaSlipBtn.addEventListener('click', async function() {
    hideMsg(etaSlipMsg);
    var q = parseInt(etaSlipQuiet.value, 10);
    var l = parseInt(etaSlipLight.value, 10);
    if (!isFinite(q) || q < 0 || q > 30) { showMsg(etaSlipMsg, 'Say nothing up to is a whole number of days from 0 to 30 (0 switches it off).', 'error'); return; }
    if (!isFinite(l) || l < 0 || l > 30) { showMsg(etaSlipMsg, 'Lighter wording up to is a whole number of days from 0 to 30 (0 switches it off).', 'error'); return; }
    etaSlipBtn.disabled = true;
    var orig = etaSlipBtn.textContent;
    etaSlipBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/eta-notice-config', { slipQuietDays: q, lightSlipDays: l });
      if (res && res.error) throw new Error(res.error);
      etaApplyDials(res);
      showMsg(etaSlipMsg, 'Saved - ' + (res.slipQuietDays ? 'a move of up to ' + res.slipQuietDays + ' day(s) says nothing' : 'every move is sent')
        + (res.lightSlipDays > res.slipQuietDays ? ', up to ' + res.lightSlipDays + ' day(s) gets the lighter wording' : '') + '.', 'success');
    } catch (e) {
      showMsg(etaSlipMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      etaSlipBtn.disabled = false;
      etaSlipBtn.textContent = orig;
    }
  });
}
if (etaBtn && etaEnabled) {
  (async function loadEta() {
    try {
      var data = await window.RepPortal.API.get('/admin/eta-notice-config');
      etaEnabled.checked = !!(data && data.enabled === true);
      if (etaWeekly) etaWeekly.checked = !!(data && data.weekly === true);
      if (etaTestFirst) etaTestFirst.checked = !(data && data.testFirst === false);
      etaApplyDials(data);
    } catch (e) {
      showMsg(etaMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  etaBtn.addEventListener('click', async function() {
    hideMsg(etaMsg);
    etaBtn.disabled = true;
    var orig = etaBtn.textContent;
    etaBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/eta-notice-config', { enabled: !!etaEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      etaEnabled.checked = !!(res && res.enabled === true);
      showMsg(etaMsg, res && res.enabled
        ? 'Saved - saving a ready-by puts an ETA update on Approvals. It still waits for you to Release it.'
        : 'Saved - saving a ready-by tells the customer nothing.', 'success');
    } catch (e) {
      showMsg(etaMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      etaBtn.disabled = false;
      etaBtn.textContent = orig;
    }
  });
}
if (etaWeeklyBtn && etaWeekly) {
  etaWeeklyBtn.addEventListener('click', async function() {
    hideMsg(etaWeeklyMsg);
    etaWeeklyBtn.disabled = true;
    var orig = etaWeeklyBtn.textContent;
    etaWeeklyBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/eta-notice-config', { weekly: !!etaWeekly.checked });
      if (res && res.error) throw new Error(res.error);
      etaWeekly.checked = !!(res && res.weekly === true);
      showMsg(etaWeeklyMsg, res && res.weekly
        ? 'Saved - the Monday sweep queues held updates for anyone who has not been told their current date.'
        : 'Saved - no Monday sweep; only a saved ready-by queues anything.', 'success');
    } catch (e) {
      showMsg(etaWeeklyMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      etaWeeklyBtn.disabled = false;
      etaWeeklyBtn.textContent = orig;
    }
  });
}
if (etaTestFirstBtn && etaTestFirst) {
  etaTestFirstBtn.addEventListener('click', async function() {
    hideMsg(etaTestFirstMsg);
    etaTestFirstBtn.disabled = true;
    var orig = etaTestFirstBtn.textContent;
    etaTestFirstBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/eta-notice-config', { testFirst: !!etaTestFirst.checked });
      if (res && res.error) throw new Error(res.error);
      etaTestFirst.checked = !(res && res.testFirst === false);
      showMsg(etaTestFirstMsg, etaTestFirst.checked
        ? 'Saved - every queued ETA update also emails you a [TEST], and agents wait for your approval.'
        : 'Saved - no more [TEST] copies; queued updates follow the normal Approvals rules.', 'success');
    } catch (e) {
      showMsg(etaTestFirstMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      etaTestFirstBtn.disabled = false;
      etaTestFirstBtn.textContent = orig;
    }
  });
}
/* CUSTOM_ETAREPCHECK_BY_CLAUDE (ONYX cdd46cd31578, Ryan 2026-10-12) - the deal-owner check on a long lead time. Loads and saves
   only its own field, so it cannot clobber the switches above. */
(function etaRepCheckPanel() {
  var box = document.getElementById('settings-etanotice-repcheck');
  var btn = document.getElementById('settings-etanotice-repcheck-btn');
  var msg = document.getElementById('settings-etanotice-repcheck-msg');
  var days = document.getElementById('settings-etanotice-repcheck-days');
  if (!box || !btn) return;
  (async function load() {
    try {
      var data = await window.RepPortal.API.get('/admin/eta-notice-config');
      box.checked = !!(data && data.repCheck === true);
      if (days) days.value = (data && data.repCheckMarginDays) || 14;
    } catch (e) { showMsg(msg, 'Could not load the current setting - reload before saving.', 'error'); }
  })();
  btn.addEventListener('click', async function() {
    hideMsg(msg);
    var d = days ? parseInt(days.value, 10) : 14;
    if (!isFinite(d) || d < 1 || d > 120) { showMsg(msg, 'Days past the usual lead time is a whole number from 1 to 120.', 'error'); return; }
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/eta-notice-config', { repCheck: !!box.checked, repCheckMarginDays: d });
      if (res && res.error) throw new Error(res.error);
      box.checked = !!(res && res.repCheck === true);
      if (days && res && res.repCheckMarginDays) days.value = res.repCheckMarginDays;
      showMsg(msg, box.checked
        ? 'Saved - a ship date more than ' + ((res && res.repCheckMarginDays) || d) + ' days past the usual lead time goes to the deal owner first.'
        : 'Saved - ETA updates go without asking the deal owner.', 'success');
    } catch (e) {
      showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      btn.disabled = false;
      btn.textContent = orig;
    }
  });
})();
if (etaQuietBtn && etaQuiet) {
  etaQuietBtn.addEventListener('click', async function() {
    hideMsg(etaQuietMsg);
    var q = parseInt(etaQuiet.value, 10);
    var c = parseInt(etaCatchUp.value, 10);
    var v = parseInt(etaConvo.value, 10);
    if (!isFinite(q) || q < 0 || q > 20) { showMsg(etaQuietMsg, 'Personal email within is a whole number of business days from 0 to 20 (0 switches it off).', 'error'); return; }
    var s = etaInStock ? parseInt(etaInStock.value, 10) : null; // CUSTOM_ETAINSTOCK_BY_CLAUDE
    if (etaInStock && (!isFinite(s) || s < 0 || s > 20)) { showMsg(etaQuietMsg, 'No email for in-stock orders is a whole number of business days from 0 to 20 (0 switches it off).', 'error'); return; }
    if (!isFinite(c) || c < 0 || c > 120) { showMsg(etaQuietMsg, 'Catch-up wording is a whole number of days from 0 to 120 (0 switches it off).', 'error'); return; }
    if (!isFinite(v) || v < 0 || v > 60) { showMsg(etaQuietMsg, 'Quiet after a conversation is a whole number of days from 0 to 60 (0 switches it off).', 'error'); return; }
    etaQuietBtn.disabled = true;
    var orig = etaQuietBtn.textContent;
    etaQuietBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/eta-notice-config', Object.assign({ customWithinBusinessDays: q, catchUpWithinDays: c, conversationQuietDays: v }, etaInStock ? { inStockQuietBusinessDays: s } : {}));
      if (res && res.error) throw new Error(res.error);
      etaApplyDials(res);
      showMsg(etaQuietMsg, 'Saved - ' + (res.inStockQuietBusinessDays ? 'an in-stock order shipping within ' + res.inStockQuietBusinessDays + ' business day(s) gets no ship-date email (the tracking email says it); ' : '')
        + 'a first update within ' + res.customWithinBusinessDays + ' business day(s) of the ready date is a personal email from Onyx, not the standard one'
        + (res.catchUpWithinDays ? ', uses the catch-up wording out to ' + res.catchUpWithinDays + ' days' : '')
        + (res.conversationQuietDays ? ', and the automatic doors stay quiet for ' + res.conversationQuietDays + ' days after the customer was in conversation' : '') + '.', 'success');
    } catch (e) {
      showMsg(etaQuietMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      etaQuietBtn.disabled = false;
      etaQuietBtn.textContent = orig;
    }
  });
}
if (etaRemBtn && etaRem) {
  etaRemBtn.addEventListener('click', async function() {
    hideMsg(etaRemMsg);
    var f = parseInt(etaRemFar.value, 10);
    var lo = parseInt(etaRemLo.value, 10);
    var hi = parseInt(etaRemHi.value, 10);
    var rc = parseInt(etaRemRecent.value, 10);
    var cn = parseInt(etaRemNow.value, 10);
    if (!isFinite(f) || f < 1 || f > 60) { showMsg(etaRemMsg, 'Middle email: a whole number of days from 1 to 60.', 'error'); return; }
    if (!isFinite(lo) || lo < 1 || lo > 30) { showMsg(etaRemMsg, 'Late email from: a whole number of days from 1 to 30.', 'error'); return; }
    if (!isFinite(hi) || hi < 1 || hi > 60) { showMsg(etaRemMsg, 'Late email to: a whole number of days from 1 to 60.', 'error'); return; }
    if (lo > hi) { showMsg(etaRemMsg, 'The late email\'s "from" must not be more than its "to".', 'error'); return; }
    if (!isFinite(rc) || rc < 0 || rc > 30) { showMsg(etaRemMsg, 'Skip the late email if we emailed within: 0 to 30 days.', 'error'); return; }
    if (!isFinite(cn) || cn < 0 || cn > 60) { showMsg(etaRemMsg, 'A date move goes at once at: 0 to 60 days (0 = every move goes at once).', 'error'); return; }
    etaRemBtn.disabled = true;
    var orig = etaRemBtn.textContent;
    etaRemBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/eta-notice-config', { reminders: !!etaRem.checked, reminderFarDays: f, finalWindowMinDays: lo, finalWindowMaxDays: hi, finalRecentDays: rc, changeNowDays: cn });
      if (res && res.error) throw new Error(res.error);
      etaApplyReminders(res);
      showMsg(etaRemMsg, res && res.reminders
        ? 'Saved - a middle email ' + res.reminderFarDays + ' days after the customer was last told a date, one late email ' + res.finalWindowMinDays + ' to ' + res.finalWindowMaxDays + ' days before it ships (skipped if we emailed in the last ' + res.finalRecentDays + '), and a date move of ' + res.changeNowDays + '+ days goes at once.'
        : 'Saved - no reminders; a customer hears again only when a date changes.', 'success');
    } catch (e) {
      showMsg(etaRemMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      etaRemBtn.disabled = false;
      etaRemBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_ETANOTICE_BY_CLAUDE */

/* CUSTOM_SETTLEMODE_BY_CLAUDE (AIOPS 5a641bed323b, Ryan 2026-09-14) — the charge-the-card-on-file
   supplier list, over GET/POST /admin/supplier-pay-config.
   ⚠️ IT POSTS THE WHOLE LIST IT SHOWS and re-reads the answer, the po-send-allowlist panel's rule:
   the server is the one that decides what was stored, and a box still showing what you typed after
   a refusal is a box that lies. An EMPTY box is a real answer (nobody settles automatically) and is
   posted as an empty array, never omitted — omitting it means "keep what is stored". */

/* CUSTOM_PAYRECEIVED_BY_CLAUDE (AIOPS 52bc9f26f198, Ryan 2026-09-25) — the payment-received reply
   switch over GET/POST /admin/payment-received-reply-config. Reads back what the server stored. */
var payrcvBox = document.getElementById('settings-payreceived-enabled');
var payrcvBtn = document.getElementById('settings-payreceived-btn');
var payrcvMsg = document.getElementById('settings-payreceived-msg');
/* CUSTOM_PAYRECEIVEDAUTO_BY_CLAUDE (ONYX 8308f41b3b54) — autoStage, posted with enabled. Only once it has loaded from the
   server: before that it is omitted, which the server reads as "keep what is stored". */
var payrcvAuto = document.getElementById('settings-payreceived-autostage');
var payrcvAutoLoaded = false;
if (payrcvBox && payrcvBtn) {
  (async function loadPayrcv() {
    try {
      var d = await window.RepPortal.API.get('/admin/payment-received-reply-config');
      payrcvBox.checked = !!(d && d.config && d.config.enabled === true);
      if (payrcvAuto) { payrcvAuto.checked = !!(d && d.config && d.config.autoStage === true); payrcvAutoLoaded = true; }
    } catch (e) {
      showMsg(payrcvMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  payrcvBtn.addEventListener('click', async function() {
    hideMsg(payrcvMsg);
    payrcvBtn.disabled = true;
    var orig = payrcvBtn.textContent;
    payrcvBtn.textContent = 'Saving...';
    try {
      var payload = { enabled: !!payrcvBox.checked };
      if (payrcvAuto && payrcvAutoLoaded) payload.autoStage = !!payrcvAuto.checked;
      var res = await window.RepPortal.API.post('/admin/payment-received-reply-config', payload);
      if (res && res.error) throw new Error(res.error);
      var on = !!(res && res.config && res.config.enabled === true);
      var auto = !!(res && res.config && res.config.autoStage === true);
      payrcvBox.checked = on;
      if (payrcvAuto) { payrcvAuto.checked = auto; payrcvAutoLoaded = true; }
      showMsg(payrcvMsg, on
        ? (auto
          ? 'Saved - on, staged automatically. The next paid pay-link puts a [TEST] of the reply in your inbox by itself; it reaches the customer when you reply Send.'
          : 'Saved - on. The next paid pay-link asks the Order Desk for a [TEST] of the reply; it reaches the customer when you reply Send.')
        : 'Saved - off. Nothing is sent to the customer when a pay-link is paid.', 'success');
    } catch (e) {
      showMsg(payrcvMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      payrcvBtn.disabled = false;
      payrcvBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_PAYRECEIVED_BY_CLAUDE */

/* CUSTOM_PORESENDRELEASE_BY_CLAUDE (ONYX e631f6c6c37e, 2026-10-28) — the PO re-send release switch over
   GET/POST /admin/po-resend-release-config. Reads back what the server stored. */
var poresendBox = document.getElementById('settings-poresend-enabled');
var poresendBtn = document.getElementById('settings-poresend-btn');
var poresendMsg = document.getElementById('settings-poresend-msg');
if (poresendBox && poresendBtn) {
  (async function loadPoresend() {
    try {
      var d = await window.RepPortal.API.get('/admin/po-resend-release-config');
      poresendBox.checked = !!(d && d.config && d.config.enabled === true);
    } catch (e) {
      showMsg(poresendMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  poresendBtn.addEventListener('click', async function() {
    hideMsg(poresendMsg);
    poresendBtn.disabled = true;
    var orig = poresendBtn.textContent;
    poresendBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/po-resend-release-config', { enabled: !!poresendBox.checked });
      if (res && res.error) throw new Error(res.error);
      var on = !!(res && res.config && res.config.enabled === true);
      poresendBox.checked = on;
      showMsg(poresendMsg, on
        ? 'Saved - on. Your Send on a PO re-send [TEST] now re-sends the PO to the supplier.'
        : 'Saved - off. A re-send TEST cannot be staged; use Re-send on the Deal Dashboard.', 'success');
    } catch (e) {
      showMsg(poresendMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      poresendBtn.disabled = false;
      poresendBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_PORESENDRELEASE_BY_CLAUDE */

/* CUSTOM_GDPROMOSTART_BY_CLAUDE (ALFRED 3bbda738c5d5, 2026-10-28) — the Golden Designs promo start-date switch over
   GET/POST /admin/golden-designs-promo-config. Reads back what the server stored. */
var gdstartBox = document.getElementById('settings-gdpromostart-enabled');
var gdstartBtn = document.getElementById('settings-gdpromostart-btn');
var gdstartMsg = document.getElementById('settings-gdpromostart-msg');
if (gdstartBox && gdstartBtn) {
  (async function loadGdstart() {
    try {
      var d = await window.RepPortal.API.get('/admin/golden-designs-promo-config');
      gdstartBox.checked = !!(d && d.config && d.config.applyOnStart === true);
    } catch (e) {
      showMsg(gdstartMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  gdstartBtn.addEventListener('click', async function() {
    hideMsg(gdstartMsg);
    gdstartBtn.disabled = true;
    var orig = gdstartBtn.textContent;
    gdstartBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/golden-designs-promo-config', { applyOnStart: !!gdstartBox.checked });
      if (res && res.error) throw new Error(res.error);
      var on = !!(res && res.config && res.config.applyOnStart === true);
      gdstartBox.checked = on;
      showMsg(gdstartMsg, on
        ? 'Saved - on. An upcoming Golden Designs promo now goes live on its start date.'
        : 'Saved - off. An upcoming promo goes live at the first sheet sync on or after its start date.', 'success');
    } catch (e) {
      showMsg(gdstartMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      gdstartBtn.disabled = false;
      gdstartBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_GDPROMOSTART_BY_CLAUDE */
/* CUSTOM_GDSHEETREAD_BY_CLAUDE (Ryan 2026-11-02) — the Golden Designs price list upload over
   GET/POST /golden-designs-promo/price-list. Check = preview (stores nothing); Save = the same file with apply. */
var gdplFile = document.getElementById('settings-gdpricelist-file');
var gdplCheck = document.getElementById('settings-gdpricelist-check');
var gdplSave = document.getElementById('settings-gdpricelist-save');
var gdplOut = document.getElementById('settings-gdpricelist-result');
var gdplMsg = document.getElementById('settings-gdpricelist-msg');
var gdplCur = document.getElementById('settings-gdpricelist-current');
if (gdplFile && gdplCheck && gdplSave) {
  var gdplChecked = null; // {name, base64} of the file last checked
  var gdplMoney = function(n) { return n == null ? '-' : '$' + Number(n).toLocaleString('en-US'); };
  var gdplLoad = async function() {
    try {
      var d = await window.RepPortal.API.get('/golden-designs-promo/price-list');
      var pl = d && d.priceList;
      gdplCur.textContent = pl
        ? 'On file: ' + pl.fileName + ', ' + pl.count + ' models, saved ' + String(pl.uploadedAt || '').slice(0, 10) + (pl.by ? ' by ' + pl.by : '') + '.'
        : 'No price list on file yet: the promo sync uses the promo sheet\'s own regular columns until one is saved.';
    } catch (e) {
      gdplCur.textContent = 'Could not load the list on file.';
    }
  };
  gdplLoad();
  var gdplRead = function(file) {
    return new Promise(function(resolve, reject) {
      var r = new FileReader();
      r.onload = function() { resolve(String(r.result || '').replace(/^data:[^,]*,/, '')); };
      r.onerror = function() { reject(new Error('the file could not be read')); };
      r.readAsDataURL(file);
    });
  };
  var gdplShow = function(res, saved) {
    var lines = [];
    lines.push((saved ? 'Saved: ' : 'Read: ') + res.count + ' models from ' + (res.source && res.source.fileName) + '.');
    if (res.source && res.source.columns) {
      lines.push('Columns: ' + Object.keys(res.source.columns).map(function(k) { return k + ' ' + res.source.columns[k]; }).join(', ') + '.');
    }
    lines.push(res.added + ' new, ' + (res.changed || []).length + ' changed, ' + (res.removed || []).length + ' no longer on the list.');
    (res.changed || []).slice(0, 40).forEach(function(c) {
      lines.push('  ' + c.model + ': cost ' + gdplMoney(c.before.cost) + ' -> ' + gdplMoney(c.after.cost) + ', MAP ' + gdplMoney(c.before.map) + ' -> ' + gdplMoney(c.after.map) + ', MSRP ' + gdplMoney(c.before.msrp) + ' -> ' + gdplMoney(c.after.msrp));
    });
    if ((res.conflicts || []).length) {
      lines.push('Listed twice with different prices, so left OFF the list (fix the spreadsheet and upload again):');
      res.conflicts.forEach(function(c) { lines.push('  ' + c.model + ': ' + c.lines.map(function(l) { return 'line ' + l.line + ' ' + gdplMoney(l.cost) + ' / ' + gdplMoney(l.map); }).join(' and ')); });
    }
    if ((res.skipped || []).length) {
      lines.push('Lines with no price, not read:');
      res.skipped.forEach(function(s) { lines.push('  line ' + s.line + ' ' + s.model + ': ' + s.why); });
    }
    gdplOut.textContent = lines.join('\n');
  };
  var gdplSend = async function(apply) {
    hideMsg(gdplMsg);
    var btn = apply ? gdplSave : gdplCheck;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = apply ? 'Saving...' : 'Checking...';
    try {
      if (!apply) {
        var f = gdplFile.files && gdplFile.files[0];
        if (!f) throw new Error('choose the price list spreadsheet first');
        gdplChecked = { name: f.name, base64: await gdplRead(f) };
      }
      var res = await window.RepPortal.API.post('/golden-designs-promo/price-list', { file: gdplChecked, apply: !!apply });
      gdplShow(res, !!apply);
      if (apply) {
        gdplChecked = null;
        gdplSave.disabled = true;
        showMsg(gdplMsg, 'Saved. The next Golden Designs promo sync uses these regular prices.', 'success');
        gdplLoad();
      } else {
        gdplSave.disabled = false;
      }
    } catch (e) {
      var d = e && e.data;
      gdplOut.textContent = d && d.problems ? 'Not read: ' + d.problems.join('; ') : '';
      showMsg(gdplMsg, (apply ? 'Not saved: ' : 'Could not check: ') + (e && e.message ? e.message : 'unknown error'), 'error');
      gdplSave.disabled = true;
    } finally {
      btn.disabled = apply ? true : false;
      if (!apply) gdplCheck.disabled = false;
      btn.textContent = orig;
    }
  };
  gdplFile.addEventListener('change', function() { gdplChecked = null; gdplSave.disabled = true; gdplOut.textContent = ''; hideMsg(gdplMsg); });
  gdplCheck.addEventListener('click', function() { gdplSend(false); });
  gdplSave.addEventListener('click', function() { if (gdplChecked) gdplSend(true); });
}
/* END CUSTOM_GDSHEETREAD_BY_CLAUDE */
/* END CUSTOM_SETTLEMODE_BY_CLAUDE */

/* CUSTOM_LINECOSTQUOTE_BY_CLAUDE (ONYX 125cb92ca300, Ryan 2026-10-01) + CUSTOM_PRODUCTRULES_BY_CLAUDE
   (Ryan 2026-10-09, Product Rules Session 4) — the percentage only, over GET/POST /admin/line-cost-config. The
   estimate-cost supplier list (and the card-on-file list above it) are retired: each supplier's answer is its
   Vendor Guide record. The page re-reads what the server stored; a failed load says so and saves nothing. */
var lcstPct = document.getElementById('settings-linecost-pct');
var lcstBtn = document.getElementById('settings-linecost-btn');
var lcstMsg = document.getElementById('settings-linecost-msg');
var lcstReady = false;
if (lcstBtn && lcstPct) {
  (async function loadLcst() {
    try {
      var cfg = await window.RepPortal.API.get('/admin/line-cost-config');
      if (!cfg || !cfg.config) throw new Error((cfg && cfg.error) || 'no answer');
      lcstPct.value = cfg.config.marginFlagPct || 15;
      lcstReady = true;
    } catch (e) {
      showMsg(lcstMsg, 'Could not load the current percentage - reload before saving.', 'error');
    }
  })();
  lcstBtn.addEventListener('click', async function() {
    hideMsg(lcstMsg);
    if (!lcstReady) { showMsg(lcstMsg, 'The current percentage did not load, so nothing was saved. Reload and try again.', 'error'); return; }
    lcstBtn.disabled = true;
    var orig = lcstBtn.textContent;
    lcstBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/line-cost-config', { marginFlagPct: Number(lcstPct.value) });
      if (res && res.error) throw new Error(res.error);
      lcstPct.value = res.config.marginFlagPct;
      showMsg(lcstMsg, 'Saved - you get an email when a quoted cost comes in more than ' + res.config.marginFlagPct + '% over the estimate.', 'success');
    } catch (e) {
      showMsg(lcstMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      lcstBtn.disabled = false;
      lcstBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_LINECOSTQUOTE_BY_CLAUDE */

/* CUSTOM_REVIEWSWITCHES_BY_CLAUDE (Ryan 2026-09-09 PM) — Admin: Review Engine. Three switches,
   three saves. The first two are rfq-worker admin routes (RepPortal.API); the ladder lives on
   review-worker, reached with the same access token and a plain fetch, because the API helper
   is bound to rfq-worker's base URL. Load-from-server rule as the panels above: nothing is
   defaulted in the markup, and a failed load says so and leaves the box untouched. */
var rvckEnabled = document.getElementById('settings-rvck-enabled');
var rvckWindow = document.getElementById('settings-rvck-window');
var rvckNudge = document.getElementById('settings-rvck-nudge');
var rvckTransit = document.getElementById('settings-rvck-transit');
var rvckInstall = document.getElementById('settings-rvck-install'); // CUSTOM_REVIEWDELIVERY_BY_CLAUDE (ONYX ceac255ae3f1)
var rvckMaxDays = document.getElementById('settings-rvck-maxdays');
var rvckBtn = document.getElementById('settings-rvck-btn');
var rvckMsg = document.getElementById('settings-rvck-msg');
var rvcgEnabled = document.getElementById('settings-rvcg-enabled');
var rvcgBtn = document.getElementById('settings-rvcg-btn');
var rvcgMsg = document.getElementById('settings-rvcg-msg');
var rvldEnabled = document.getElementById('settings-rvld-enabled');
var rvldBtn = document.getElementById('settings-rvld-btn');
var rvldMsg = document.getElementById('settings-rvld-msg');
var REVIEW_WORKER_BASE = 'https://review-worker.ryan-29b.workers.dev';

async function rvReviewWorker(method, body) {
  var token = await window.RepPortal.Auth.getAccessToken();
  var r = await fetch(REVIEW_WORKER_BASE + '/admin/reviews/abby-settings', {
    method: method,
    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  var d = await r.json().catch(function() { return {}; });
  if (!r.ok) throw new Error(d.error || ('HTTP ' + r.status));
  return d;
}

if (rvckBtn && rvckEnabled) {
  (async function loadRvck() {
    try {
      var data = await window.RepPortal.API.get('/admin/review-checkin-config');
      var cfg = (data && data.config) || {};
      rvckEnabled.checked = cfg.enabled === true;
      rvckWindow.value = cfg.windowWorkdays;
      rvckNudge.value = cfg.nudgeWorkday;
      rvckTransit.value = cfg.transitDays;
      if (rvckInstall) rvckInstall.value = cfg.installWindowWorkdays;
      if (rvckMaxDays) rvckMaxDays.value = cfg.maxDaysAfterDelivery;
    } catch (e) {
      showMsg(rvckMsg, 'Could not load the check-in settings — reload before saving.', 'error');
    }
  })();
  rvckBtn.addEventListener('click', async function() {
    hideMsg(rvckMsg);
    var w = parseInt(rvckWindow.value, 10), n = parseInt(rvckNudge.value, 10), t = parseInt(rvckTransit.value, 10);
    if (!isFinite(w) || w < 1 || w > 15) { showMsg(rvckMsg, 'Ask after: a whole number of workdays from 1 to 15.', 'error'); return; }
    if (!isFinite(n) || n < 1 || n >= w) { showMsg(rvckMsg, 'Nudge on workday: from 1 up to one less than the ask day.', 'error'); return; }
    if (!isFinite(t) || t < 0 || t > 30) { showMsg(rvckMsg, 'Ask the owner after: 0 to 30 days.', 'error'); return; }
    var iw = rvckInstall ? parseInt(rvckInstall.value, 10) : NaN, md = rvckMaxDays ? parseInt(rvckMaxDays.value, 10) : NaN;
    if (rvckInstall && (!isFinite(iw) || iw < 1 || iw > 40)) { showMsg(rvckMsg, 'Install / flooring jobs: 1 to 40 workdays.', 'error'); return; }
    if (rvckMaxDays && (!isFinite(md) || md < 7 || md > 120)) { showMsg(rvckMsg, 'Skip if later than: 7 to 120 days.', 'error'); return; }
    rvckBtn.disabled = true; var orig = rvckBtn.textContent; rvckBtn.textContent = 'Saving...';
    try {
      var rvckBody = { enabled: !!rvckEnabled.checked, windowWorkdays: w, nudgeWorkday: n, transitDays: t };
      if (rvckInstall) rvckBody.installWindowWorkdays = iw;
      if (rvckMaxDays) rvckBody.maxDaysAfterDelivery = md;
      var res = await window.RepPortal.API.post('/admin/review-checkin-config', rvckBody);
      if (res && res.error) throw new Error(res.error);
      var c = (res && res.config) || {};
      rvckEnabled.checked = c.enabled === true;
      showMsg(rvckMsg, c.enabled
        ? 'Saved — the owner is emailed at delivery and the ask goes out ' + c.windowWorkdays + ' workdays after delivery (' + c.installWindowWorkdays + ' for an install job) unless they say no.'
        : 'Saved — the owner check-in is off; nothing is emailed and no ask goes out by default.', 'success');
    } catch (e) {
      showMsg(rvckMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rvckBtn.disabled = false; rvckBtn.textContent = orig; }
  });
}

if (rvcgBtn && rvcgEnabled) {
  (async function loadRvcg() {
    try {
      var data = await window.RepPortal.API.get('/admin/care-guide-config');
      rvcgEnabled.checked = !!(data && data.config && data.config.enabled === true);
    } catch (e) {
      showMsg(rvcgMsg, 'Could not load the care-guide setting — reload before saving.', 'error');
    }
  })();
  rvcgBtn.addEventListener('click', async function() {
    hideMsg(rvcgMsg);
    rvcgBtn.disabled = true; var orig = rvcgBtn.textContent; rvcgBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/care-guide-config', { enabled: !!rvcgEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      rvcgEnabled.checked = !!(res && res.config && res.config.enabled === true);
      showMsg(rvcgMsg, rvcgEnabled.checked
        ? 'Saved — E-Cleaner shipping notifications carry the care blurb and the PDF.'
        : 'Saved — tracking emails go bare; the guide can still be sent by hand from a deal.', 'success');
    } catch (e) {
      showMsg(rvcgMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rvcgBtn.disabled = false; rvcgBtn.textContent = orig; }
  });
}

/* CUSTOM_REVIEWREPLY_BY_CLAUDE (AIOPS 1816266b898f, Ryan 2026-09-10) — the automatic five-star thank-you
   on Google: the switch + the delay band on rfq-worker (/admin/review-reply-config), and six rendered
   samples of the phrase bank (/admin/review-reply-samples) so the words can be read before the flip. */
var rvarEnabled = document.getElementById('settings-rvar-enabled');
var rvarMin = document.getElementById('settings-rvar-min');
var rvarMax = document.getElementById('settings-rvar-max');
var rvarBtn = document.getElementById('settings-rvar-btn');
var rvarMsg = document.getElementById('settings-rvar-msg');
var rvarSamplesBtn = document.getElementById('settings-rvar-samples-btn');
var rvarSamples = document.getElementById('settings-rvar-samples');
if (rvarBtn && rvarEnabled) {
  (async function loadRvar() {
    try {
      var data = await window.RepPortal.API.get('/admin/review-reply-config');
      var cfg = (data && data.config) || {};
      rvarEnabled.checked = cfg.enabled === true;
      rvarMin.value = cfg.delayMinMinutes;
      rvarMax.value = cfg.delayMaxMinutes;
    } catch (e) {
      showMsg(rvarMsg, 'Could not load the thank-you setting — reload before saving.', 'error');
    }
  })();
  rvarBtn.addEventListener('click', async function() {
    hideMsg(rvarMsg);
    var lo = parseInt(rvarMin.value, 10), hi = parseInt(rvarMax.value, 10);
    if (!isFinite(lo) || lo < 5 || lo > 180) { showMsg(rvarMsg, 'No sooner than: a whole number of minutes from 5 to 180.', 'error'); return; }
    if (!isFinite(hi) || hi < lo || hi > 240) { showMsg(rvarMsg, 'No later than: from the lower bound up to 240 minutes.', 'error'); return; }
    rvarBtn.disabled = true; var orig = rvarBtn.textContent; rvarBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/review-reply-config', { enabled: !!rvarEnabled.checked, delayMinMinutes: lo, delayMaxMinutes: hi });
      if (res && res.error) throw new Error(res.error);
      var c = (res && res.config) || {};
      rvarEnabled.checked = c.enabled === true;
      rvarMin.value = c.delayMinMinutes; rvarMax.value = c.delayMaxMinutes;
      showMsg(rvarMsg, c.enabled
        ? 'Saved — five-star Google reviews matched to a deal get a thank-you on Google ' + c.delayMinMinutes + ' to ' + c.delayMaxMinutes + ' minutes after the match, in customer hours.'
        : 'Saved — nothing posts on Google by itself; anything already queued is dropped at its next check.', 'success');
    } catch (e) {
      showMsg(rvarMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rvarBtn.disabled = false; rvarBtn.textContent = orig; }
  });
  if (rvarSamplesBtn && rvarSamples) rvarSamplesBtn.addEventListener('click', async function() {
    rvarSamplesBtn.disabled = true; var o = rvarSamplesBtn.textContent; rvarSamplesBtn.textContent = 'Loading...';
    try {
      var d = await window.RepPortal.API.get('/admin/review-reply-samples?n=6&salt=' + Date.now().toString(36));
      var list = (d && d.samples) || [];
      if (!list.length) throw new Error((d && d.error) || 'no samples');
      rvarSamples.innerHTML = list.map(function(s) {
        return '<div style="margin: 0 0 10px; padding: 8px 10px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 6px;">'
          + '<div style="font-size: 11px; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 4px;">' + vslaEsc(s.reviewerName) + (s.ratingOnly ? ' · rating only' : ' · with text') + '</div>'
          + '<div style="white-space: pre-wrap; color: var(--rq-text, #e6e9f2);">' + vslaEsc(s.reply) + '</div></div>';
      }).join('');
      rvarSamples.style.display = '';
    } catch (e) {
      showMsg(rvarMsg, 'Could not load samples: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rvarSamplesBtn.disabled = false; rvarSamplesBtn.textContent = o; }
  });
}

if (rvldBtn && rvldEnabled) {
  (async function loadRvld() {
    try {
      var d = await rvReviewWorker('GET');
      rvldEnabled.checked = d.repQuoteFullLadder === true;
    } catch (e) {
      showMsg(rvldMsg, 'Could not load the ladder setting — reload before saving.', 'error');
    }
  })();
  rvldBtn.addEventListener('click', async function() {
    hideMsg(rvldMsg);
    rvldBtn.disabled = true; var orig = rvldBtn.textContent; rvldBtn.textContent = 'Saving...';
    try {
      var d = await rvReviewWorker('POST', { repQuoteFullLadder: !!rvldEnabled.checked });
      rvldEnabled.checked = d.repQuoteFullLadder === true;
      showMsg(rvldMsg, rvldEnabled.checked
        ? 'Saved — rep-built deals get the seven-day follow-up too.'
        : 'Saved — rep-built deals get the initial ask only.', 'success');
    } catch (e) {
      showMsg(rvldMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rvldBtn.disabled = false; rvldBtn.textContent = orig; }
  });
}
/* END CUSTOM_REVIEWSWITCHES_BY_CLAUDE */
/* CUSTOM_COLLECTDUEALERT_BY_CLAUDE (AIOPS 0a3725aa5757, Ryan 2026-09-11) — Admin: Balance Collect
   Alert. The switch, the noise dial, the last run, and a dry run that renders the exact email the
   9am tick would send. Nothing is defaulted in the markup; every value is loaded from the worker. */
var cdueEnabled = document.getElementById('settings-cdue-enabled');
var cdueDrip = document.getElementById('settings-cdue-drip');
var cdueMax = document.getElementById('settings-cdue-max');
var cdueQuiet = document.getElementById('settings-cdue-quiet');
var cdueBtn = document.getElementById('settings-cdue-btn');
var cduePreviewBtn = document.getElementById('settings-cdue-preview-btn');
var cduePreview = document.getElementById('settings-cdue-preview');
var cdueMsg = document.getElementById('settings-cdue-msg');
var cdueStatus = document.getElementById('settings-cdue-status');

function cdueRender(data) {
  if (!cdueStatus) return;
  var r = data && data.lastRun;
  if (!r) { cdueStatus.innerHTML = 'It has not run yet. It runs at 9am Mountain on business days; the first pass shows here.'; return; }
  var html = '<div>Ran <strong>' + vslaEsc(vslaWhen(r.at)) + '</strong>'
    + (r.enabled === false ? ' &mdash; <strong>switched off</strong>' : '') + ': '
    + vslaEsc(r.scanned) + ' order records read, <strong>' + vslaEsc(r.due) + ' due</strong>'
    + (r.hiddenDripOwned ? ', ' + vslaEsc(r.hiddenDripOwned) + ' left to Abby' : '')
    + (r.held ? ', ' + vslaEsc(r.held) + ' held because nothing changed' : '')
    + '.</div>';
  var sup = r.suppressed || {};
  var supBits = Object.keys(sup).map(function(k) { return vslaEsc(sup[k]) + ' ' + vslaEsc(k); });
  if (supBits.length) html += '<div style="margin-top: 6px;">Left out: ' + supBits.join(', ') + '.</div>';
  if (r.truncated) html += '<div style="margin-top: 6px; color:#f59e0b;">The walk hit its key cap, so not every order record was read.</div>';
  html += '<div style="margin-top: 6px;">' + (r.sent
    ? 'Emailed ' + vslaEsc(data.to || 'Ryan') + ': ' + vslaEsc(r.subject || '')
    : 'Sent nothing' + (r.why ? ' (' + vslaEsc(r.why) + ')' : '') + '.') + '</div>';
  if (r.rows && r.rows.length) {
    html += '<div style="margin-top: 6px;">' + r.rows.map(function(x) {
      return vslaEsc(x.ref) + ' (' + (x.amount != null ? '$' + Number(x.amount).toFixed(2) : 'figure unknown')
        + ', ' + vslaEsc(x.emails) + ' email(s)' + (x.askSource === 'stamp' ? ' on the old stamp' : '')
        + ', ' + vslaEsc(x.workdaysSinceLast) + ' workday(s)'
        + (x.callable ? ', call' : '') + (x.engaged ? ', customer engaged' : '')
        + ', ' + vslaEsc(x.nobodyChasing ? 'nobody chasing' : 'Abby has it') + ')';
    }).join('; ') + '</div>';
  }
  if (r.emailError) html += '<div style="margin-top: 6px; color:#f87171;"><strong>The email did not go: ' + vslaEsc(r.emailError) + '</strong> (nothing was stamped, so the next run tries again).</div>';
  if (r.error) html += '<div style="margin-top: 6px; color:#f87171;"><strong>Error: ' + vslaEsc(r.error) + '</strong></div>';
  cdueStatus.innerHTML = html;
}

if (cdueBtn && cdueEnabled) {
  (async function loadCdue() {
    try {
      var data = await window.RepPortal.API.get('/admin/collect-due-alert-config');
      var cfg = data.config || {};
      cdueEnabled.checked = cfg.enabled !== false;
      cdueDrip.checked = cfg.includeDripOwned !== false;
      cdueMax.value = cfg.maxRows;
      cdueQuiet.value = cfg.quietAfterReports;
      cdueRender(data);
    } catch (e) {
      showMsg(cdueMsg, 'Could not load the current alert rules — reload before saving.', 'error');
      if (cdueStatus) cdueStatus.textContent = 'Could not load the last run.';
    }
  })();

  cdueBtn.addEventListener('click', async function() {
    hideMsg(cdueMsg);
    var n = parseInt(cdueMax.value, 10);
    if (!isFinite(n) || n < 1 || n > 200) { showMsg(cdueMsg, 'Enter a whole number of rows from 1 to 200.', 'error'); return; }
    var q = parseInt(cdueQuiet.value, 10);
    if (!isFinite(q) || q < 0 || q > 20) { showMsg(cdueMsg, 'Enter a whole number of mornings from 0 to 20 (0 = never go quiet).', 'error'); return; }
    cdueBtn.disabled = true;
    var orig = cdueBtn.textContent;
    cdueBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/collect-due-alert-config', {
        enabled: !!cdueEnabled.checked, includeDripOwned: !!cdueDrip.checked, maxRows: n, quietAfterReports: q
      });
      var cfg = res.config || {};
      cdueEnabled.checked = cfg.enabled !== false;
      cdueDrip.checked = cfg.includeDripOwned !== false;
      cdueMax.value = cfg.maxRows;
      cdueQuiet.value = cfg.quietAfterReports;
      showMsg(cdueMsg, cfg.enabled === false
        ? 'Saved — the morning list is off. Abby keeps following up on her own clock.'
        : 'Saved — the morning list emails Ryan when a balance is due, and nothing when it is not.', 'success');
    } catch (e) {
      showMsg(cdueMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { cdueBtn.disabled = false; cdueBtn.textContent = orig; }
  });
}

/* The dry run. It reads, it renders, it sends NOTHING and stamps nothing — so pressing it at
   4pm shows exactly what tomorrow at 9am would say. */
if (cduePreviewBtn && cduePreview) {
  cduePreviewBtn.addEventListener('click', async function() {
    hideMsg(cdueMsg);
    cduePreviewBtn.disabled = true;
    var orig = cduePreviewBtn.textContent;
    cduePreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/collect-due-alert');
      var run = (d && d.run) || {};
      if (!d.previewHtml) {
        cduePreview.style.display = 'none';
        showMsg(cdueMsg, 'Nothing is due right now — ' + (run.scanned || 0) + ' order records read, no email would go out.', 'success');
      } else {
        cduePreview.innerHTML = '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 0 0 6px;">Subject: <strong>' + vslaEsc(run.subject || '') + '</strong></div>'
          + '<iframe title="Balance alert preview" style="width: 100%; height: 420px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.previewHtml) + '"></iframe>';
        cduePreview.style.display = '';
        showMsg(cdueMsg, run.why === 'already-reported-today'
          ? 'This is what would go out. Today\'s list has already been emailed, so the next send is tomorrow morning.'
          : 'This is what the 9am email would say. Nothing was sent.', 'success');
      }
      /* The "Last run" box keeps showing the last REAL run: a dry run sends nothing and must
         not overwrite the record of what the 9am tick actually did. */
      try { cdueRender(await window.RepPortal.API.get('/admin/collect-due-alert-config')); } catch (_) { /* the preview is the answer here */ }
    } catch (e) {
      showMsg(cdueMsg, 'Could not build the list: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { cduePreviewBtn.disabled = false; cduePreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_COLLECTDUEALERT_BY_CLAUDE */

/* CUSTOM_EMAILJUDGE_BY_CLAUDE (AIOPS 5e5c2834d9bf, Ryan 2026-10-02) - Admin: Email Judgments. The one
   model every Claude email judgment uses, and when they last worked. */
var ejudgeModel = document.getElementById('settings-ejudge-model');
var ejudgeBtn = document.getElementById('settings-ejudge-btn');
var ejudgeMsg = document.getElementById('settings-ejudge-msg');
var ejudgeStatus = document.getElementById('settings-ejudge-status');
function ejudgeEsc(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function ejudgeWhen(iso) { try { return new Date(iso).toLocaleString('en-US', { timeZone: 'America/Denver', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) + ' MT'; } catch (_) { return String(iso || ''); } }
function ejudgeRender(data) {
  if (!ejudgeModel) return;
  var models = (data && data.models) || [];
  var cur = data && data.config ? data.config.model : '';
  ejudgeModel.innerHTML = models.map(function(m) {
    return '<option value="' + ejudgeEsc(m.id) + '"' + (m.id === cur ? ' selected' : '') + '>' + ejudgeEsc(m.label) + '</option>';
  }).join('');
  if (!ejudgeStatus) return;
  var h = (data && data.health) || null;
  var html = '<div>In use: <strong>' + ejudgeEsc(cur) + '</strong>' + (data && data.stored ? '' : ' (the default; nothing saved yet)') + '.</div>';
  if (!h) html += '<div style="margin-top: 6px;">No calls recorded yet.</div>';
  else {
    if (h.lastOkAt) html += '<div style="margin-top: 6px;">Last worked ' + ejudgeEsc(ejudgeWhen(h.lastOkAt)) + (h.lastOkModel ? ' on ' + ejudgeEsc(h.lastOkModel) : '') + '.</div>';
    if (h.failingSince) html += '<div style="margin-top: 6px; color:#f87171;"><strong>Failing since ' + ejudgeEsc(ejudgeWhen(h.failingSince)) + '</strong> (' + ejudgeEsc(h.failures || 1) + ' failed calls on ' + ejudgeEsc(h.lastErrorModel || '?') + '): ' + ejudgeEsc(h.lastError || '') + '</div>';
    else if (h.lastErrorAt) html += '<div style="margin-top: 6px;">Last failure ' + ejudgeEsc(ejudgeWhen(h.lastErrorAt)) + ': ' + ejudgeEsc(h.lastError || '') + ' (it has worked since).</div>';
  }
  ejudgeStatus.innerHTML = html;
}
if (ejudgeBtn && ejudgeModel) {
  (async function loadEjudge() {
    try { ejudgeRender(await window.RepPortal.API.get('/admin/email-judge-config')); }
    catch (e) {
      showMsg(ejudgeMsg, 'Could not load the email judgment setting - reload before saving.', 'error');
      if (ejudgeStatus) ejudgeStatus.textContent = 'Could not load.';
    }
  })();
  ejudgeBtn.addEventListener('click', async function() {
    hideMsg(ejudgeMsg);
    ejudgeBtn.disabled = true;
    var orig = ejudgeBtn.textContent;
    ejudgeBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/email-judge-config', { model: ejudgeModel.value });
      if (res && res.error) throw new Error(res.error);
      ejudgeRender(res);
      showMsg(ejudgeMsg, 'Saved - every email judgment now uses ' + (res && res.config ? res.config.model : ejudgeModel.value) + '.', 'success');
    } catch (e) {
      showMsg(ejudgeMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { ejudgeBtn.disabled = false; ejudgeBtn.textContent = orig; }
  });
}
/* END CUSTOM_EMAILJUDGE_BY_CLAUDE */

/* CUSTOM_STUCKSENDWATCH_BY_CLAUDE (AIOPS 4b20ae84507c, Ryan 2026-09-11) - Admin: Stuck Send Watch.
   The switch, the two dials, the last run, and a dry run that shows what is queued right now. The
   dry run is FORCED, so pressing it at 10pm still answers rather than reading as "all clear". */
var stuckEnabled = document.getElementById('settings-stuck-enabled');
var stuckMinutes = document.getElementById('settings-stuck-minutes');
var stuckRepeat = document.getElementById('settings-stuck-repeat');
var stuckOrphans = document.getElementById('settings-stuck-orphans');
var stuckFreight = document.getElementById('settings-stuck-freight'); // CUSTOM_FREIGHTMISSWATCH_BY_CLAUDE (Ryan 2026-10-02)
var stuckJudge = document.getElementById('settings-stuck-judge'); // CUSTOM_EMAILJUDGE_BY_CLAUDE (Ryan 2026-10-02)
var stuckFacts = document.getElementById('settings-stuck-facts'); // CUSTOM_FACTCHECK_BY_CLAUDE (AIOPS c6470314f58c)
var stuckFactsStrict = document.getElementById('settings-stuck-facts-strict'); // CUSTOM_FACTCHECK_BY_CLAUDE - absent reads as off (watch)
var stuckBtn = document.getElementById('settings-stuck-btn');
var stuckPreviewBtn = document.getElementById('settings-stuck-preview-btn');
var stuckPreview = document.getElementById('settings-stuck-preview');
var stuckMsg = document.getElementById('settings-stuck-msg');
var stuckStatus = document.getElementById('settings-stuck-status');

function stuckRender(data) {
  if (!stuckStatus) return;
  var r = data && data.lastRun;
  if (!r) { stuckStatus.innerHTML = 'It has not run yet. It runs every fifteen minutes while the send window is open; the first pass shows here.'; return; }
  var html = '<div>Ran <strong>' + vslaEsc(vslaWhen(r.at)) + '</strong>'
    + (r.enabled === false ? ' &mdash; <strong>switched off</strong>' : '')
    + (r.windowOpen === false ? ' &mdash; the send window was shut, so nothing could be late' : '')
    + ': ' + vslaEsc(r.checked) + ' held email(s) read, <strong>' + vslaEsc((r.stuck || []).length) + ' stuck</strong>'
    + ((r.orphans || []).length ? ', ' + vslaEsc(r.orphans.length) + ' never sent' : '')
    + ((r.factMisses || []).length ? ', ' + vslaEsc(r.factMisses.length) + ' fact-check finding(s)' : '') // CUSTOM_FACTCHECK_BY_CLAUDE
    + (r.held ? ', ' + vslaEsc(r.held) + ' already reported' : '')
    + '.</div>';
  html += '<div style="margin-top: 6px;">' + (r.sent
    ? 'Emailed ' + vslaEsc(data.to || 'Ryan') + ': ' + vslaEsc(r.subject || '')
    : 'Sent nothing' + (r.why ? ' (' + vslaEsc(r.why) + ')' : '') + '.') + '</div>';
  if (r.stuck && r.stuck.length) {
    html += '<div style="margin-top: 6px;">' + r.stuck.map(function(x) {
      return vslaEsc(x.ref || x.key) + ' (' + vslaEsc(x.kind) + ', ' + vslaEsc(x.overdueMinutes) + ' min past due)';
    }).join('; ') + '</div>';
  }
  if (r.emailError) html += '<div style="margin-top: 6px; color:#f87171;"><strong>The email did not go: ' + vslaEsc(r.emailError) + '</strong> (nothing was stamped, so the next tick tries again).</div>';
  if (r.error) html += '<div style="margin-top: 6px; color:#f87171;"><strong>Error: ' + vslaEsc(r.error) + '</strong></div>';
  if (r.truncated) html += '<div style="margin-top: 6px; color:#f59e0b;">A queue hit its key cap, so not every held email was read.</div>';
  stuckStatus.innerHTML = html;
}

if (stuckBtn && stuckEnabled) {
  (async function loadStuck() {
    try {
      var data = await window.RepPortal.API.get('/admin/stuck-send-config');
      var cfg = data.config || {};
      stuckEnabled.checked = cfg.enabled !== false;
      stuckMinutes.value = cfg.stuckAfterMinutes;
      stuckRepeat.value = cfg.repeatAfterHours;
      stuckOrphans.checked = cfg.reportOrphans !== false;
      if (stuckFreight) stuckFreight.checked = cfg.reportFreightMisses !== false;
      if (stuckJudge) stuckJudge.checked = cfg.reportJudgeFailures !== false;
      if (stuckFacts) stuckFacts.checked = cfg.reportFactMisses !== false;
      if (stuckFactsStrict) stuckFactsStrict.checked = cfg.factCheckStrict === true;
      stuckRender(data);
    } catch (e) {
      showMsg(stuckMsg, 'Could not load the current watch rules - reload before saving.', 'error');
      if (stuckStatus) stuckStatus.textContent = 'Could not load the last run.';
    }
  })();

  stuckBtn.addEventListener('click', async function() {
    hideMsg(stuckMsg);
    var m = parseInt(stuckMinutes.value, 10);
    if (!isFinite(m) || m < 10 || m > 240) { showMsg(stuckMsg, 'Enter a whole number of minutes from 10 to 240. The drains run every five minutes, so anything under ten reports a drain that is merely running.', 'error'); return; }
    var h = parseInt(stuckRepeat.value, 10);
    if (!isFinite(h) || h < 1 || h > 72) { showMsg(stuckMsg, 'Enter a whole number of hours from 1 to 72.', 'error'); return; }
    stuckBtn.disabled = true;
    var orig = stuckBtn.textContent;
    stuckBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/stuck-send-config', {
        enabled: !!stuckEnabled.checked, stuckAfterMinutes: m, repeatAfterHours: h, reportOrphans: !!stuckOrphans.checked,
        reportFreightMisses: stuckFreight ? !!stuckFreight.checked : undefined,
        reportJudgeFailures: stuckJudge ? !!stuckJudge.checked : undefined,
        reportFactMisses: stuckFacts ? !!stuckFacts.checked : undefined,
        factCheckStrict: stuckFactsStrict ? !!stuckFactsStrict.checked : undefined
      });
      var cfg = res.config || {};
      stuckEnabled.checked = cfg.enabled !== false;
      stuckMinutes.value = cfg.stuckAfterMinutes;
      stuckRepeat.value = cfg.repeatAfterHours;
      stuckOrphans.checked = cfg.reportOrphans !== false;
      if (stuckFreight) stuckFreight.checked = cfg.reportFreightMisses !== false;
      if (stuckJudge) stuckJudge.checked = cfg.reportJudgeFailures !== false;
      if (stuckFacts) stuckFacts.checked = cfg.reportFactMisses !== false;
      if (stuckFactsStrict) stuckFactsStrict.checked = cfg.factCheckStrict === true;
      showMsg(stuckMsg, cfg.enabled === false
        ? 'Saved - the watch is off. A queue that stops draining will not tell anyone.'
        : 'Saved - you get one email when something is stuck, and nothing when the queues are clear.', 'success');
    } catch (e) {
      showMsg(stuckMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { stuckBtn.disabled = false; stuckBtn.textContent = orig; }
  });
}

if (stuckPreviewBtn && stuckPreview) {
  stuckPreviewBtn.addEventListener('click', async function() {
    hideMsg(stuckMsg);
    stuckPreviewBtn.disabled = true;
    var orig = stuckPreviewBtn.textContent;
    stuckPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/stuck-sends');
      var run = (d && d.run) || {};
      var queued = run.queued || [];
      var lines = queued.map(function(q) {
        return '<div style="padding: 4px 0;">' + vslaEsc(q.ref || q.key) + ' &middot; ' + vslaEsc(q.kind)
          + ' &middot; due ' + vslaEsc(vslaWhen(q.dueAt)) + ' &middot; <strong>' + vslaEsc(q.why) + '</strong>'
          + (q.overdueMinutes != null ? ' (' + vslaEsc(q.overdueMinutes) + ' min)' : '') + '</div>';
      }).join('');
      stuckPreview.innerHTML = '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 0 0 6px;">'
        + (run.windowOpen ? 'The send window is open.' : 'The send window is shut, so nothing can be late right now.')
        + ' ' + vslaEsc(queued.length) + ' held email(s) waiting on the clock.</div>'
        + (lines || '<div style="padding: 4px 0; color: var(--rq-text-secondary);">Nothing is queued.</div>')
        + (d.previewHtml
          ? '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 10px 0 6px;">This is the email that would go out:</div>'
            + '<iframe title="Stuck send preview" style="width: 100%; height: 360px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.previewHtml) + '"></iframe>'
          : '');
      stuckPreview.style.display = '';
      showMsg(stuckMsg, (run.stuck || []).length
        ? 'Nothing was sent - this is a preview. ' + run.stuck.length + ' held email(s) are past due.'
        : 'Nothing is stuck. Nothing was sent.', 'success');
      /* The "Last run" box keeps showing the last REAL run: a dry run sends nothing and must not
         overwrite the record of what the cron actually did. */
      try { stuckRender(await window.RepPortal.API.get('/admin/stuck-send-config')); } catch (_) { /* the preview is the answer here */ }
    } catch (e) {
      showMsg(stuckMsg, 'Could not read the queues: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { stuckPreviewBtn.disabled = false; stuckPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_STUCKSENDWATCH_BY_CLAUDE */

/* CUSTOM_EXTERNALWAITSLA_BY_CLAUDE (AIOPS 4622788dc2ef, Ryan 2026-09-12) - Admin: External Wait
   SLA. The switch, the dials, the last run, and a dry run that shows exactly what tomorrow's 9am
   email would say. The dry run is FORCED: it answers at any hour AND while the rail is switched
   off, which is the state it ships in and the state Ryan reads it in before arming it. */
var extEnabled = document.getElementById('settings-extwait-enabled');
var extThreshold = document.getElementById('settings-extwait-threshold');
var extMax = document.getElementById('settings-extwait-max');
var extQuiet = document.getElementById('settings-extwait-quiet');
var extPreCutoff = document.getElementById('settings-extwait-precutoff');
var extSamples = document.getElementById('settings-extwait-samples');
var extParkedSkip = document.getElementById('settings-extwait-parkedskip');
/* CUSTOM_ASKPARK_BY_CLAUDE (AIOPS facf1e051d77) — the two 2026-09-17 suppressions. */
var extSiblingSold = document.getElementById('settings-extwait-siblingsold');
var extDiscDrip = document.getElementById('settings-extwait-discdrip');
var extCustWait = document.getElementById('settings-extwait-customerwait'); // CUSTOM_CUSTOMERWAIT_BY_CLAUDE (AIOPS 058f329c6bea)
var extParked = document.getElementById('settings-extwait-parked');
var extParkedDays = document.getElementById('settings-extwait-parkeddays');
var extBtn = document.getElementById('settings-extwait-btn');
var extPreviewBtn = document.getElementById('settings-extwait-preview-btn');
var extPreview = document.getElementById('settings-extwait-preview');
var extMsg = document.getElementById('settings-extwait-msg');
var extStatus = document.getElementById('settings-extwait-status');

function extFill(cfg) {
  /* ⛔ NOTHING IS DEFAULTED IN THE MARKUP. Every box is painted from the server's own answer, so a
     panel that failed to load can never be mistaken for a panel showing the real settings. */
  extEnabled.checked = cfg.enabled === true;
  extThreshold.value = cfg.thresholdWorkdays;
  extMax.value = cfg.maxRows;
  extQuiet.value = cfg.quietAfterReports;
  extPreCutoff.checked = cfg.includePreCutoff === true;
  extSamples.checked = cfg.excludeSamples !== false;
  extParkedSkip.checked = cfg.skipParkedOnCall !== false;
  if (extSiblingSold) extSiblingSold.checked = cfg.skipSiblingSold !== false;
  if (extDiscDrip) extDiscDrip.checked = cfg.skipDiscontinuedDrip !== false;
  if (extCustWait) extCustWait.checked = cfg.includeCustomerWait !== false;
  extParked.checked = cfg.includeParked === true;
  extParkedDays.value = cfg.parkedAfterWorkdays;
}

function extRender(data) {
  if (!extStatus) return;
  var r = data && data.lastRun;
  var off = !(data && data.config && data.config.enabled === true);
  if (!r) {
    extStatus.innerHTML = off
      ? 'It is <strong>switched off</strong> and has never run. Press &ldquo;Show me today&rsquo;s list&rdquo; to see what it would say, then tick the box above to arm it.'
      : 'It has not run yet. It runs at 9am Mountain on business days; the first pass shows here.';
    return;
  }
  var html = '<div>Ran <strong>' + vslaEsc(vslaWhen(r.at)) + '</strong>'
    + (r.enabled === false ? ' &mdash; <strong>switched off</strong>' : '') + ': '
    + vslaEsc(r.scanned) + ' deals read, ' + vslaEsc(r.openAsks) + ' open ask(s), <strong>'
    + vslaEsc(r.late) + ' overdue</strong>, ' + vslaEsc(r.listed) + ' listed'
    + (r.held ? ', ' + vslaEsc(r.held) + ' held because nothing changed' : '') + '.</div>';
  var sup = r.suppressed || {};
  var supBits = Object.keys(sup).map(function(k) { return vslaEsc(sup[k]) + ' ' + vslaEsc(k); });
  if (supBits.length) html += '<div style="margin-top: 6px;">Left out: ' + supBits.join(', ') + '.</div>';
  if (r.truncated) html += '<div style="margin-top: 6px; color:#f59e0b;">The walk hit its key cap, so not every deal was read.</div>';
  html += '<div style="margin-top: 6px;">' + (r.sent
    ? 'Emailed ' + vslaEsc(data.to || 'Ryan') + ': ' + vslaEsc(r.subject || '')
    : 'Sent nothing' + (r.why ? ' (' + vslaEsc(r.why) + ')' : '') + '.') + '</div>';
  if (r.rows && r.rows.length) {
    html += '<div style="margin-top: 6px;">' + r.rows.map(function(x) {
      return vslaEsc(x.ref) + ' (' + vslaEsc(x.vendor) + ', ' + vslaEsc(x.kind) + ', ' + vslaEsc(x.workdaysWaiting) + ' workday(s)'
        + (x.replyMatchable ? '' : ', no vendor email on file') + ')';
    }).join('; ') + '</div>';
  }
  if (r.parked && r.parked.length) {
    html += '<div style="margin-top: 6px;">Parked on a call: ' + r.parked.map(function(x) {
      return vslaEsc(x.ref) + ' (' + vslaEsc(x.workdaysWaiting) + ' workday(s))';
    }).join('; ') + '</div>';
  }
  if (r.emailError) html += '<div style="margin-top: 6px; color:#f87171;"><strong>The email did not go: ' + vslaEsc(r.emailError) + '</strong> (nothing was stamped, so the next run tries again).</div>';
  if (r.error) html += '<div style="margin-top: 6px; color:#f87171;"><strong>Error: ' + vslaEsc(r.error) + '</strong></div>';
  extStatus.innerHTML = html;
}

if (extBtn && extEnabled) {
  (async function loadExt() {
    try {
      var data = await window.RepPortal.API.get('/admin/external-wait-sla-config');
      extFill(data.config || {});
      extRender(data);
    } catch (e) {
      showMsg(extMsg, 'Could not load the current wait rules — reload before saving.', 'error');
      if (extStatus) extStatus.textContent = 'Could not load the last run.';
    }
  })();

  extBtn.addEventListener('click', async function() {
    hideMsg(extMsg);
    var t = parseInt(extThreshold.value, 10);
    if (!isFinite(t) || t < 1 || t > 10) { showMsg(extMsg, 'Enter a whole number of workdays from 1 to 10.', 'error'); return; }
    var n = parseInt(extMax.value, 10);
    if (!isFinite(n) || n < 1 || n > 200) { showMsg(extMsg, 'Enter a whole number of rows from 1 to 200.', 'error'); return; }
    var q = parseInt(extQuiet.value, 10);
    if (!isFinite(q) || q < 0 || q > 20) { showMsg(extMsg, 'Enter a whole number of mornings from 0 to 20 (0 = never go quiet).', 'error'); return; }
    var pd = parseInt(extParkedDays.value, 10);
    if (!isFinite(pd) || pd < 1 || pd > 20) { showMsg(extMsg, 'Enter a whole number of workdays from 1 to 20 for the parked section.', 'error'); return; }
    extBtn.disabled = true;
    var orig = extBtn.textContent;
    extBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/external-wait-sla-config', {
        enabled: !!extEnabled.checked, thresholdWorkdays: t, maxRows: n, quietAfterReports: q,
        includePreCutoff: !!extPreCutoff.checked, excludeSamples: !!extSamples.checked,
        skipParkedOnCall: !!extParkedSkip.checked, includeParked: !!extParked.checked,
        skipSiblingSold: !extSiblingSold || !!extSiblingSold.checked,
        skipDiscontinuedDrip: !extDiscDrip || !!extDiscDrip.checked,
        includeCustomerWait: !extCustWait || !!extCustWait.checked,
        parkedAfterWorkdays: pd
      });
      var cfg = res.config || {};
      extFill(cfg);
      showMsg(extMsg, cfg.enabled === true
        ? 'Saved — the 9am list emails Ryan when an ask has gone ' + cfg.thresholdWorkdays + ' workday(s) with no reply, and nothing when none has.'
        : 'Saved — the morning list is off. The agent sweep above still flags late supplier asks; only this email stops.', 'success');
    } catch (e) {
      showMsg(extMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { extBtn.disabled = false; extBtn.textContent = orig; }
  });
}

/* The dry run. It reads the real board, renders the real email, and sends and stamps NOTHING — so
   pressing it at 4pm on a Sunday, with the rail switched off, still shows what an armed 9am would
   say. That is the whole point: it is the screen Ryan arms this from. */
if (extPreviewBtn && extPreview) {
  extPreviewBtn.addEventListener('click', async function() {
    hideMsg(extMsg);
    extPreviewBtn.disabled = true;
    var orig = extPreviewBtn.textContent;
    extPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/external-wait-sla');
      var run = (d && d.run) || {};
      if (!d.previewHtml) {
        extPreview.style.display = 'none';
        showMsg(extMsg, 'Nothing is overdue right now — ' + (run.scanned || 0) + ' deals read, ' + (run.openAsks || 0) + ' open ask(s), no email would go out.', 'success');
      } else {
        extPreview.innerHTML = '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 0 0 6px;">Subject: <strong>' + vslaEsc(run.subject || '') + '</strong></div>'
          + '<iframe title="External wait preview" style="width: 100%; height: 420px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.previewHtml) + '"></iframe>';
        extPreview.style.display = '';
        showMsg(extMsg, run.why === 'already-reported-today'
          ? 'This is what would go out. Today\'s list has already been emailed, so the next send is tomorrow morning.'
          : 'This is what the 9am email would say. Nothing was sent.', 'success');
      }
      /* The "Last run" box keeps showing the last REAL run: a dry run sends nothing and must not
         overwrite the record of what the 9am tick actually did. */
      try { extRender(await window.RepPortal.API.get('/admin/external-wait-sla-config')); } catch (_) { /* the preview is the answer here */ }
    } catch (e) {
      showMsg(extMsg, 'Could not build the list: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { extPreviewBtn.disabled = false; extPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_EXTERNALWAITSLA_BY_CLAUDE */

/* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (AIOPS ca624b9b44c0, Ryan 2026-09-12) - Admin: Supplier Pay
   Digest. The switch, the dials, the pinned orders, the extra recipients, the last run, a dry run
   that renders the exact email the 3 PM tick would send - and the list of what is owed with a
   Mark paid button beside each row.

   ⛔ MARK PAID IS THE HUMAN SURFACE THIS RAIL NEEDED. Until now nothing in the portal could close
   a `supplier-pay-pending:` row at all: the only doors were POST /supplier-pay/settle and the AI
   agent acting on a "paid" in chat. An email that lists money nobody can tick off from the screen
   it is described on is a list that grows. It posts to the settle route that already owns the
   rule - it records a payment, it never makes one. */
var paydigEnabled = document.getElementById('settings-paydig-enabled');
var paydigAlways = document.getElementById('settings-paydig-always');
var paydigMorning = document.getElementById('settings-paydig-morning');
var paydigAcks = document.getElementById('settings-paydig-acks');
var paydigOverdue = document.getElementById('settings-paydig-overdue'); // CUSTOM_PAYOVERDUE_BY_CLAUDE
var paydigMax = document.getElementById('settings-paydig-max');
var paydigPins = document.getElementById('settings-paydig-pins');
var paydigCc = document.getElementById('settings-paydig-cc');
var paydigBtn = document.getElementById('settings-paydig-btn');
var paydigPreviewBtn = document.getElementById('settings-paydig-preview-btn');
var paydigPreview = document.getElementById('settings-paydig-preview');
var paydigOwed = document.getElementById('settings-paydig-owed');
var paydigMsg = document.getElementById('settings-paydig-msg');
var paydigStatus = document.getElementById('settings-paydig-status');

/* CUSTOM_SOPOCHECK_BY_CLAUDE (ONYX 5dc0b45b4d44) - the worker's reason guess, in words */
var PAYDIG_REASON = { 'freight-missing': 'freight left off', 'freight-added': 'freight added', 'tax-added': 'tax added', 'qty-price-drift': 'qty or price differs', 'line-mismatch': 'wrong item' }; // line-mismatch: CUSTOM_SOLINEMISMATCH_BY_CLAUDE

function paydigMoney(n) {
  if (n === null || n === undefined || n === '') return 'figure unknown';
  var v = Number(n);
  if (!isFinite(v)) return 'figure unknown';
  return '$' + v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function paydigApply(cfg) {
  paydigEnabled.checked = cfg.enabled === true;
  paydigAlways.checked = cfg.alwaysSendAt3pm !== false;
  paydigMorning.checked = cfg.morningCatchUp !== false;
  paydigAcks.checked = cfg.includeAcks !== false;
  if (paydigOverdue) paydigOverdue.checked = cfg.overdueWake !== false; // CUSTOM_PAYOVERDUE_BY_CLAUDE - absent reads ON
  paydigMax.value = cfg.maxRows;
  paydigPins.value = (cfg.forceInclude || []).join(', ');
  paydigCc.value = (cfg.recipients || []).join(', ');
}

function paydigRender(data) {
  if (!paydigStatus) return;
  var r = data && data.lastRun;
  if (!r) { paydigStatus.innerHTML = 'It has not run yet. It runs at 3 PM Mountain on business days, and at 7 AM when something opened overnight; the first pass shows here.'; return; }
  var html = '<div>Ran <strong>' + vslaEsc(vslaWhen(r.at)) + '</strong> (' + vslaEsc(r.run === 'morning' ? '7 AM catch-up' : '3 PM list') + ')'
    + (r.enabled === false ? ' &mdash; <strong>switched off</strong>' : '') + ': '
    + vslaEsc(r.openPoRows) + ' unpaid purchase order(s), ' + vslaEsc(r.ackStamps) + ' supplier ask(s) on record, '
    + '<strong>' + vslaEsc(r.listed) + ' listed</strong>'
    + (r.newCount ? ', ' + vslaEsc(r.newCount) + ' new' : '')
    + (r.mismatches ? ', <span style="color:#f87171;">' + vslaEsc(r.mismatches) + ' DO NOT PAY</span>' : '')
    + (r.total ? ', ' + vslaEsc(paydigMoney(r.total)) + ' in all' : '')
    + '.</div>';
  var sk = r.skipped || {};
  var skBits = Object.keys(sk).map(function(k) { return vslaEsc(sk[k]) + ' ' + vslaEsc(k); });
  if (skBits.length) html += '<div style="margin-top: 6px;">Left out: ' + skBits.join(', ') + '.</div>';
  if (r.truncated) html += '<div style="margin-top: 6px; color:#f59e0b;">The walk hit its key cap, so not every record was read.</div>';
  html += '<div style="margin-top: 6px;">' + (r.sent
    ? 'Emailed ' + vslaEsc((data.to || []).join(', ')) + ': ' + vslaEsc(r.subject || '')
    : 'Sent nothing' + (r.why ? ' (' + vslaEsc(r.why) + ')' : '') + '.') + '</div>';
  if (data.baseline) html += '<div style="margin-top: 6px;">The 7 AM catch-up measures against the 3 PM list of ' + vslaEsc(vslaWhen(data.baseline.at)) + ' (' + vslaEsc(data.baseline.count) + ' order(s)).</div>';
  if (r.emailError) html += '<div style="margin-top: 6px; color:#f87171;"><strong>The email did not go: ' + vslaEsc(r.emailError) + '</strong> (nothing was stamped and the overnight baseline did not move, so the next run tries again).</div>';
  if (r.error) html += '<div style="margin-top: 6px; color:#f87171;"><strong>Error: ' + vslaEsc(r.error) + '</strong></div>';
  paydigStatus.innerHTML = html;
}

/* What is owed, with a Mark paid button on each row. The rows come from the dry run, so this
   panel and the email can never disagree about the list. */
function paydigRenderOwed(rows) {
  if (!paydigOwed) return;
  if (!rows || !rows.length) { paydigOwed.style.display = 'none'; paydigOwed.innerHTML = ''; return; }
  paydigOwed.innerHTML = '<h3 style="font-size: 15px; font-weight: 700; margin: 0 0 6px;">Owed right now</h3>'
    + rows.map(function(x) {
      var tag = x.isNew
        ? '<span style="font-weight:700;color:#34d399;">NEW</span>'
        : '<span style="font-weight:700;color:#f59e0b;">repeat</span>';
      return '<div style="display:flex; gap:10px; align-items:center; flex-wrap:wrap; padding:6px 0; border-top:1px solid var(--rq-border, #1e2a42);">'
        + '<span style="min-width:46px;">' + tag + '</span>'
        + '<strong>' + vslaEsc(x.ref) + '</strong>'
        + '<span style="color: var(--rq-text-secondary);">' + vslaEsc(x.vendor || '') + '</span>'
        + '<span>' + vslaEsc(paydigMoney(x.amount)) + '</span>'
        + (x.poNumber ? '<span style="color: var(--rq-text-secondary);">' + vslaEsc(x.poNumber) + '</span>' : '')
        + (x.mismatch ? '<span style="color:#f87171; font-weight:700;">SO ≠ PO · DO NOT PAY' + (PAYDIG_REASON[x.gapReason] ? ' (' + PAYDIG_REASON[x.gapReason] + ')' : '') + '</span>' : '') /* CUSTOM_SOPOCHECK_BY_CLAUDE */
        + '<button type="button" class="rep-settings__submit" data-paydig-paid="' + vslaEsc(x.poNumber || '') + '" data-paydig-ref="' + vslaEsc(x.ref) + '" style="margin-left:auto; padding:4px 10px; font-size:12px;">Mark paid</button>'
        + '</div>';
    }).join('');
  paydigOwed.style.display = '';
}

if (paydigOwed) {
  paydigOwed.addEventListener('click', async function(ev) {
    var btn = ev.target.closest('[data-paydig-paid]');
    if (!btn) return;
    var po = btn.getAttribute('data-paydig-paid');
    var ref = btn.getAttribute('data-paydig-ref');
    if (!window.confirm('Record ' + (po || ref) + ' as PAID? This does not pay anybody; it takes the row off the digest.')) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Recording...';
    try {
      var body = po ? { poNumber: po, outcome: 'paid' } : { ref: ref, outcome: 'paid' };
      var res = await window.RepPortal.API.post('/supplier-pay/settle', body);
      if (res && res.settled && res.settled.length) {
        btn.textContent = 'Paid';
        btn.style.opacity = '0.5';
        showMsg(paydigMsg, 'Recorded ' + (po || ref) + ' as paid. It drops off the next digest.', 'success');
      } else {
        btn.disabled = false;
        btn.textContent = orig;
        showMsg(paydigMsg, 'Nothing open matched ' + (po || ref) + '. It may already be settled.', 'error');
      }
    } catch (e) {
      btn.disabled = false;
      btn.textContent = orig;
      showMsg(paydigMsg, 'Could not record it: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    }
  });
}

if (paydigBtn && paydigEnabled) {
  (async function loadPaydig() {
    try {
      var data = await window.RepPortal.API.get('/admin/supplier-pay-digest-config');
      paydigApply(data.config || {});
      paydigRender(data);
    } catch (e) {
      showMsg(paydigMsg, 'Could not load the current digest rules - reload before saving.', 'error');
      if (paydigStatus) paydigStatus.textContent = 'Could not load the last run.';
    }
  })();

  paydigBtn.addEventListener('click', async function() {
    hideMsg(paydigMsg);
    var n = parseInt(paydigMax.value, 10);
    if (!isFinite(n) || n < 1 || n > 200) { showMsg(paydigMsg, 'Enter a whole number of rows from 1 to 200.', 'error'); return; }
    var pins = paydigPins.value.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    var cc = paydigCc.value.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    paydigBtn.disabled = true;
    var orig = paydigBtn.textContent;
    paydigBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/supplier-pay-digest-config', {
        enabled: !!paydigEnabled.checked,
        alwaysSendAt3pm: !!paydigAlways.checked,
        morningCatchUp: !!paydigMorning.checked,
        includeAcks: !!paydigAcks.checked,
        overdueWake: paydigOverdue ? !!paydigOverdue.checked : true, // CUSTOM_PAYOVERDUE_BY_CLAUDE
        maxRows: n, forceInclude: pins, recipients: cc
      });
      paydigApply(res.config || {});
      showMsg(paydigMsg, res.config && res.config.enabled
        ? 'Saved - the digest emails ' + ((res.to || []).join(', ')) + ' at 3 PM every weekday, and at 7 AM when something opened overnight. Delete the Grok "Supplier pay digest" routine if it is still running.'
        : 'Saved - the digest is off. Nothing is emailed; the unpaid purchase orders are still recorded.', 'success');
    } catch (e) {
      showMsg(paydigMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { paydigBtn.disabled = false; paydigBtn.textContent = orig; }
  });
}

/* The dry run. It reads, it renders, it sends NOTHING and stamps nothing - so pressing it at
   10am shows exactly what this afternoon at 3 PM would say, whether or not the rail is armed. */
if (paydigPreviewBtn && paydigPreview) {
  paydigPreviewBtn.addEventListener('click', async function() {
    hideMsg(paydigMsg);
    paydigPreviewBtn.disabled = true;
    var orig = paydigPreviewBtn.textContent;
    paydigPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/supplier-pay-digest');
      var run = (d && d.run) || {};
      paydigRenderOwed(run.rows || []);
      paydigPreview.innerHTML = '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 0 0 6px;">Subject: <strong>' + vslaEsc(run.subject || '') + '</strong></div>'
        + '<iframe title="Supplier pay digest preview" style="width: 100%; height: 460px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.previewHtml || '') + '"></iframe>';
      paydigPreview.style.display = '';
      showMsg(paydigMsg, run.listed
        ? 'This is what the 3 PM email would say: ' + run.listed + ' order(s) owed' + (run.mismatches ? ', ' + run.mismatches + ' of them DO NOT PAY' : '') + '. Nothing was sent.'
        : 'Nothing is outstanding. Nothing was sent.', 'success');
      /* The "Last run" box keeps showing the last REAL run: a dry run sends nothing and must not
         overwrite the record of what the 3 PM tick actually did. */
      try { paydigRender(await window.RepPortal.API.get('/admin/supplier-pay-digest-config')); } catch (_) { /* the preview is the answer here */ }
    } catch (e) {
      showMsg(paydigMsg, 'Could not build the list: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { paydigPreviewBtn.disabled = false; paydigPreviewBtn.textContent = orig; }
  });
}

/* The backlog clear. ⛔ TWO BUTTONS ON PURPOSE, and the second one does not exist until the first
   has been pressed: this is one-way, so "count it" is not a courtesy step, it is the only chance
   to look before 240 rows leave the digest for good. The Clear button re-hides itself if the date
   changes, so a count of one cut can never be committed against another. */
var paydigCutoff = document.getElementById('settings-paydig-cutoff');
var paydigCountBtn = document.getElementById('settings-paydig-count-btn');
var paydigClearBtn = document.getElementById('settings-paydig-clear-btn');
var paydigBacklog = document.getElementById('settings-paydig-backlog');
var paydigCountedFor = null;

function paydigBacklogSummary(d) {
  var v = d.byVendor || {};
  var names = Object.keys(v).sort(function(a, b) { return v[b].total - v[a].total; });
  return '<div><strong>' + vslaEsc(d.count) + '</strong> order(s), <strong>' + vslaEsc(paydigMoney(d.total)) + '</strong> in all'
    + (d.oldest ? ', sent between ' + vslaEsc(String(d.oldest).slice(0, 10)) + ' and ' + vslaEsc(String(d.newest).slice(0, 10)) : '') + '.</div>'
    + (names.length ? '<div style="margin-top: 6px;">' + names.map(function(n) {
        return vslaEsc(n) + ': ' + vslaEsc(v[n].rows) + ' (' + vslaEsc(paydigMoney(v[n].total)) + ')';
      }).join(' &middot; ') + '</div>' : '');
}

if (paydigCutoff && paydigCountBtn) {
  paydigCutoff.addEventListener('input', function() {
    if (paydigCountedFor && paydigCountedFor !== paydigCutoff.value) {
      paydigClearBtn.hidden = true;
      paydigBacklog.innerHTML = '';
      paydigCountedFor = null;
    }
  });

  paydigCountBtn.addEventListener('click', async function() {
    hideMsg(paydigMsg);
    if (!paydigCutoff.value) { showMsg(paydigMsg, 'Pick a date first. Everything sent BEFORE it is settled.', 'error'); return; }
    paydigCountBtn.disabled = true;
    var orig = paydigCountBtn.textContent;
    paydigCountBtn.textContent = 'Counting...';
    try {
      var d = await window.RepPortal.API.get('/admin/supplier-pay/clear-backlog?before=' + encodeURIComponent(paydigCutoff.value));
      paydigBacklog.innerHTML = paydigBacklogSummary(d);
      if (d.count) {
        paydigClearBtn.hidden = false;
        paydigClearBtn.textContent = 'Clear these ' + d.count;
        paydigCountedFor = paydigCutoff.value;
        showMsg(paydigMsg, 'Nothing has changed yet. Read the breakdown, then press Clear.', 'success');
      } else {
        paydigClearBtn.hidden = true;
        paydigCountedFor = null;
        showMsg(paydigMsg, 'Nothing was sent before that date that is still open.', 'success');
      }
    } catch (e) {
      showMsg(paydigMsg, 'Could not count them: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { paydigCountBtn.disabled = false; paydigCountBtn.textContent = orig; }
  });

  paydigClearBtn.addEventListener('click', async function() {
    if (paydigCountedFor !== paydigCutoff.value) { showMsg(paydigMsg, 'The date changed. Count again before clearing.', 'error'); return; }
    if (!window.confirm('Settle every supplier order sent before ' + paydigCutoff.value + ' as NOT OWED?\n\nThis cannot be undone - a settled row can never come back onto the digest. It records; it pays nobody.')) return;
    paydigClearBtn.disabled = true;
    var orig = paydigClearBtn.textContent;
    paydigClearBtn.textContent = 'Clearing...';
    try {
      var r = await window.RepPortal.API.post('/admin/supplier-pay/clear-backlog', { before: paydigCutoff.value });
      paydigClearBtn.hidden = true;
      paydigCountedFor = null;
      paydigBacklog.innerHTML = '<div>Settled <strong>' + vslaEsc(r.settled) + '</strong> order(s), ' + vslaEsc(paydigMoney(r.total)) + '. No payment was recorded and no deal feed was written to.</div>';
      showMsg(paydigMsg, 'Done. Press Show me what is owed to see what is left.', 'success');
    } catch (e) {
      paydigClearBtn.disabled = false;
      paydigClearBtn.textContent = orig;
      showMsg(paydigMsg, 'Could not clear them: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { paydigClearBtn.disabled = false; }
  });
}
/* END CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE */

/* CUSTOM_ECOREETAREMINDER_BY_CLAUDE (AIOPS 1ff431a91179, Ryan 2026-09-14) - the Monday ECORE ETA
   reminder. The switch, the quiet window, the dry run and the last run.

   The dry run is the important button: it is FORCED server-side, so it answers on a Thursday while
   the rail is switched off, which is the state it ships in and the state Ryan arms it from. */
var ecoretaEnabled = document.getElementById('settings-ecoreeta-enabled');
var ecoretaQuiet = document.getElementById('settings-ecoreeta-quiet');
var ecoretaAge = document.getElementById('settings-ecoreeta-age');
var ecoretaMax = document.getElementById('settings-ecoreeta-max');
var ecoretaExclude = document.getElementById('settings-ecoreeta-exclude');
var ecoretaCc = document.getElementById('settings-ecoreeta-cc');
var ecoretaBtn = document.getElementById('settings-ecoreeta-btn');
var ecoretaPreviewBtn = document.getElementById('settings-ecoreeta-preview-btn');
var ecoretaPreview = document.getElementById('settings-ecoreeta-preview');
var ecoretaMsg = document.getElementById('settings-ecoreeta-msg');
var ecoretaStatus = document.getElementById('settings-ecoreeta-status');
var ecoretaAgentPull = document.getElementById('settings-ecoreeta-agentpull'); // CUSTOM_ECOREETAPULL_BY_CLAUDE
var ecoretaPullStatus = document.getElementById('settings-ecoreeta-pull-status');

function ecoretaApply(c) {
  if (!c) return;
  if (ecoretaEnabled) ecoretaEnabled.checked = c.enabled === true;
  if (ecoretaAgentPull) ecoretaAgentPull.checked = c.agentPull === true; // CUSTOM_ECOREETAPULL_BY_CLAUDE - absent reads OFF
  if (ecoretaQuiet) ecoretaQuiet.value = (c.quietDays == null ? 14 : c.quietDays);
  if (ecoretaAge) ecoretaAge.value = (c.maxAgeDays == null ? 120 : c.maxAgeDays);
  if (ecoretaMax) ecoretaMax.value = (c.maxRows == null ? 60 : c.maxRows);
  if (ecoretaExclude) ecoretaExclude.value = (c.exclude || []).join(', ');
  if (ecoretaCc) ecoretaCc.value = (c.recipients || []).join(', ');
}

/* THE LAST RUN IS PRINTED EVEN WHEN IT SENT NOTHING, and it names WHY. A Monday with no email is
   the normal, healthy outcome of this rail once the ETAs are current - and it is also exactly what
   a dead cron looks like. This line is the only thing that tells them apart. */
function ecoretaRenderLast(d) {
  /* CUSTOM_ECOREETAPULL_BY_CLAUDE (ONYX 2d2bb3d9da35) - what Onyx's last import stamped. */
  if (ecoretaPullStatus) {
    var p = d && d.lastPull;
    if (!p) ecoretaPullStatus.textContent = 'Onyx has not imported the portal yet.';
    else {
      var pw = '';
      try { pw = new Date(p.at).toLocaleString(); } catch (_) { pw = String(p.at || ''); }
      ecoretaPullStatus.textContent = 'Last Onyx import ' + pw + ': ' + (p.portalRows || 0) + ' portal rows, '
        + ((p.stamped || []).length) + ' ETA(s) stamped, ' + ((p.unchanged || []).length) + ' unchanged'
        + ((p.unmatched || []).length ? ', ' + p.unmatched.length + ' row(s) matched no open deal' : '')
        + ((p.notOnPortal || []).length ? ', ' + p.notOnPortal.length + ' open order(s) missing from the portal (' + p.notOnPortal.map(function(x) { return x.ref; }).join(', ') + ')' : '')
        + ((p.errors || []).length ? ' - ' + p.errors.length + ' write(s) FAILED' : '') + '.';
    }
  }
  if (!ecoretaStatus) return;
  var last = d && d.lastRun;
  if (!last) { ecoretaStatus.textContent = 'It has not run yet.'; return; }
  var when = '';
  try { when = new Date(last.at).toLocaleString(); } catch (_) { when = String(last.at || ''); }
  var why = {
    'no-open-ecore-orders': 'no ECORE orders were open',
    'recent-pass': 'every open order already had a current ETA',
    'eta-needed': 'orders needed an ETA',
    'agent-pull-woken': 'Onyx was woken to pull the portal instead'
  }[last.why] || last.why || '';
  ecoretaStatus.textContent = 'Last run ' + when + ': ' + (last.open || 0) + ' open, '
    + (last.needing || 0) + ' needing an ETA'
    + (last.pastDue ? ' (' + last.pastDue + ' past due)' : '')
    + ' - ' + (last.sent ? 'emailed ' + ((last.to || []).join(', ') || 'Ryan') : 'nothing sent, ' + why)
    + (last.emailError ? ' [' + last.emailError + ']' : '')
    + (last.truncated ? ' - WARNING: the purchase-order scan hit its cap, so the list may be short.' : '');
}

if (ecoretaBtn && ecoretaEnabled) {
  (async function loadEcoreta() {
    try {
      var data = await window.RepPortal.API.get('/admin/ecore-eta-reminder-config');
      ecoretaApply(data.config || {});
      ecoretaRenderLast(data);
    } catch (e) {
      showMsg(ecoretaMsg, 'Could not load the current reminder rules - reload before saving.', 'error');
      if (ecoretaStatus) ecoretaStatus.textContent = 'Could not load the last run.';
    }
  })();

  ecoretaBtn.addEventListener('click', async function() {
    hideMsg(ecoretaMsg);
    var q = parseInt(ecoretaQuiet.value, 10);
    var a = parseInt(ecoretaAge.value, 10);
    var m = parseInt(ecoretaMax.value, 10);
    if (!isFinite(q) || q < 0 || q > 90) { showMsg(ecoretaMsg, 'The quiet window is a whole number of days from 0 to 90. 0 asks every week.', 'error'); return; }
    if (!isFinite(a) || a < 7 || a > 1000) { showMsg(ecoretaMsg, 'Ignore-older-than is a whole number of days from 7 to 1000.', 'error'); return; }
    if (!isFinite(m) || m < 1 || m > 200) { showMsg(ecoretaMsg, 'Enter a whole number of rows from 1 to 200.', 'error'); return; }
    var ex = ecoretaExclude.value.split(',').map(function(s2) { return s2.trim(); }).filter(Boolean);
    var cc = ecoretaCc.value.split(',').map(function(s2) { return s2.trim(); }).filter(Boolean);
    ecoretaBtn.disabled = true;
    var orig = ecoretaBtn.textContent;
    ecoretaBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/ecore-eta-reminder-config', {
        enabled: !!ecoretaEnabled.checked, quietDays: q, maxAgeDays: a, maxRows: m,
        exclude: ex, recipients: cc,
        agentPull: !!(ecoretaAgentPull && ecoretaAgentPull.checked) // CUSTOM_ECOREETAPULL_BY_CLAUDE
      });
      ecoretaApply(res.config || {});
      ecoretaRenderLast(res);
      showMsg(ecoretaMsg, res.config && res.config.agentPull
        ? 'Saved - Onyx pulls the ECORE portal at 8:26 AM every Monday and stamps the ETAs itself. You get the list by email only if no import has landed by 12:29 PM.'
        : res.config && res.config.enabled
        ? 'Saved - the reminder emails ' + ((res.to || []).join(', ')) + ' at 8 AM every Monday, and stays quiet on a Monday where every open ECORE order already has a current ETA. Delete the Grok "ecore-eta-reminder" routine if it is still running.'
        : 'Saved - the reminder is off. Nothing is emailed; the open ECORE orders are still listed by the button below.', 'success');
    } catch (e) {
      showMsg(ecoretaMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { ecoretaBtn.disabled = false; ecoretaBtn.textContent = orig; }
  });
}

if (ecoretaPreviewBtn && ecoretaPreview) {
  ecoretaPreviewBtn.addEventListener('click', async function() {
    hideMsg(ecoretaMsg);
    ecoretaPreviewBtn.disabled = true;
    var orig = ecoretaPreviewBtn.textContent;
    ecoretaPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/ecore-eta-reminder');
      var run = (d && d.run) || {};
      ecoretaPreview.innerHTML = '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 0 0 6px;">Subject: <strong>' + vslaEsc(run.subject || '(nothing would be sent)') + '</strong></div>'
        + '<iframe title="ECORE ETA reminder preview" style="width: 100%; height: 420px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.previewHtml || '') + '"></iframe>';
      ecoretaPreview.style.display = '';
      showMsg(ecoretaMsg, run.needing
        ? 'This is what Monday would say: ' + run.needing + ' of ' + run.open + ' open ECORE order(s) need an ETA' + (run.pastDue ? ', ' + run.pastDue + ' of them past due' : '') + '. Nothing was sent.'
        : (run.open ? 'All ' + run.open + ' open ECORE orders already have a current ETA, so Monday would be silent. Nothing was sent.'
                    : 'No ECORE orders are open. Nothing was sent.'), 'success');
      /* The "Last run" line keeps showing the last REAL run: a dry run sends nothing and must not
         overwrite the record of what Monday's tick actually did. */
      try { ecoretaRenderLast(await window.RepPortal.API.get('/admin/ecore-eta-reminder-config')); } catch (_) { /* the preview is the answer here */ }
    } catch (e) {
      showMsg(ecoretaMsg, 'Could not build the list: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { ecoretaPreviewBtn.disabled = false; ecoretaPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_ECOREETAREMINDER_BY_CLAUDE */

/* CUSTOM_PICKUPCHECK_BY_CLAUDE (AIOPS 5f122e10d4a9, Ryan 2026-09-19) - the morning-after pickup
   tracking check. The switch, the escalation window, the dials, the dry run and the last run.

   The dry run is the important button: it is FORCED server-side, so it says what an armed pass
   would do while the rail is switched off, which is the state it ships in and the state Ryan arms
   it from. */
var pickchkEnabled = document.getElementById('settings-pickupcheck-enabled');
var pickchkEscalate = document.getElementById('settings-pickupcheck-escalate');
var pickchkAge = document.getElementById('settings-pickupcheck-age');
var pickchkMax = document.getElementById('settings-pickupcheck-max');
var pickchkCc = document.getElementById('settings-pickupcheck-cc');
var pickchkBtn = document.getElementById('settings-pickupcheck-btn');
var pickchkPreviewBtn = document.getElementById('settings-pickupcheck-preview-btn');
var pickchkPreview = document.getElementById('settings-pickupcheck-preview');
var pickchkMsg = document.getElementById('settings-pickupcheck-msg');
var pickchkStatus = document.getElementById('settings-pickupcheck-status');
var pickchkCustEmails = document.getElementById('settings-pickupcheck-customer-emails'); // CUSTOM_PROCHASE_BY_CLAUDE (ONYX 4432b1acdd03)
var pickchkOpsAsk = document.getElementById('settings-pickupcheck-ops-ask');

function pickchkApply(c) {
  if (!c) return;
  if (pickchkEnabled) pickchkEnabled.checked = c.enabled === true;
  if (pickchkCustEmails) pickchkCustEmails.checked = c.customerEmails === true;
  if (pickchkOpsAsk) pickchkOpsAsk.checked = c.opsAsk === true;
  if (pickchkEscalate) pickchkEscalate.value = (c.escalateHours == null ? 24 : c.escalateHours);
  if (pickchkAge) pickchkAge.value = (c.maxAgeDays == null ? 30 : c.maxAgeDays);
  if (pickchkMax) pickchkMax.value = (c.maxPerRun == null ? 25 : c.maxPerRun);
  if (pickchkCc) pickchkCc.value = (c.recipients || []).join(', ');
}

/* THE LAST RUN IS PRINTED EVEN WHEN IT DID NOTHING. A quiet hour is the normal, healthy outcome of
   this rail - and it is also exactly what a dead cron looks like. This line is the only thing that
   tells them apart. */
function pickchkRenderLast(d) {
  if (!pickchkStatus) return;
  var last = d && d.lastRun;
  if (!last) { pickchkStatus.textContent = 'It has not run yet.'; return; }
  var when = '';
  try { when = new Date(last.at).toLocaleString(); } catch (_) { when = String(last.at || ''); }
  pickchkStatus.textContent = 'Last run ' + when + ': ' + (last.jobs || 0) + ' booked pickup(s) being watched, '
    + (last.woke || 0) + ' asked of the Order Desk'
    + (last.escalated ? ', ' + last.escalated + ' emailed to you' : '')
    + (last.dropped ? ', ' + last.dropped + ' finished and dropped' : '')
    + (last.deferred ? ' - ' + last.deferred + ' left for the next pass' : '')
    + (last.emailError ? ' [' + last.emailError + ']' : '') + '.';
}

if (pickchkBtn && pickchkEnabled) {
  (async function loadPickchk() {
    try {
      var data = await window.RepPortal.API.get('/admin/pickup-check-config');
      pickchkApply(data.config || {});
      pickchkRenderLast(data);
    } catch (e) {
      showMsg(pickchkMsg, 'Could not load the current check rules - reload before saving.', 'error');
      if (pickchkStatus) pickchkStatus.textContent = 'Could not load the last run.';
    }
  })();

  pickchkBtn.addEventListener('click', async function() {
    hideMsg(pickchkMsg);
    var h = parseInt(pickchkEscalate.value, 10);
    var a = parseInt(pickchkAge.value, 10);
    var m = parseInt(pickchkMax.value, 10);
    if (!isFinite(h) || h < 0 || h > 168) { showMsg(pickchkMsg, 'Email me after is a whole number of hours from 0 to 168. 0 tells you on the same pass.', 'error'); return; }
    if (!isFinite(a) || a < 1 || a > 180) { showMsg(pickchkMsg, 'Give up after is a whole number of days from 1 to 180.', 'error'); return; }
    if (!isFinite(m) || m < 1 || m > 200) { showMsg(pickchkMsg, 'Enter a whole number of shipments from 1 to 200.', 'error'); return; }
    var cc = pickchkCc.value.split(',').map(function(s2) { return s2.trim(); }).filter(Boolean);
    pickchkBtn.disabled = true;
    var orig = pickchkBtn.textContent;
    pickchkBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/pickup-check-config', {
        enabled: !!pickchkEnabled.checked, escalateHours: h, maxAgeDays: a, maxPerRun: m, recipients: cc,
        customerEmails: !!(pickchkCustEmails && pickchkCustEmails.checked), opsAsk: !!(pickchkOpsAsk && pickchkOpsAsk.checked)
      });
      pickchkApply(res.config || {});
      pickchkRenderLast(res);
      showMsg(pickchkMsg, res.config && res.config.enabled
        ? 'Saved - the morning after a booked pickup the Order Desk is asked for the tracking, and ' + ((res.to || []).join(', ')) + ' hears about anything still missing ' + (res.config.escalateHours || 0) + ' hours later.'
        : 'Saved - the check is off. Booked pickups are still recorded on their deals, so turning it on later picks them up.', 'success');
    } catch (e) {
      showMsg(pickchkMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { pickchkBtn.disabled = false; pickchkBtn.textContent = orig; }
  });
}

if (pickchkPreviewBtn && pickchkPreview) {
  pickchkPreviewBtn.addEventListener('click', async function() {
    hideMsg(pickchkMsg);
    pickchkPreviewBtn.disabled = true;
    var orig = pickchkPreviewBtn.textContent;
    pickchkPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/pickup-check');
      var run = (d && d.run) || {};
      var rows = (run.wakeRows || []).concat(run.escalateRows || []);
      var list = rows.length
        ? '<ul style="margin: 0 0 8px; padding-left: 20px; font-size: 13px;">' + rows.map(function(r) {
            return '<li style="margin: 0 0 2px;">' + vslaEsc(r.ref) + ' - ' + vslaEsc(r.vendor || '')
              + ' <span style="color: var(--rq-text-secondary);">(pickup ' + vslaEsc(r.pickupScheduledFor || 'date not recorded')
              + ', missing ' + vslaEsc((r.missing || []).join(' + ')) + ')</span></li>';
          }).join('') + '</ul>'
        : '';
      pickchkPreview.innerHTML = list
        + (d.previewHtml
          ? '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 8px 0 6px;">The email you would get: <strong>' + vslaEsc(run.subject || '') + '</strong></div>'
            + '<iframe title="Pickup tracking check preview" style="width: 100%; height: 320px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.previewHtml) + '"></iframe>'
          : '');
      pickchkPreview.style.display = rows.length ? '' : 'none';
      showMsg(pickchkMsg, rows.length
        ? 'Right now it would ask the Order Desk about ' + (run.woke || 0) + ' shipment(s)' + (run.escalated ? ' and email you about ' + run.escalated : '') + '. Nothing was asked and nothing was sent.'
        : (run.jobs
            ? 'All ' + run.jobs + ' booked pickup(s) are either not due yet or already have their tracking. Nothing would happen.'
            : 'No booked pickups are being watched. Record one with a pickup date on a deal and it appears here.'), 'success');
      /* The "Last run" line keeps showing the last REAL run: a dry run does nothing and must not
         overwrite the record of what the cron actually did. */
      try { pickchkRenderLast(await window.RepPortal.API.get('/admin/pickup-check-config')); } catch (_) { /* the preview is the answer here */ }
    } catch (e) {
      showMsg(pickchkMsg, 'Could not run the check: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { pickchkPreviewBtn.disabled = false; pickchkPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_PICKUPCHECK_BY_CLAUDE */


/* CUSTOM_RECEIVABLESDIGEST_BY_CLAUDE (AIOPS 1202df5b141e + cda823116d56, Ryan 2026-09-13/16) -
   the weekly receivables digest: the switch, the day, the two dials, the mid-week coupling, and a
   dry run that works while the rail is OFF (which is the state it ships in and the state Ryan arms
   it from). Nothing here sends; Save writes the config, the preview button renders the email. */
var recvEnabled = document.getElementById('settings-recv-enabled');
var recvWeekday = document.getElementById('settings-recv-weekday');
var recvMin = document.getElementById('settings-recv-min');
var recvMax = document.getElementById('settings-recv-max');
var recvPre = document.getElementById('settings-recv-pre');
var recvUrgent = document.getElementById('settings-recv-urgent');
var recvBtn = document.getElementById('settings-recv-btn');
var recvPreviewBtn = document.getElementById('settings-recv-preview-btn');
var recvPreview = document.getElementById('settings-recv-preview');
var recvMsg = document.getElementById('settings-recv-msg');
var recvStatus = document.getElementById('settings-recv-status');

function recvApply(c) {
  if (recvEnabled) recvEnabled.checked = c.enabled === true;
  if (recvWeekday) recvWeekday.value = c.weekday || 'mon';
  if (recvMin) recvMin.value = c.minAmount == null ? 0 : c.minAmount;
  if (recvMax) recvMax.value = c.maxRows == null ? 60 : c.maxRows;
  if (recvPre) recvPre.checked = c.includePreEmail !== false;
}

/* THE MID-WEEK DIAL LIVES ON THE OTHER RAIL'S CONFIG. It is `collect-due-alert-config.urgentOnly`
   and it is TRI-STATE - null means "follow this digest", which is the whole reason the two cards
   move together. Rendering it as a checkbox here would have to pick a side for null and would then
   save that guess back on the first press of Save. */
function recvApplyUrgent(v) {
  if (!recvUrgent) return;
  recvUrgent.value = v === true ? 'urgent' : (v === false ? 'all' : 'auto');
}

function recvRenderLast(d) {
  if (!recvStatus) return;
  var last = (d && d.lastRun) || null;
  var send = (d && d.lastSend) || null;
  if (!last) { recvStatus.textContent = send ? 'Last sent ' + send.at : 'Not run yet.'; return; }
  var why = last.why || (last.sent ? 'sent' : 'nothing sent');
  recvStatus.textContent = 'Last run ' + last.at + ': '
    + (last.chasing || 0) + ' being chased, ' + (last.preEmail || 0) + ' not asked yet'
    + (last.total ? ', $' + Number(last.total).toFixed(2) + ' in all' : '')
    + ' - ' + (last.sent ? 'emailed' : 'nothing sent, ' + why)
    + (last.emailError ? ' [' + last.emailError + ']' : '')
    + (last.truncated ? ' - WARNING: the order scan hit its cap, so the list may be short.' : '');
}

if (recvBtn && recvEnabled) {
  (async function loadRecv() {
    try {
      var data = await window.RepPortal.API.get('/admin/receivables-digest-config');
      recvApply(data.config || {});
      recvRenderLast(data);
    } catch (e) {
      showMsg(recvMsg, 'Could not load the current digest rules - reload before saving.', 'error');
      if (recvStatus) recvStatus.textContent = 'Could not load the last run.';
    }
    /* The mid-week dial is a field of the daily alert's own record, so it is a second read. A
       failure here leaves the select on its "auto" default and says nothing: the digest's own
       settings are still perfectly saveable without it. */
    try {
      var cd = await window.RepPortal.API.get('/admin/collect-due-alert-config');
      recvApplyUrgent(cd && cd.config ? cd.config.urgentOnly : null);
    } catch (_) { /* leave it on Follow this digest */ }
  })();

  recvBtn.addEventListener('click', async function() {
    hideMsg(recvMsg);
    var mn = Number(recvMin.value);
    var mx = parseInt(recvMax.value, 10);
    if (!isFinite(mn) || mn < 0) { showMsg(recvMsg, 'The minimum is a dollar figure of 0 or more. 0 lists everything.', 'error'); return; }
    if (!isFinite(mx) || mx < 1 || mx > 200) { showMsg(recvMsg, 'Enter a whole number of rows from 1 to 200.', 'error'); return; }
    recvBtn.disabled = true;
    var orig = recvBtn.textContent;
    recvBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/receivables-digest-config', {
        enabled: !!recvEnabled.checked,
        weekday: recvWeekday.value,
        minAmount: mn,
        maxRows: mx,
        includePreEmail: !!recvPre.checked
      });
      recvApply(res.config || {});
      /* THE SECOND POST IS NOT OPTIONAL AND IT GOES SECOND. The mid-week dial's meaning depends on
         whether this digest is armed, so saving it BEFORE the digest would briefly resolve against
         the old state; and skipping it when the select reads "auto" would leave an earlier explicit
         choice in place while the screen says it is following. */
      var want = recvUrgent ? recvUrgent.value : 'auto';
      var urgentOnly = want === 'urgent' ? true : (want === 'all' ? false : null);
      var midweek = '';
      try {
        var cd2 = await window.RepPortal.API.post('/admin/collect-due-alert-config', { urgentOnly: urgentOnly });
        var u = cd2 && cd2.config ? cd2.config.urgentOnly : urgentOnly;
        recvApplyUrgent(u);
        midweek = u === true ? ' Mid-week you will only hear about a balance that wants a call or that nobody is chasing.'
          : (u === false ? ' Mid-week the daily list still names every due balance.'
            : (res.config && res.config.enabled
              ? ' Mid-week the daily list has narrowed to the urgent rows, because this digest is on.'
              : ' Mid-week the daily list still names every due balance, because this digest is off.'));
      } catch (_) { midweek = ' The mid-week setting could not be saved - open the Balance Collect Alert card and set it there.'; }
      recvRenderLast(res);
      showMsg(recvMsg, res.config && res.config.enabled
        ? 'Saved - the list emails ' + ((res.to || []).join(', ')) + ' at 8 AM on ' + (res.config.weekday || 'mon') + ', and a week with nothing outstanding is silent.' + midweek
        : 'Saved - the weekly list is off. Nothing is emailed; the button below still shows you who owes us.' + midweek, 'success');
    } catch (e) {
      showMsg(recvMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { recvBtn.disabled = false; recvBtn.textContent = orig; }
  });
}

if (recvPreviewBtn && recvPreview) {
  recvPreviewBtn.addEventListener('click', async function() {
    hideMsg(recvMsg);
    recvPreviewBtn.disabled = true;
    var orig = recvPreviewBtn.textContent;
    recvPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/receivables-digest');
      var run = (d && d.run) || {};
      var n = (run.chasing || 0) + (run.preEmail || 0);
      recvPreview.innerHTML = '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 0 0 6px;">Subject: <strong>' + vslaEsc(run.subject || '(nothing would be sent)') + '</strong></div>'
        + '<iframe title="Receivables digest preview" style="width: 100%; height: 480px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.previewHtml || '') + '"></iframe>';
      recvPreview.style.display = '';
      showMsg(recvMsg, n
        ? 'This is what the weekly list would say: ' + run.chasing + ' balance(s) being chased and ' + run.preEmail + ' nobody has asked for yet'
          + (run.total ? ', $' + Number(run.total).toFixed(2) + ' in all' : '') + '. Nothing was sent.'
        : 'Nothing is outstanding, so the week would be silent. Nothing was sent.', 'success');
      /* The "Last run" line keeps showing the last REAL run: a dry run sends nothing and must not
         overwrite the record of what the weekly tick actually did. */
      try { recvRenderLast(await window.RepPortal.API.get('/admin/receivables-digest-config')); } catch (_) { /* the preview is the answer here */ }
    } catch (e) {
      showMsg(recvMsg, 'Could not build the list: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { recvPreviewBtn.disabled = false; recvPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_RECEIVABLESDIGEST_BY_CLAUDE */

/* CUSTOM_REPDIGEST_BY_CLAUDE (ONYX 19d32ac7df4e + a10effd579df + 1e5d1f455c42, Ryan 2026-09-30) -
   the morning rep digest: the three-way switch, the test address, a dry run of every rep's email
   and a "send them all to the test address now". Loaded from the server, never defaulted in the
   markup, so a Save can never write a value the page did not read. */
var rdMode = document.getElementById('settings-repdigest-mode');
var rdTestTo = document.getElementById('settings-repdigest-testto');
var rdBtn = document.getElementById('settings-repdigest-btn');
var rdMsg = document.getElementById('settings-repdigest-msg');
var rdWeekend = document.getElementById('settings-repdigest-weekend');
var rdPreviewBtn = document.getElementById('settings-repdigest-preview-btn');
var rdTestBtn = document.getElementById('settings-repdigest-test-btn');
var rdStatus = document.getElementById('settings-repdigest-status');
var rdPreview = document.getElementById('settings-repdigest-preview');
var rdLoaded = false;

function rdApply(c) {
  rdMode.value = c.mode === 'test' || c.mode === 'live' ? c.mode : 'off';
  if (rdTestTo) rdTestTo.value = c.testTo || '';
}

function rdRenderLast(d) {
  if (!rdStatus) return;
  var last = d && d.lastRun;
  if (!last) { rdStatus.textContent = 'Not run yet.'; return; }
  var emails = last.emails || [];
  var sent = emails.filter(function(e) { return e.sent; }).length;
  rdStatus.textContent = 'Last run ' + last.at + ' (' + (last.mode || 'off') + (last.urgentOnly ? ', weekend' : '') + '): '
    + (last.items || 0) + ' open items, ' + emails.length + ' email(s), ' + sent + ' sent'
    + (emails.length > sent ? ' - ' + (emails.length - sent) + ' FAILED' : '')
    + ((last.truncated || []).length ? ' - WARNING: a list hit its cap, so an email may be short.' : '');
}

if (rdBtn && rdMode) {
  (async function loadRd() {
    try {
      var data = await window.RepPortal.API.get('/admin/rep-digest-config');
      rdApply(data.config || {});
      rdRenderLast(data);
      rdLoaded = true;
    } catch (e) {
      showMsg(rdMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  rdBtn.addEventListener('click', async function() {
    hideMsg(rdMsg);
    if (!rdLoaded) { showMsg(rdMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    var body = { mode: rdMode.value };
    var t = (rdTestTo.value || '').trim();
    if (t) body.testTo = t;
    rdBtn.disabled = true;
    var orig = rdBtn.textContent;
    rdBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/rep-digest-config', body);
      var c = res.config || {};
      rdApply(c);
      showMsg(rdMsg, c.mode === 'live' ? 'Saved - each rep gets their own email at 7:31 AM Mountain.'
        : (c.mode === 'test' ? 'Saved - every rep\'s email goes to ' + c.testTo + ' at 7:31 AM Mountain, and no rep gets one.'
          : 'Saved - it is off. Nothing is emailed; the preview below still works.'), 'success');
    } catch (e) {
      showMsg(rdMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rdBtn.disabled = false; rdBtn.textContent = orig; }
  });
}

function rdDrawEmails(emails) {
  if (!rdPreview) return;
  rdPreview.innerHTML = (emails || []).map(function(e) {
    return '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 12px 0 6px;">To <strong>' + vslaEsc(e.to) + '</strong> - Subject: <strong>' + vslaEsc(e.subject) + '</strong></div>'
      + (e.html ? '<iframe title="Digest preview" style="width: 100%; height: 420px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(e.html) + '"></iframe>' : '');
  }).join('');
  rdPreview.style.display = (emails || []).length ? '' : 'none';
}

if (rdPreviewBtn) {
  rdPreviewBtn.addEventListener('click', async function() {
    hideMsg(rdMsg);
    rdPreviewBtn.disabled = true;
    var orig = rdPreviewBtn.textContent;
    rdPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/rep-digest' + (rdWeekend && rdWeekend.checked ? '?weekend=1' : ''));
      var run = (d && d.run) || {};
      rdDrawEmails(run.emails);
      showMsg(rdMsg, (run.emails || []).length
        ? (run.emails.length + ' email(s) would go, from ' + (run.items || 0) + ' open items. Nothing was sent.')
        : 'Nobody has anything open' + (rdWeekend && rdWeekend.checked ? ' that is Urgent' : '') + ', so nothing would go. Nothing was sent.', 'success');
    } catch (e) {
      showMsg(rdMsg, 'Could not build the preview: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rdPreviewBtn.disabled = false; rdPreviewBtn.textContent = orig; }
  });
}

if (rdTestBtn) {
  rdTestBtn.addEventListener('click', async function() {
    hideMsg(rdMsg);
    if (!window.confirm('Email every rep\'s digest to the test address now? No rep gets one.')) return;
    rdTestBtn.disabled = true;
    var orig = rdTestBtn.textContent;
    rdTestBtn.textContent = 'Sending...';
    try {
      var d = await window.RepPortal.API.post('/admin/rep-digest' + (rdWeekend && rdWeekend.checked ? '?weekend=1' : ''), {});
      var emails = ((d && d.run) || {}).emails || [];
      var sent = emails.filter(function(e) { return e.sent; }).length;
      showMsg(rdMsg, emails.length ? sent + ' of ' + emails.length + ' sent to ' + d.to + '.' : 'Nobody has anything open, so nothing was sent.', sent === emails.length ? 'success' : 'error');
    } catch (e) {
      showMsg(rdMsg, 'Could not send: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rdTestBtn.disabled = false; rdTestBtn.textContent = orig; }
  });
}
/* END CUSTOM_REPDIGEST_BY_CLAUDE */

/* CUSTOM_ABBYINTRO_BY_CLAUDE (AIOPS 67db43d9ee42 + 3323c0336059 + 1bb223ad4abe, Ryan 2026-09-30) - Abby's intro on a
   sold offline deal: the three-way switch, the two once-per-customer dials, the keep-the-owner-on-replies switch, a dry
   run for one deal and the recent list. Loaded from the server, never defaulted in the markup, so a Save can never write
   a value the page did not read. */
var aiMode = document.getElementById('settings-abbyintro-mode');
var aiWindow = document.getElementById('settings-abbyintro-window');
var aiMax = document.getElementById('settings-abbyintro-maxinbound');
var aiKeep = document.getElementById('settings-abbyintro-keepowner');
var aiBtn = document.getElementById('settings-abbyintro-btn');
var aiMsg = document.getElementById('settings-abbyintro-msg');
var aiRef = document.getElementById('settings-abbyintro-ref');
var aiPreviewBtn = document.getElementById('settings-abbyintro-preview-btn');
var aiListBtn = document.getElementById('settings-abbyintro-list-btn');
var aiStatus = document.getElementById('settings-abbyintro-status');
var aiPreview = document.getElementById('settings-abbyintro-preview');
var aiLoaded = false;

function aiApply(c) {
  aiMode.value = c.mode === 'test' || c.mode === 'live' ? c.mode : 'off';
  if (aiWindow) aiWindow.value = c.windowDays || 180;
  if (aiMax) aiMax.value = c.maxInbound || 3;
  if (aiKeep) aiKeep.checked = c.keepOwnerOnReplies === true;
}

if (aiBtn && aiMode) {
  (async function loadAi() {
    try {
      var data = await window.RepPortal.API.get('/admin/abby-intro-config');
      aiApply(data.config || {});
      aiLoaded = true;
    } catch (e) {
      showMsg(aiMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  aiBtn.addEventListener('click', async function() {
    hideMsg(aiMsg);
    if (!aiLoaded) { showMsg(aiMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    var body = {
      mode: aiMode.value,
      windowDays: parseInt(aiWindow.value, 10),
      maxInbound: parseInt(aiMax.value, 10),
      keepOwnerOnReplies: !!aiKeep.checked,
    };
    aiBtn.disabled = true;
    var orig = aiBtn.textContent;
    aiBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/abby-intro-config', body);
      var c = res.config || {};
      aiApply(c);
      showMsg(aiMsg, res.meaning || 'Saved.', 'success');
    } catch (e) {
      showMsg(aiMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { aiBtn.disabled = false; aiBtn.textContent = orig; }
  });

  if (aiPreviewBtn) aiPreviewBtn.addEventListener('click', async function() {
    var ref = String(aiRef.value || '').trim().toUpperCase();
    if (!ref) { aiStatus.textContent = 'Type a deal reference first, e.g. RW-1428-A.'; return; }
    aiPreviewBtn.disabled = true;
    aiStatus.textContent = 'Checking ' + ref + '...';
    try {
      var d = await window.RepPortal.API.get('/admin/abby-intro?ref=' + encodeURIComponent(ref));
      var v = d.verdict || {};
      var rec = d.record;
      aiStatus.textContent = (rec ? 'On record: ' + rec.status + (rec.reason ? ' (' + rec.reason + ')' : '') + '. ' : 'Nothing on record yet. ')
        + (v.skip ? 'Right now it would NOT send: ' + v.words + '.' : v.retry ? 'Right now it would wait: the orders@ mailbox could not be checked (' + v.retry + ').' : 'Right now it would send this:');
      if (d.wouldSend) {
        aiPreview.style.display = 'block';
        aiPreview.innerHTML = '<p style="font-size: 12px; margin: 0 0 6px;">To ' + vslaEsc(d.wouldSend.to)
          + (d.wouldSend.cc && d.wouldSend.cc.length ? ', cc ' + vslaEsc(d.wouldSend.cc.join(', ')) : '')
          + ' - ' + vslaEsc(d.wouldSend.subject) + ' (' + vslaEsc(d.wouldSend.variant) + ')</p>'
          + '<iframe title="Abby intro preview" style="width: 100%; height: 300px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.wouldSend.html) + '"></iframe>';
      } else { aiPreview.style.display = 'none'; aiPreview.innerHTML = ''; }
    } catch (e) {
      aiStatus.textContent = 'Could not check: ' + (e && e.message ? e.message : 'unknown error');
    } finally { aiPreviewBtn.disabled = false; }
  });

  if (aiListBtn) aiListBtn.addEventListener('click', async function() {
    aiListBtn.disabled = true;
    try {
      var d = await window.RepPortal.API.get('/admin/abby-intro?limit=40');
      var rows = d.intros || [];
      aiStatus.textContent = rows.length ? rows.length + ' recent intro record(s), newest first.' : 'No intro records yet.';
      aiPreview.style.display = rows.length ? 'block' : 'none';
      aiPreview.innerHTML = rows.map(function(r) {
        return '<div style="font-size: 12px; padding: 2px 0;">' + vslaEsc(r.ref) + ' - ' + vslaEsc(r.status || '?')
          + (r.reason ? ' (' + vslaEsc(r.reason) + ')' : '') + (r.at ? ' - ' + vslaEsc(String(r.at).slice(0, 16).replace('T', ' ')) + ' UTC' : '') + '</div>';
      }).join('');
    } catch (e) {
      aiStatus.textContent = 'Could not load the list: ' + (e && e.message ? e.message : 'unknown error');
    } finally { aiListBtn.disabled = false; }
  });
}
/* END CUSTOM_ABBYINTRO_BY_CLAUDE */

/* CUSTOM_ORDERRECEIVED_BY_CLAUDE (ONYX 7ea395c74cdd, Ryan 2026-10-03) - the order-received email's switch, the 60-hour
   heads-up (switch, dollar line, hours), the editable suggestions list, a dry run for one order and the recent list.
   Loaded from the server, never defaulted in the markup, so a Save can never write a value the page did not read. */
var orMode = document.getElementById('settings-orderreceived-mode');
var orHeads = document.getElementById('settings-orderreceived-headsup');
var orMin = document.getElementById('settings-orderreceived-min');
var orHours = document.getElementById('settings-orderreceived-hours');
var orPairs = document.getElementById('settings-orderreceived-pairings');
var orAddPair = document.getElementById('settings-orderreceived-addpair');
var orAlways = document.getElementById('settings-orderreceived-alwayssend'); // CUSTOM_ORPARCELSKIP_BY_CLAUDE
var orBtn = document.getElementById('settings-orderreceived-btn');
var orMsg = document.getElementById('settings-orderreceived-msg');
var orRef = document.getElementById('settings-orderreceived-ref');
var orPreviewBtn = document.getElementById('settings-orderreceived-preview-btn');
var orListBtn = document.getElementById('settings-orderreceived-list-btn');
var orStatus = document.getElementById('settings-orderreceived-status');
var orPreview = document.getElementById('settings-orderreceived-preview');
var orLoaded = false;
var OR_PAIR_FIELDS = [
  { k: 'name', ph: 'Suggest (e.g. ECORE E-Cleaner)', w: 190 },
  { k: 'vendor', ph: 'Supplier (e.g. ECORE)', w: 120 },
  { k: 'titleWords', ph: 'Title has one of (comma list)', w: 200 },
  { k: 'alreadyWords', ph: 'Skip if order already has', w: 160 },
  { k: 'why', ph: 'Why (e.g. to keep the floor looking new)', w: 230 },
];

function orPairRow(p) {
  var row = document.createElement('div');
  row.setAttribute('data-or-pair', '1');
  row.style.cssText = 'display: flex; gap: 6px; flex-wrap: wrap; align-items: center; margin: 0 0 6px;';
  OR_PAIR_FIELDS.forEach(function(f) {
    var inp = document.createElement('input');
    inp.type = 'text';
    inp.className = 'rep-settings__input';
    inp.setAttribute('data-k', f.k);
    inp.placeholder = f.ph;
    inp.value = (p && p[f.k]) || '';
    inp.style.cssText = 'max-width: ' + f.w + 'px; font-size: 13px;';
    row.appendChild(inp);
  });
  var rm = document.createElement('button');
  rm.type = 'button';
  rm.className = 'rep-settings__submit';
  rm.textContent = 'Remove';
  rm.style.cssText = 'opacity: 0.7; padding: 4px 10px;';
  rm.addEventListener('click', function() { if (row.parentNode) row.parentNode.removeChild(row); });
  row.appendChild(rm);
  return row;
}

function orApply(c) {
  orMode.value = c.mode === 'test' || c.mode === 'live' ? c.mode : 'off';
  if (orHeads) orHeads.checked = c.headsUp === true;
  if (orMin) orMin.value = c.headsUpMinTotal != null ? c.headsUpMinTotal : 1000;
  if (orHours) orHours.value = c.headsUpHours || 60;
  if (orAlways) orAlways.value = c.alwaysSend || '';
  if (orPairs) {
    orPairs.innerHTML = '';
    (Array.isArray(c.pairings) ? c.pairings : []).forEach(function(p) { orPairs.appendChild(orPairRow(p)); });
  }
}

function orReadPairs() {
  var out = [];
  if (!orPairs) return out;
  var rows = orPairs.querySelectorAll('[data-or-pair]');
  for (var i = 0; i < rows.length; i++) {
    var p = {};
    var inputs = rows[i].querySelectorAll('input[data-k]');
    for (var j = 0; j < inputs.length; j++) p[inputs[j].getAttribute('data-k')] = String(inputs[j].value || '').trim();
    if (p.name) out.push(p);
  }
  return out;
}

if (orBtn && orMode) {
  (async function loadOr() {
    try {
      var data = await window.RepPortal.API.get('/admin/order-received-config');
      orApply(data.config || {});
      orLoaded = true;
    } catch (e) {
      showMsg(orMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  if (orAddPair) orAddPair.addEventListener('click', function() { if (orPairs) orPairs.appendChild(orPairRow({})); });

  orBtn.addEventListener('click', async function() {
    hideMsg(orMsg);
    if (!orLoaded) { showMsg(orMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    var body = {
      mode: orMode.value,
      headsUp: !!(orHeads && orHeads.checked),
      headsUpMinTotal: Number(orMin && orMin.value),
      headsUpHours: parseInt(orHours && orHours.value, 10),
      pairings: orReadPairs(),
    };
    if (orAlways) body.alwaysSend = String(orAlways.value || '').trim();
    orBtn.disabled = true;
    var orig = orBtn.textContent;
    orBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/order-received-config', body);
      orApply(res.config || {});
      showMsg(orMsg, res.meaning || 'Saved.', 'success');
    } catch (e) {
      showMsg(orMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { orBtn.disabled = false; orBtn.textContent = orig; }
  });

  if (orPreviewBtn) orPreviewBtn.addEventListener('click', async function() {
    var ref = String(orRef.value || '').trim().toUpperCase();
    if (!ref) { orStatus.textContent = 'Type an order reference first, e.g. SHOP-2128.'; return; }
    orPreviewBtn.disabled = true;
    orStatus.textContent = 'Checking ' + ref + '...';
    try {
      var d = await window.RepPortal.API.get('/admin/order-received?ref=' + encodeURIComponent(ref));
      var v = d.verdict || {};
      var rec = d.record;
      orStatus.textContent = (rec ? 'On record: ' + rec.status + (rec.reason ? ' (' + rec.reason + ')' : '') + (rec.testNumber ? ', TEST ' + rec.testNumber : '') + '. ' : 'Nothing on record yet. ')
        + (v.skip ? 'Right now it would NOT send: ' + v.words + '.' : v.retry ? 'Right now it would wait (' + v.retry + ').' : 'Right now it would send this:');
      if (d.wouldSend) {
        orPreview.style.display = 'block';
        orPreview.innerHTML = '<p style="font-size: 12px; margin: 0 0 6px;">To ' + vslaEsc(d.wouldSend.to) + ' - ' + vslaEsc(d.wouldSend.subject)
          + ' (' + vslaEsc(d.wouldSend.variant) + (d.wouldSend.leadTime ? ', lead time ' + vslaEsc(d.wouldSend.leadTime) : '') + ')</p>'
          + '<iframe title="Order-received preview" style="width: 100%; height: 340px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(d.wouldSend.html) + '"></iframe>';
      } else { orPreview.style.display = 'none'; orPreview.innerHTML = ''; }
    } catch (e) {
      orStatus.textContent = 'Could not check: ' + (e && e.message ? e.message : 'unknown error');
    } finally { orPreviewBtn.disabled = false; }
  });

  if (orListBtn) orListBtn.addEventListener('click', async function() {
    orListBtn.disabled = true;
    try {
      var d = await window.RepPortal.API.get('/admin/order-received?limit=40');
      var rows = d.records || [];
      orStatus.textContent = rows.length ? rows.length + ' recent order record(s), newest first.' : 'No order records yet.';
      orPreview.style.display = rows.length ? 'block' : 'none';
      orPreview.innerHTML = rows.map(function(r) {
        return '<div style="font-size: 12px; padding: 2px 0;">' + vslaEsc(r.ref) + ' - ' + vslaEsc(r.status || '?')
          + (r.testNumber ? ' (TEST ' + vslaEsc(r.testNumber) + ')' : '')
          + (r.reason ? ' (' + vslaEsc(r.reason) + ')' : '') + (r.at ? ' - ' + vslaEsc(String(r.at).slice(0, 16).replace('T', ' ')) + ' UTC' : '') + '</div>';
      }).join('');
    } catch (e) {
      orStatus.textContent = 'Could not load the list: ' + (e && e.message ? e.message : 'unknown error');
    } finally { orListBtn.disabled = false; }
  });
}
/* END CUSTOM_ORDERRECEIVED_BY_CLAUDE */

/* CUSTOM_ORPHANSWEEP_BY_CLAUDE (ONYX 9d91a54f6a9f, Ryan 2026-09-30) - the hourly orphan sweep's switch and a dry run
   of what it would find. Loaded from the server, never defaulted in the markup, so a Save can never write a value
   the page did not read. */
var osEnabled = document.getElementById('settings-orphansweep-enabled');
var osBtn = document.getElementById('settings-orphansweep-btn');
var osMsg = document.getElementById('settings-orphansweep-msg');
var osPreviewBtn = document.getElementById('settings-orphansweep-preview-btn');
var osStatus = document.getElementById('settings-orphansweep-status');
var osPreview = document.getElementById('settings-orphansweep-preview');
var osLoaded = false;

function osRenderLast(d) {
  if (!osStatus) return;
  var last = d && d.lastRun;
  osStatus.textContent = last ? ('Last run ' + last.at + ': ' + (last.orphans || 0) + ' open with no follow-up, ' + (last.due || 0) + ' due today, ' + (last.woke || 0) + ' wake(s) sent.') : 'Not run yet.';
}

if (osBtn && osEnabled) {
  (async function loadOs() {
    try {
      var data = await window.RepPortal.API.get('/admin/orphan-sweep-config');
      osEnabled.checked = !!(data.config && data.config.enabled === true);
      osRenderLast(data);
      osLoaded = true;
    } catch (e) {
      showMsg(osMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  osBtn.addEventListener('click', async function() {
    hideMsg(osMsg);
    if (!osLoaded) { showMsg(osMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    osBtn.disabled = true;
    var orig = osBtn.textContent;
    osBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/orphan-sweep-config', { enabled: !!osEnabled.checked });
      osEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(osMsg, osEnabled.checked ? 'Saved - on. The next business hour wakes the agents about open work with no follow-up.' : 'Saved - off. Nobody is woken; the preview below still works.', 'success');
    } catch (e) {
      showMsg(osMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { osBtn.disabled = false; osBtn.textContent = orig; }
  });
}

if (osPreviewBtn && osPreview) {
  osPreviewBtn.addEventListener('click', async function() {
    hideMsg(osMsg);
    osPreviewBtn.disabled = true;
    var orig = osPreviewBtn.textContent;
    osPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/orphan-sweep');
      var run = (d && d.run) || {};
      var list = run.list || [];
      osPreview.innerHTML = list.map(function(o) {
        return '<div style="padding: 6px 0; border-bottom: 1px solid var(--rq-border, #1e2a42);"><strong>' + vslaEsc(o.ref || 'no deal named') + '</strong> - '
          + vslaEsc(o.last || '') + ' <span style="color: var(--rq-text-secondary);">Suggested: ' + vslaEsc(o.suggestedTier || '') + ', ' + vslaEsc(o.suggestedFollowUpLabel || '') + '. Owner: ' + vslaEsc(o.seat || '') + '.</span></div>';
      }).join('');
      osPreview.style.display = list.length ? '' : 'none';
      showMsg(osMsg, list.length ? (list.length + ' open item(s) with no follow-up; ' + (run.due || 0) + ' would wake today. Nobody was woken.') : 'Nothing is open without a follow-up. Nobody was woken.', 'success');
    } catch (e) {
      showMsg(osMsg, 'Could not check: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { osPreviewBtn.disabled = false; osPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_ORPHANSWEEP_BY_CLAUDE */

/* CUSTOM_STREETFOLLOWUP_BY_CLAUDE (ONYX 2611059c0fb8, Ryan 2026-10-16) - the street-address follow-ups' switch and a dry run.
   Loaded from the server, never defaulted in the markup, so a Save can never write a value the page did not read. */
var sfuEnabled = document.getElementById('settings-streetfu-enabled');
var sfuBtn = document.getElementById('settings-streetfu-btn');
var sfuMsg = document.getElementById('settings-streetfu-msg');
var sfuPreviewBtn = document.getElementById('settings-streetfu-preview-btn');
var sfuStatus = document.getElementById('settings-streetfu-status');
var sfuPreview = document.getElementById('settings-streetfu-preview');
var sfuLoaded = false;
var SFU_WORDS = {
  'due': 'would send the next follow-up now', 'not-due': 'waiting for two business days to pass', 'outside-hours': 'due, waits for business hours',
  'ask-test-waiting-on-ryan': 'the first ask is still a [TEST] waiting on you', 'followup-test-waiting-on-ryan': 'a follow-up [TEST] is waiting on you',
  'rep-replied': 'the owner replied: stops', 'street-saved': 'the street is on the deal: stops', 'deal-closed': 'the deal closed: stops',
  'followup-discarded': 'you discarded a follow-up: stops', 'ask-never-sent': 'the first ask was never sent: stops', 'all-sent': 'all three went: stops',
  'no-thread': 'no thread on record (an ask from before this was built)', 'thread-unread': 'the thread could not be read right now'
};

if (sfuBtn && sfuEnabled) {
  (async function loadSfu() {
    try {
      var data = await window.RepPortal.API.get('/admin/street-followup-config');
      sfuEnabled.checked = !!(data.config && data.config.enabled === true);
      var last = data.lastRun;
      if (sfuStatus) sfuStatus.textContent = last ? ('Last run ' + last.at + ': ' + (last.asks || 0) + ' ask(s), ' + (last.sent || 0) + ' follow-up(s) sent or staged, ' + (last.stopped || 0) + ' stopped.') : 'Not run yet.';
      sfuLoaded = true;
    } catch (e) {
      showMsg(sfuMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  sfuBtn.addEventListener('click', async function() {
    hideMsg(sfuMsg);
    if (!sfuLoaded) { showMsg(sfuMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    sfuBtn.disabled = true;
    var orig = sfuBtn.textContent;
    sfuBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/street-followup-config', { enabled: !!sfuEnabled.checked });
      sfuEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(sfuMsg, sfuEnabled.checked ? 'Saved - on. Unanswered street-address asks get their first follow-up two business days after the ask.' : 'Saved - off. No follow-ups go; the preview below still works.', 'success');
    } catch (e) {
      showMsg(sfuMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { sfuBtn.disabled = false; sfuBtn.textContent = orig; }
  });
}

if (sfuPreviewBtn && sfuPreview) {
  sfuPreviewBtn.addEventListener('click', async function() {
    hideMsg(sfuMsg);
    sfuPreviewBtn.disabled = true;
    var orig = sfuPreviewBtn.textContent;
    sfuPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/street-followup');
      var rows = ((d && d.run && d.run.rows) || []).filter(function(r) { return r.action !== 'skip' && r.action !== 'done'; });
      sfuPreview.innerHTML = rows.map(function(r) {
        return '<div style="padding: 6px 0; border-bottom: 1px solid var(--rq-border, #1e2a42);"><strong>' + vslaEsc(r.ref || '') + '</strong> - '
          + vslaEsc(SFU_WORDS[r.why] || r.why || '') + ' <span style="color: var(--rq-text-secondary);">Owner: ' + vslaEsc(r.owner || '?') + '. Follow-ups so far: ' + (r.sent || 0) + '.</span></div>';
      }).join('');
      sfuPreview.style.display = rows.length ? '' : 'none';
      showMsg(sfuMsg, rows.length ? (rows.length + ' open street-address ask(s). Nothing was sent.') : 'No open street-address asks. Nothing was sent.', 'success');
    } catch (e) {
      showMsg(sfuMsg, 'Could not check: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { sfuPreviewBtn.disabled = false; sfuPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_STREETFOLLOWUP_BY_CLAUDE */


/* CUSTOM_SIGNEDORDERPENDING_BY_CLAUDE (ONYX 51b7fca781f6, Ryan 2026-10-16) - the sign-the-proposal switch and its dry run.
   Same load-from-server rule as the panels above: a failed load leaves the box untouched and refuses the save. */
var sopEnabled = document.getElementById('settings-signedorder-enabled');
var sopBtn = document.getElementById('settings-signedorder-btn');
var sopMsg = document.getElementById('settings-signedorder-msg');
var soPreviewBtn = document.getElementById('settings-signedorder-preview-btn');
var soStatus = document.getElementById('settings-signedorder-status');
var soPreview = document.getElementById('settings-signedorder-preview');
var sopLoaded = false;
var SO_WORDS = {
  'ask-due': 'would ask the customer to sign now', 'reminder-due': 'a reminder is due now', 'not-due': 'waiting for the next reminder day',
  'off': 'the switch is off', 'no-payment-recorded': 'no payment recorded yet', 'signed': 'signed: the thank-you is due',
  'thanks-waiting': 'the thank-you is waiting to go', 'reminders-done': 'all reminders went: would email you',
  'reminders-done-ryan-told': 'all reminders went and you were emailed', 'deal-not-sold': 'the deal is no longer sold: stops',
  'not-required': 'signed order marked not required: stops', 'not-pending': 'no longer pending: stops',
  'signed-before-ask': 'signed before Abby asked: stops', 'signed-thanked': 'signed and thanked: done', 'thanks-discarded': 'the thank-you was discarded: stops'
};

if (sopBtn && sopEnabled) {
  (async function loadSop() {
    try {
      var data = await window.RepPortal.API.get('/admin/signed-order-config');
      sopEnabled.checked = !!(data.config && data.config.enabled === true);
      var last = data.lastRun;
      if (soStatus) soStatus.textContent = last ? ('Last run ' + last.at + ': ' + (last.deals || 0) + ' pending deal(s), ' + (last.parked || 0) + ' email(s) parked, ' + (last.closed || 0) + ' closed.') : 'Not run yet.';
      sopLoaded = true;
    } catch (e) {
      showMsg(sopMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  sopBtn.addEventListener('click', async function() {
    hideMsg(sopMsg);
    if (!sopLoaded) { showMsg(sopMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    sopBtn.disabled = true;
    var orig = sopBtn.textContent;
    sopBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/signed-order-config', { enabled: !!sopEnabled.checked });
      sopEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(sopMsg, sopEnabled.checked ? 'Saved - on. PENDING deals get the sign request on the next 15-minute tick.' : 'Saved - off. Nothing is sent; the preview below still works.', 'success');
    } catch (e) {
      showMsg(sopMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { sopBtn.disabled = false; sopBtn.textContent = orig; }
  });
}

if (soPreviewBtn && soPreview) {
  soPreviewBtn.addEventListener('click', async function() {
    hideMsg(sopMsg);
    soPreviewBtn.disabled = true;
    var orig = soPreviewBtn.textContent;
    soPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/signed-order');
      var rows = (d && d.run && d.run.rows) || [];
      soPreview.innerHTML = rows.map(function(r) {
        return '<div style="padding: 6px 0; border-bottom: 1px solid var(--rq-border, #1e2a42);"><strong>' + vslaEsc(r.ref || '') + '</strong> - '
          + vslaEsc(SO_WORDS[r.why] || r.why || '') + ' <span style="color: var(--rq-text-secondary);">Emails so far: ' + (r.steps || 0) + (r.dueAt ? '. Next: ' + vslaEsc(r.dueAt) : '') + '.</span></div>';
      }).join('');
      soPreview.style.display = rows.length ? '' : 'none';
      showMsg(sopMsg, rows.length ? (rows.length + ' PENDING deal(s). Nothing was sent.') : 'No PENDING deals. Nothing was sent.', 'success');
    } catch (e) {
      showMsg(sopMsg, 'Could not check: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { soPreviewBtn.disabled = false; soPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_SIGNEDORDERPENDING_BY_CLAUDE */


/* CUSTOM_ONLINESIGN_BY_CLAUDE (Ryan 2026-10-26) - Abby's signed-copy email after a customer signs online. Same load-from-server rule
   as the panels above: a failed load leaves the box untouched and refuses the save. */
var osCopy = document.getElementById('settings-onlinesign-copy');
var osAch = document.getElementById('settings-onlinesign-ach');
var osUnpaid = document.getElementById('settings-onlinesign-unpaid'); // CUSTOM_SIGNEDUNPAID_BY_CLAUDE (card 0a13de9f8439)
var onsBtn = document.getElementById('settings-onlinesign-btn');
var onsMsg = document.getElementById('settings-onlinesign-msg');
var onsLoaded = false;
if (onsBtn && osCopy) {
  (async function loadOns() {
    try {
      var data = await window.RepPortal.API.get('/admin/sign-online-config');
      osCopy.checked = !!(data.config && data.config.customerCopy === true);
      if (osAch) osAch.checked = !!(data.config && data.config.achEmail === true);
      if (osUnpaid) osUnpaid.checked = !!(data.config && data.config.unpaidReminders === true);
      onsLoaded = true;
    } catch (e) {
      showMsg(onsMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  onsBtn.addEventListener('click', async function() {
    hideMsg(onsMsg);
    if (!onsLoaded) { showMsg(onsMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    onsBtn.disabled = true;
    var orig = onsBtn.textContent;
    onsBtn.textContent = 'Saving...';
    try {
      var osBody = { customerCopy: !!osCopy.checked };
      if (osAch) osBody.achEmail = !!osAch.checked;
      if (osUnpaid) osBody.unpaidReminders = !!osUnpaid.checked;
      var res = await window.RepPortal.API.post('/admin/sign-online-config', osBody);
      osCopy.checked = !!(res.config && res.config.customerCopy === true);
      if (osAch) osAch.checked = !!(res.config && res.config.achEmail === true);
      if (osUnpaid) osUnpaid.checked = !!(res.config && res.config.unpaidReminders === true);
      showMsg(onsMsg, 'Saved. Signed copy email: ' + (osCopy.checked ? 'on' : 'off') + '. ACH and wire instructions email: ' + (osAch && osAch.checked ? 'on' : 'off') + '. Signed-but-unpaid reminders: ' + (osUnpaid && osUnpaid.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(onsMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { onsBtn.disabled = false; onsBtn.textContent = orig; }
  });
}
/* END CUSTOM_ONLINESIGN_BY_CLAUDE */


/* CUSTOM_SIGNEDCOPYGATE_BY_CLAUDE (Ryan 2026-10-22, RW-1532-A) - paid without a signed copy: the owner-email switch, the reminder
   spacing, and a dry run. Same load-from-server rule as the panels above. */
var scEnabled = document.getElementById('settings-signedcopy-enabled');
var scDays = document.getElementById('settings-signedcopy-workdays');
var scBtn = document.getElementById('settings-signedcopy-btn');
var scMsg = document.getElementById('settings-signedcopy-msg');
var scPreviewBtn = document.getElementById('settings-signedcopy-preview-btn');
var scStatus = document.getElementById('settings-signedcopy-status');
var scPreview = document.getElementById('settings-signedcopy-preview');
var scLoaded = false;
var SC_WORDS = {
  'ask-due': 'would ask the deal owner now', 'off': 'the switch is off', 'ask-test-waiting-on-ryan': 'the ask is waiting on your [TEST]',
  'ask-discarded': 'you discarded the ask: stops', 'no-thread': 'waiting for the ask to land', 'followup-test-waiting-on-ryan': 'a follow-up is waiting on your [TEST]',
  'followup-discarded': 'you discarded a follow-up: stops', 'thread-unread': 'could not read the email thread', 'owner-replied-onyx-reads-it': 'the owner replied: ONYX records the answer',
  'not-due': 'waiting for the next reminder day', 'outside-hours': 'due, outside customer hours', 'due': 'a reminder is due now',
  'abby-asks-the-customer': 'Abby is asking the customer: stops here', 'signed-copy-on-file': 'the signed copy is on file: stops', 'deal-closed': 'the deal closed: stops', 'not-awaiting': 'no longer waiting: stops'
};

if (scBtn && scEnabled) {
  (async function loadSc() {
    try {
      var data = await window.RepPortal.API.get('/admin/signed-copy-config');
      scEnabled.checked = !!(data.config && data.config.enabled === true);
      if (scDays) scDays.value = (data.config && data.config.workdays) || 2;
      var last = data.lastRun;
      if (scStatus) scStatus.textContent = last ? ('Last run ' + last.at + ': ' + (last.deals || 0) + ' deal(s) waiting, ' + (last.sent || 0) + ' email(s) sent or staged, ' + (last.stopped || 0) + ' stopped.') : 'Not run yet.';
      scLoaded = true;
    } catch (e) {
      showMsg(scMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  scBtn.addEventListener('click', async function() {
    hideMsg(scMsg);
    if (!scLoaded) { showMsg(scMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    var days = parseInt(scDays && scDays.value, 10);
    if (!(days >= 1 && days <= 10)) { showMsg(scMsg, 'Business days must be a whole number from 1 to 10.', 'error'); return; }
    scBtn.disabled = true;
    var orig = scBtn.textContent;
    scBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/signed-copy-config', { enabled: !!scEnabled.checked, workdays: days });
      scEnabled.checked = !!(res.config && res.config.enabled === true);
      if (scDays) scDays.value = (res.config && res.config.workdays) || days;
      showMsg(scMsg, scEnabled.checked ? 'Saved - on. Deals waiting on a signed copy get the owner email on the next 15-minute tick.' : 'Saved - off. Nothing is sent to deal owners; the reminder spacing still applies to the customer emails.', 'success');
    } catch (e) {
      showMsg(scMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { scBtn.disabled = false; scBtn.textContent = orig; }
  });
}

if (scPreviewBtn && scPreview) {
  scPreviewBtn.addEventListener('click', async function() {
    hideMsg(scMsg);
    scPreviewBtn.disabled = true;
    var orig = scPreviewBtn.textContent;
    scPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/signed-copy');
      var rows = (d && d.run && d.run.rows) || [];
      scPreview.innerHTML = rows.map(function(r) {
        return '<div style="padding: 6px 0; border-bottom: 1px solid var(--rq-border, #1e2a42);"><strong>' + vslaEsc(r.ref || '') + '</strong> - '
          + vslaEsc(SC_WORDS[r.why] || r.why || '') + ' <span style="color: var(--rq-text-secondary);">Follow-ups so far: ' + (r.followUps || 0) + (r.dueAt ? '. Next: ' + vslaEsc(r.dueAt) : '') + '.</span></div>';
      }).join('');
      scPreview.style.display = rows.length ? '' : 'none';
      showMsg(scMsg, rows.length ? (rows.length + ' deal(s) waiting on a signed copy. Nothing was sent.') : 'No deals waiting on a signed copy. Nothing was sent.', 'success');
    } catch (e) {
      showMsg(scMsg, 'Could not check: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { scPreviewBtn.disabled = false; scPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_SIGNEDCOPYGATE_BY_CLAUDE */


/* CUSTOM_ROLLLENGTHS_BY_CLAUDE (AIOPS 3ebeb1b3c73d, Ryan 2026-09-16) - the roll-lengths alert:
   one switch, the extra recipients, and a dry run that works while the rail is OFF.
   Same load-from-server rule as the panels above: nothing is defaulted in the markup, and a failed
   load says so and leaves the box untouched, so a tick can never be saved on top of a value the
   page never read. */
var rollenEnabled = document.getElementById('settings-rolllen-enabled');
var rollenCc = document.getElementById('settings-rolllen-cc');
var rollenBtn = document.getElementById('settings-rolllen-btn');
var rollenMsg = document.getElementById('settings-rolllen-msg');
var rollenRef = document.getElementById('settings-rolllen-ref');
var rollenPreviewBtn = document.getElementById('settings-rolllen-preview-btn');
var rollenPreview = document.getElementById('settings-rolllen-preview');
var rollenStatus = document.getElementById('settings-rolllen-status');

function rollenApply(cfg) {
  /* ⛔ `=== true`, the worker's own rule. An absent setting is OFF, and a box that read
     "ticked" for a record that says nothing would show Ryan a rail that is not armed. */
  rollenEnabled.checked = cfg.enabled === true;
  if (rollenCc) rollenCc.value = (cfg.recipients || []).join(', ');
}

if (rollenBtn && rollenEnabled) {
  (async function loadRollen() {
    try {
      var data = await window.RepPortal.API.get('/admin/roll-lengths-alert-config');
      rollenApply((data && data.config) || {});
    } catch (e) {
      showMsg(rollenMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  rollenBtn.addEventListener('click', async function() {
    hideMsg(rollenMsg);
    var cc = (rollenCc ? rollenCc.value : '').split(',').map(function(s2) { return s2.trim(); }).filter(Boolean);
    rollenBtn.disabled = true;
    var orig = rollenBtn.textContent;
    rollenBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/roll-lengths-alert-config', {
        enabled: !!rollenEnabled.checked, recipients: cc
      });
      rollenApply((res && res.config) || {});
      showMsg(rollenMsg, res.config && res.config.enabled
        ? 'Saved - a new online order with rolled flooring and no cut lengths emails ' + ((res.to || []).join(', ')) + ' within a minute or two of the order landing.'
        : 'Saved - the alert is off. Nothing is emailed; the check below still works.', 'success');
    } catch (e) {
      showMsg(rollenMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rollenBtn.disabled = false; rollenBtn.textContent = orig; }
  });
}

if (rollenPreviewBtn && rollenPreview) {
  rollenPreviewBtn.addEventListener('click', async function() {
    hideMsg(rollenMsg);
    var ref = (rollenRef ? rollenRef.value : '').trim().toUpperCase();
    if (!/^SHOP-\d+$/.test(ref)) { showMsg(rollenMsg, 'Type an online order reference, e.g. SHOP-2062.', 'error'); return; }
    rollenPreviewBtn.disabled = true;
    var orig = rollenPreviewBtn.textContent;
    rollenPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/roll-lengths-alert?ref=' + encodeURIComponent(ref));
      var pv = (d && d.preview) || null;
      if (pv) {
        rollenPreview.innerHTML = '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 0 0 6px;">Subject: <strong>' + vslaEsc(pv.subject || '') + '</strong></div>'
          + '<iframe title="Roll lengths alert preview" style="width: 100%; height: 320px; border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; background: #fff;" srcdoc="' + vslaEsc(pv.html || '') + '"></iframe>';
        rollenPreview.style.display = '';
      } else {
        rollenPreview.innerHTML = '';
        rollenPreview.style.display = 'none';
      }
      /* ⚠️ THE THREE ANSWERS ARE DIFFERENT AND ARE SAID DIFFERENTLY. "Nothing is missing"
         and "the switch is off" and "he was already told" all end in no email, and reading one as
         another is how somebody concludes the rail is broken when it is doing its job. */
      if (!pv) {
        showMsg(rollenMsg, ref + ' has no rolled flooring missing its cut lengths. Nothing would be sent.', 'success');
      } else if (d.alreadyToldHimAt) {
        showMsg(rollenMsg, 'This is the email. It was already sent for ' + ref + ' on ' + String(d.alreadyToldHimAt).slice(0, 10) + ', so it would not go again until the lengths are saved. Nothing was sent now.', 'success');
      } else if (!d.enabled) {
        showMsg(rollenMsg, 'This is the email ' + ref + ' would produce. The alert is switched OFF, so nothing is sent. Nothing was sent now.', 'success');
      } else {
        showMsg(rollenMsg, 'This is the email ' + ref + ' would produce. Nothing was sent now - the alert fires on a NEW order, not from this button.', 'success');
      }
      if (rollenStatus) {
        rollenStatus.textContent = (d.lines || 0) + ' line(s) with no cut lengths'
          + ' - goes to ' + ((d.to || []).join(', ') || 'ryan@blueskyfitsupply.com')
          + (d.metafieldsRead === false ? ' - WARNING: Shopify would not answer about the roll_width metafield, so only product names were checked.' : '');
      }
    } catch (e) {
      showMsg(rollenMsg, 'Could not check that order: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rollenPreviewBtn.disabled = false; rollenPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_ROLLLENGTHS_BY_CLAUDE */


/* CUSTOM_WDPHOTOCHECK_BY_CLAUDE (Ryan 2026-11-01) - Admin: Weight Designer Photo Check. One switch (the card),
   the model, and what the check has seen. Same load-from-server rule as the panels above: a failed load says so
   and leaves the box untouched, so a tick can never be saved on top of a value the page never read. */
var wdpEnabled = document.getElementById('settings-wdphoto-enabled');
var wdpModel = document.getElementById('settings-wdphoto-model');
var wdpBtn = document.getElementById('settings-wdphoto-btn');
var wdpMsg = document.getElementById('settings-wdphoto-msg');
var wdpStats = document.getElementById('settings-wdphoto-stats');
var wdpLoaded = false;

function wdpApply(data) {
  var cfg = (data && data.config) || {};
  /* `=== true`, the worker's own rule: an absent setting is OFF. */
  wdpEnabled.checked = cfg.enabled === true;
  if (wdpModel && Array.isArray(data && data.models)) {
    wdpModel.innerHTML = data.models.map(function(m) {
      return '<option value="' + vslaEsc(m.id) + '">' + vslaEsc(m.label) + '</option>';
    }).join('');
    wdpModel.value = cfg.model || '';
  }
  if (wdpStats && data && data.month) {
    var r = data.recent || {};
    wdpStats.textContent = 'This month: ' + (data.month.checks || 0) + ' upload' + (data.month.checks === 1 ? '' : 's') + ' checked, $'
      + Number(data.month.dollars || 0).toFixed(2) + ' of the $' + Number(data.month.capDollars || 0).toFixed(2) + ' monthly cap. '
      + 'Last ' + (r.count || 0) + ': ' + (r.logo || 0) + ' logo' + (r.logo === 1 ? '' : 's') + ', ' + (r.photo || 0) + ' photo' + (r.photo === 1 ? '' : 's')
      + (r.unknown ? ', ' + r.unknown + ' not answered' : '') + '.';
  }
}

if (wdpBtn && wdpEnabled) {
  (async function loadWdp() {
    try {
      var data = await window.RepPortal.API.get('/admin/wd-photo-check-config');
      wdpApply(data || {});
      wdpLoaded = true;
    } catch (e) {
      showMsg(wdpMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  wdpBtn.addEventListener('click', async function() {
    hideMsg(wdpMsg);
    if (!wdpLoaded) { showMsg(wdpMsg, 'The current setting has not loaded - reload before saving.', 'error'); return; }
    wdpBtn.disabled = true;
    var orig = wdpBtn.textContent;
    wdpBtn.textContent = 'Saving...';
    try {
      var body = { enabled: !!wdpEnabled.checked };
      if (wdpModel && wdpModel.value) body.model = wdpModel.value;
      var res = await window.RepPortal.API.post('/admin/wd-photo-check-config', body);
      var again = await window.RepPortal.API.get('/admin/wd-photo-check-config').catch(function() { return null; });
      wdpApply(again || res || {});
      showMsg(wdpMsg, res && res.config && res.config.enabled
        ? 'Saved - buyers who upload a photo now see the card. They can still use the file if it is their logo.'
        : 'Saved - the card is off. Uploads are still checked quietly and counted below.', 'success');
    } catch (e) {
      showMsg(wdpMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { wdpBtn.disabled = false; wdpBtn.textContent = orig; }
  });
}
/* END CUSTOM_WDPHOTOCHECK_BY_CLAUDE */

/* CUSTOM_WDAUTOQUOTE_BY_CLAUDE (Ryan 2026-11-02) - Admin: Weight Designer Auto Quote. One switch. Same load-from-server rule
   as the panels above: a failed load says so and leaves the box untouched, so a tick is never saved over an unread value. */
var wdaqEnabled = document.getElementById('settings-wdautoquote-enabled');
var wdaqBtn = document.getElementById('settings-wdautoquote-btn');
var wdaqMsg = document.getElementById('settings-wdautoquote-msg');
var wdaqStats = document.getElementById('settings-wdautoquote-stats');
var wdaqLoaded = false;

function wdaqApply(data) {
  var cfg = (data && data.config) || {};
  wdaqEnabled.checked = cfg.enabled === true; // the worker's own rule: absent is OFF
  if (wdaqStats) {
    var w = Number((data && data.waiting) || 0);
    wdaqStats.textContent = (cfg.enabled === true ? 'On' : 'Off')
      + (cfg.updatedBy ? ' (last changed by ' + cfg.updatedBy + ')' : '')
      + (w ? '. ' + w + ' lead' + (w === 1 ? '' : 's') + ' waiting for the next run.' : '.');
  }
}

if (wdaqBtn && wdaqEnabled) {
  (async function loadWdaq() {
    try {
      var data = await window.RepPortal.API.get('/admin/wd-auto-quote-config');
      wdaqApply(data || {});
      wdaqLoaded = true;
    } catch (e) {
      showMsg(wdaqMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  wdaqBtn.addEventListener('click', async function() {
    hideMsg(wdaqMsg);
    if (!wdaqLoaded) { showMsg(wdaqMsg, 'The current setting has not loaded - reload before saving.', 'error'); return; }
    wdaqBtn.disabled = true;
    var orig = wdaqBtn.textContent;
    wdaqBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/wd-auto-quote-config', { enabled: !!wdaqEnabled.checked });
      var again = await window.RepPortal.API.get('/admin/wd-auto-quote-config').catch(function() { return null; });
      wdaqApply(again || res || {});
      showMsg(wdaqMsg, res && res.config && res.config.enabled
        ? 'Saved - the next Weight Designer lead gets its quote built and freight requested within about two minutes.'
        : 'Saved - off. Weight Designer leads arrive without a quote, as before.', 'success');
    } catch (e) {
      showMsg(wdaqMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { wdaqBtn.disabled = false; wdaqBtn.textContent = orig; }
  });
}
/* END CUSTOM_WDAUTOQUOTE_BY_CLAUDE */

/* CUSTOM_SAMPLESCHASE_BY_CLAUDE (AIOPS 18391ebd69fa, Ryan 2026-09-14) — the ECORE samples chase: one
   switch and the two workday gaps. Load-from-server rule as the panels above: nothing is defaulted in
   the markup, and a failed load says so and leaves the boxes untouched, so a tick can never be saved
   on top of a value the page never read. */
var schaseEnabled = document.getElementById('settings-schase-enabled');
var schaseReportOnly = document.getElementById('settings-schase-reportonly');
var schaseFirst = document.getElementById('settings-schase-first');
var schaseSecond = document.getElementById('settings-schase-second');
var schaseBtn = document.getElementById('settings-schase-btn');
var schaseMsg = document.getElementById('settings-schase-msg');

if (schaseBtn && schaseEnabled) {
  (async function loadSchase() {
    try {
      var data = await window.RepPortal.API.get('/admin/samples-chase-config');
      var cfg = (data && data.config) || {};
      var off = Array.isArray(cfg.offsetWorkdays) ? cfg.offsetWorkdays : [];
      schaseEnabled.checked = cfg.enabled === true;
      /* ⚠️ `!== false`, matching the worker: an absent value REPORTS rather than sends, so the box
         must read ticked when the record says nothing. Defaulting it unticked here would show Ryan
         "sending" while the worker was still reporting. */
      if (schaseReportOnly) schaseReportOnly.checked = cfg.reportOnly !== false;
      schaseFirst.value = off[0];
      schaseSecond.value = off[1];
    } catch (e) {
      showMsg(schaseMsg, 'Could not load the samples-chase settings — reload before saving.', 'error');
    }
  })();
  schaseBtn.addEventListener('click', async function() {
    hideMsg(schaseMsg);
    var a = parseInt(schaseFirst.value, 10), b = parseInt(schaseSecond.value, 10);
    if (!isFinite(a) || a < 1 || a > 30) { showMsg(schaseMsg, 'First nudge: a whole number of workdays from 1 to 30.', 'error'); return; }
    if (!isFinite(b) || b < 1 || b > 30) { showMsg(schaseMsg, 'Second nudge: a whole number of workdays from 1 to 30.', 'error'); return; }
    schaseBtn.disabled = true; var orig = schaseBtn.textContent; schaseBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/samples-chase-config', { enabled: !!schaseEnabled.checked, reportOnly: schaseReportOnly ? !!schaseReportOnly.checked : true, offsetWorkdays: [a, b] });
      if (res && res.error) throw new Error(res.error);
      var c = (res && res.config) || {};
      var co = Array.isArray(c.offsetWorkdays) ? c.offsetWorkdays : [a, b];
      schaseEnabled.checked = c.enabled === true;
      if (schaseReportOnly) schaseReportOnly.checked = c.reportOnly !== false;
      schaseFirst.value = co[0]; schaseSecond.value = co[1];
      showMsg(schaseMsg, !c.enabled
        ? 'Saved — the chase is off. Unanswered samples requests sit silent, exactly as before.'
        : (c.reportOnly !== false
          ? 'Saved — REPORT ONLY. Nothing is emailed to ECORE; you get one email listing what it would have sent, and those requests keep their follow-ups.'
          : 'Saved — LIVE. An unanswered samples request is nudged after ' + co[0] + ' workdays, then again after ' + co[1] + ' more with Ryan copied. Nothing else goes out.'), 'success');
    } catch (e) {
      showMsg(schaseMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { schaseBtn.disabled = false; schaseBtn.textContent = orig; }
  });
}
/* END CUSTOM_SAMPLESCHASE_BY_CLAUDE */

/* CUSTOM_PODRIP_BY_CLAUDE (Ryan 2026-09-22) — the vendor PO follow-up drip: the switch, three workday
   gaps, the escalation gap, the last-nudge Cc, and the queue. Load-from-server rule as the panels
   above: nothing is defaulted in the markup, and a failed load says so and leaves the boxes untouched.
   ⚠️ The Cc box is the one field where BLANK is an answer ("copy nobody") and is sent as [] on purpose;
   the worker keeps an explicit empty list and only falls back to ryan@ when the field is ABSENT. */
var podripEnabled = document.getElementById('settings-podrip-enabled');
var podripCc = document.getElementById('settings-podrip-cc');
var podripBtn = document.getElementById('settings-podrip-btn');
var podripMsg = document.getElementById('settings-podrip-msg');
var podripLive = document.getElementById('settings-podrip-live');
var podripLiveMsg = document.getElementById('settings-podrip-live-msg');
var podripClosed = document.getElementById('settings-podrip-closed'); // CUSTOM_POACKJUDGE_BY_CLAUDE (Ryan 2026-10-02)
var podripClosedMsg = document.getElementById('settings-podrip-closed-msg');

if (podripBtn && podripEnabled) {
  var podripPaint = function(cfg) {
    /* CUSTOM_VENDORFOLLOWUPDAYS_BY_CLAUDE (ONYX bf6a05875ee5) - the days now live per supplier in the Vendor Guide. */
    podripEnabled.checked = cfg.enabled === true;
    podripCc.value = Array.isArray(cfg.finalStepCc) ? cfg.finalStepCc.join(', ') : '';
  };
  var podripEsc = function(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var podripRenderLive = function(live) {
    if (!podripLive) return;
    var rows = Array.isArray(live) ? live.slice() : [];
    if (!rows.length) { podripLive.textContent = 'Nothing queued. A PO enrols when it is sent while the switch is on.'; return; }
    rows.sort(function(a, b) { return String(a.sendAfter || '').localeCompare(String(b.sendAfter || '')); });
    var h = '<div style="display: grid; grid-template-columns: auto auto auto auto auto; gap: 4px 14px; align-items: center;">';
    h += '<strong>Deal</strong><strong>PO</strong><strong>Supplier</strong><strong>Next</strong><span></span>';
    rows.forEach(function(j) {
      var next = j.sendAfter ? String(j.sendAfter).slice(0, 10) : '-';
      var rung = (j.rung && j.of) ? ('nudge ' + j.rung + ' of ' + j.of + ' on ' + next) : next;
      h += '<span>' + podripEsc(j.ref || '') + '</span><span>' + podripEsc(j.poNumber || '') + '</span><span>' + podripEsc(j.vendor || '') + '</span><span>' + podripEsc(rung) + '</span>'
        + '<button type="button" class="rep-settings__submit" data-podrip-stop="' + podripEsc(j.poNumber || '') + '" style="padding: 2px 10px; font-size: 12px; margin: 0;">Stop</button>';
    });
    h += '</div>';
    podripLive.innerHTML = h;
  };
  /* CUSTOM_POACKJUDGE_BY_CLAUDE (AIOPS 5e5c2834d9bf, Ryan 2026-10-02) - POs the old any-reply rule closed. */
  var podripRenderClosed = function(rows) {
    if (!podripClosed) return;
    rows = Array.isArray(rows) ? rows : [];
    if (!rows.length) { podripClosed.textContent = 'None.'; return; }
    var h = '<div style="display: grid; grid-template-columns: auto auto auto auto auto; gap: 4px 14px; align-items: center;">';
    h += '<strong>Deal</strong><strong>PO</strong><strong>Supplier</strong><strong>Stopped</strong><span></span>';
    rows.forEach(function(r) {
      h += '<span>' + podripEsc(r.ref || '') + '</span><span>' + podripEsc(r.poNumber || '') + '</span><span>' + podripEsc(r.vendor || '') + '</span><span>'
        + podripEsc(String(r.closedAt || '').slice(0, 10)) + (r.stepsSent ? ' after ' + podripEsc(r.stepsSent) + ' nudge(s)' : '') + '</span>'
        + '<button type="button" class="rep-settings__submit" data-podrip-rearm="' + podripEsc(r.poNumber || '') + '" style="padding: 2px 10px; font-size: 12px; margin: 0;">Re-arm</button>';
    });
    podripClosed.innerHTML = h + '</div>';
  };
  var podripLoad = async function() {
    var data = await window.RepPortal.API.get('/admin/po-drip-config');
    if (data && data.error) throw new Error(data.error);
    podripPaint((data && data.config) || {});
    podripRenderLive(data && data.live);
    podripRenderClosed(data && data.closedOnReply);
  };
  if (podripClosed) {
    podripClosed.addEventListener('click', async function(ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-podrip-rearm]') : null;
      if (!btn) return;
      var po = btn.getAttribute('data-podrip-rearm');
      if (!po || !window.confirm('Re-arm the reminders on PO ' + po + '? Abby picks up where the follow-ups stopped and nudges the supplier until they confirm the PO.')) return;
      hideMsg(podripClosedMsg);
      btn.disabled = true;
      try {
        var res = await window.RepPortal.API.post('/admin/po-drip', { poNumber: po, action: 'rearm' });
        if (res && res.error) throw new Error(res.error);
        if (res && res.rearmed === false) throw new Error(res.hint || res.reason || 'not re-armed');
        showMsg(podripClosedMsg, 'Re-armed PO ' + po + '. Next nudge ' + String((res && res.sendAfter) || '').slice(0, 10) + ' unless the supplier confirms.', 'success');
        await podripLoad();
      } catch (e3) {
        showMsg(podripClosedMsg, 'Could not re-arm PO ' + po + ': ' + (e3 && e3.message ? e3.message : 'unknown error'), 'error');
        btn.disabled = false;
      }
    });
  }
  (async function loadPodrip() {
    try { await podripLoad(); }
    catch (e) {
      showMsg(podripMsg, 'Could not load the PO follow-up settings — reload before saving.', 'error');
      if (podripLive) podripLive.textContent = 'Could not load the queue.';
    }
  })();
  podripBtn.addEventListener('click', async function() {
    hideMsg(podripMsg);
    var cc = String(podripCc.value || '').split(/[,;\s]+/).map(function(s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var badCc = cc.filter(function(s) { return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s); });
    if (badCc.length) { showMsg(podripMsg, 'Copy on the third nudge: "' + badCc[0] + '" is not an email address.', 'error'); return; }
    if (cc.length > 5) { showMsg(podripMsg, 'Copy on the third nudge: at most five addresses.', 'error'); return; }
    podripBtn.disabled = true; var orig = podripBtn.textContent; podripBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/po-drip-config', { enabled: !!podripEnabled.checked, finalStepCc: cc });
      if (res && res.error) throw new Error(res.error);
      var saved = (res && res.config) || {};
      podripPaint(saved);
      var sc = Array.isArray(saved.finalStepCc) ? saved.finalStepCc : [];
      showMsg(podripMsg, !saved.enabled
        ? 'Saved — the follow-ups are off. A PO sent now is not enrolled; anything already queued is held, not dropped.'
        : 'Saved - LIVE. Each PO is nudged on the Vendor Guide days for its supplier (default 3 supplier days), each nudge a [TEST] to you first; the last one'
          + (sc.length ? ' copies ' + sc.join(', ') : ' copies nobody') + '. It stops the moment the supplier confirms the PO or the order ships.', 'success');
    } catch (e2) {
      showMsg(podripMsg, 'Could not save: ' + (e2 && e2.message ? e2.message : 'unknown error'), 'error');
    } finally { podripBtn.disabled = false; podripBtn.textContent = orig; }
  });
  if (podripLive) {
    podripLive.addEventListener('click', async function(ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-podrip-stop]') : null;
      if (!btn) return;
      var po = btn.getAttribute('data-podrip-stop');
      if (!po || !window.confirm('Stop the follow-ups on PO ' + po + '? Nothing more is emailed to the supplier for this PO, and it will not re-arm unless a new PO is sent.')) return;
      hideMsg(podripLiveMsg);
      btn.disabled = true; btn.textContent = 'Stopping...';
      try {
        var r = await window.RepPortal.API.post('/admin/po-drip', { poNumber: po, action: 'stop' });
        if (r && r.error) throw new Error(r.error);
        showMsg(podripLiveMsg, 'Stopped the follow-ups on PO ' + po + '.', 'success');
        try { await podripLoad(); } catch (e3) { /* the stop is the answer; the list refreshes on reload */ }
      } catch (e4) {
        showMsg(podripLiveMsg, 'Could not stop PO ' + po + ': ' + (e4 && e4.message ? e4.message : 'unknown error'), 'error');
        btn.disabled = false; btn.textContent = 'Stop';
      }
    });
  }
}
/* END CUSTOM_PODRIP_BY_CLAUDE */

/* CUSTOM_ABBYEXTERNAL_BY_CLAUDE (AIOPS 771d2dcf1126, Ryan 2026-09-18) — Admin: Abby Sends After My Reply
   On A Test. TWO buttons over ONE record (GET/POST /admin/abby-external-config), each POSTing only its
   own field — the route treats an omitted field as "keep what is stored", so the switch and the list
   cannot clobber each other. Nothing is defaulted in the markup: the tick and the addresses are read
   from the server, because a default written twice is a screen that goes on showing the old one the
   first time the worker changes its mind.
   CUSTOM_ONERELEASE_BY_CLAUDE (Ryan 2026-09-21): the record's `replyRelease` is THE switch every TEST
   kind reads (outside email, customer reply, truckload RFQ, whatever comes next); the per-rail
   switches and the allowlist are gone, and the list is a denylist (`denyTo`). */
var arEnabled = document.getElementById('settings-abbyreplyrelease-enabled');
var arBtn = document.getElementById('settings-abbyreplyrelease-btn');
var arMsg = document.getElementById('settings-abbyreplyrelease-msg');
var axDeny = document.getElementById('settings-abbyexternal-deny');
var axDenyBtn = document.getElementById('settings-abbyexternal-deny-btn');
var axDenyMsg = document.getElementById('settings-abbyexternal-deny-msg');
/* CUSTOM_SHAREDINBOX_BY_CLAUDE (AIOPS 4f49348535f1, Ryan 2026-09-24) - the shared-inbox list, its own button */
var axShared = document.getElementById('settings-abbyexternal-shared');
var axSharedBtn = document.getElementById('settings-abbyexternal-shared-btn');
var axSharedMsg = document.getElementById('settings-abbyexternal-shared-msg');
/* CUSTOM_TESTRECALL_BY_CLAUDE (AIOPS c53de6753aab, Ryan 2026-09-30) - the recall switch, its own button over the same record */
var atrEnabled = document.getElementById('settings-abbytestrecall-enabled');
var atrBtn = document.getElementById('settings-abbytestrecall-btn');
var atrMsg = document.getElementById('settings-abbytestrecall-msg');
/* CUSTOM_TESTDELETE_BY_CLAUDE (ONYX 0c34dc68f96d, Ryan 2026-10-03) - delete = discard, its own button over the same record */
var atdEnabled = document.getElementById('settings-abbytestdelete-enabled');
var atdBtn = document.getElementById('settings-abbytestdelete-btn');
var atdMsg = document.getElementById('settings-abbytestdelete-msg');
/* CUSTOM_TESTFILED_BY_CLAUDE (ONYX f19ab7d1451f, Ryan 2026-10-07) - file a released TEST, its own button over the same record */
var atfEnabled = document.getElementById('settings-abbytestfiled-enabled');
var atfBtn = document.getElementById('settings-abbytestfiled-btn');
var atfMsg = document.getElementById('settings-abbytestfiled-msg');
/* CUSTOM_RYANNAMEDCC_BY_CLAUDE (ONYX 262192359aa0, Ryan 2026-10-16) - a Cc Ryan named in chat, its own button over the same record */
var arcEnabled = document.getElementById('settings-abbyryancc-enabled');
var arcBtn = document.getElementById('settings-abbyryancc-btn');
var arcMsg = document.getElementById('settings-abbyryancc-msg');
if (arBtn && arEnabled) {
  var arPaint = function(c) {
    arEnabled.checked = !!(c && c.replyRelease === true);
    if (atrEnabled) atrEnabled.checked = !!(c && c.recallUnread === true); // CUSTOM_TESTRECALL_BY_CLAUDE
    if (atdEnabled) atdEnabled.checked = !!(c && c.deleteDiscards === true); // CUSTOM_TESTDELETE_BY_CLAUDE
    if (atfEnabled) atfEnabled.checked = !!(c && c.fileReleased === true); // CUSTOM_TESTFILED_BY_CLAUDE
    if (arcEnabled) arcEnabled.checked = !!(c && c.ryanNamedCc === true); // CUSTOM_RYANNAMEDCC_BY_CLAUDE
    if (axDeny && c && Array.isArray(c.denyTo)) axDeny.value = c.denyTo.join('\n');
    if (axShared && c && Array.isArray(c.sharedInboxes)) axShared.value = c.sharedInboxes.join('\n'); // CUSTOM_SHAREDINBOX_BY_CLAUDE
  };
  (async function loadAr() {
    try {
      arPaint(await window.RepPortal.API.get('/admin/abby-external-config'));
    } catch (e) {
      showMsg(arMsg, 'Could not load the current setting — reload before saving.', 'error');
    }
  })();
  arBtn.addEventListener('click', async function() {
    hideMsg(arMsg);
    arBtn.disabled = true;
    var orig = arBtn.textContent;
    arBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/abby-external-config', { replyRelease: !!arEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      arPaint(res);
      showMsg(arMsg, res && res.replyRelease
        ? 'Saved — replying send on any of Abby’s tests now really sends it: an outside email to the address it names, a customer reply on their thread, a truckload request to GoRocket. An agent still cannot send one by itself.'
        : 'Saved — your reply sends nothing by itself. Every test still reaches you and says so in red; your reply wakes the agent instead.', 'success');
    } catch (e) {
      showMsg(arMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      arBtn.disabled = false;
      arBtn.textContent = orig;
    }
  });
}
/* CUSTOM_TESTRECALL_BY_CLAUDE (AIOPS c53de6753aab) - posts ONLY `recallUnread`; the route keeps the send switch and
   both lists as stored. The tick is painted by arPaint above, from the server. */
if (atrBtn && atrEnabled) {
  atrBtn.addEventListener('click', async function() {
    hideMsg(atrMsg);
    atrBtn.disabled = true;
    var orig = atrBtn.textContent;
    atrBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/abby-external-config', { recallUnread: !!atrEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      atrEnabled.checked = !!(res && res.recallUnread === true);
      if (arEnabled) arEnabled.checked = !!(res && res.replyRelease === true);
      showMsg(atrMsg, res && res.recallUnread
        ? 'Saved - a withdrawn or replaced test now leaves your inbox (to Deleted Items), opened or not.'
        : 'Saved - nothing reads your inbox; a withdrawn test just stays where it is and can no longer be sent.', 'success');
    } catch (e) {
      showMsg(atrMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      atrBtn.disabled = false;
      atrBtn.textContent = orig;
    }
  });
}
/* CUSTOM_TESTFILED_BY_CLAUDE (ONYX f19ab7d1451f) - posts ONLY `fileReleased`; the route keeps every other field as stored. */
if (atfBtn && atfEnabled) {
  atfBtn.addEventListener('click', async function() {
    hideMsg(atfMsg);
    atfBtn.disabled = true;
    var orig = atfBtn.textContent;
    atfBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/abby-external-config', { fileReleased: !!atfEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      atfEnabled.checked = !!(res && res.fileReleased === true);
      showMsg(atfMsg, res && res.fileReleased
        ? 'Saved - a test you release now moves into Inbox > AI > TESTS once the real email goes.'
        : 'Saved - a released test stays in your Inbox.', 'success');
    } catch (e) {
      showMsg(atfMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      atfBtn.disabled = false;
      atfBtn.textContent = orig;
    }
  });
}
/* CUSTOM_RYANNAMEDCC_BY_CLAUDE - posts ONLY `ryanNamedCc`; the route keeps every other field as stored. */
if (arcBtn && arcEnabled) {
  arcBtn.addEventListener('click', async function() {
    hideMsg(arcMsg);
    arcBtn.disabled = true;
    var orig = arcBtn.textContent;
    arcBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/abby-external-config', { ryanNamedCc: !!arcEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      arcEnabled.checked = !!(res && res.ryanNamedCc === true);
      showMsg(arcMsg, res && res.ryanNamedCc
        ? 'Saved - an agent may now copy one address you named in chat, on a test to you only.'
        : 'Saved - agents copy only our own mailboxes and the customer\'s or supplier\'s own company.', 'success');
    } catch (e) {
      showMsg(arcMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      arcBtn.disabled = false;
      arcBtn.textContent = orig;
    }
  });
}
/* CUSTOM_TESTDELETE_BY_CLAUDE (ONYX 0c34dc68f96d) - posts ONLY `deleteDiscards`; the route keeps every other field as
   stored. The tick is painted by arPaint above, from the server. */
if (atdBtn && atdEnabled) {
  atdBtn.addEventListener('click', async function() {
    hideMsg(atdMsg);
    atdBtn.disabled = true;
    var orig = atdBtn.textContent;
    atdBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/abby-external-config', { deleteDiscards: !!atdEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      atdEnabled.checked = !!(res && res.deleteDiscards === true);
      if (arEnabled) arEnabled.checked = !!(res && res.replyRelease === true);
      if (atrEnabled) atrEnabled.checked = !!(res && res.recallUnread === true);
      showMsg(atdMsg, res && res.deleteDiscards
        ? 'Saved - deleting a test that is still waiting for your send now discards it (checked every 15 minutes).'
        : 'Saved - deleting a test only tidies your inbox; it stays pending until you reply.', 'success');
    } catch (e) {
      showMsg(atdMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      atdBtn.disabled = false;
      atdBtn.textContent = orig;
    }
  });
}
/* CUSTOM_SHAREDINBOX_BY_CLAUDE (AIOPS 4f49348535f1) - posts ONLY its own field; the route keeps the
   others as stored, so this button cannot clear the switch or the denylist. */
if (axSharedBtn && axShared) {
  axSharedBtn.addEventListener('click', async function() {
    hideMsg(axSharedMsg);
    var list = axShared.value.split(/[\n,;]+/).map(function(s) { return s.trim(); }).filter(Boolean);
    axSharedBtn.disabled = true;
    var orig = axSharedBtn.textContent;
    axSharedBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/abby-external-config', { sharedInboxes: list });
      if (res && res.error) throw new Error(res.error);
      var kept = (res && res.sharedInboxes) || [];
      axShared.value = kept.join('\n');
      showMsg(axSharedMsg, kept.length === 0
        ? 'Saved - no inbox is treated as shared; a new email may greet anybody.'
        : (kept.length === list.length
            ? 'Saved - a new email to ' + kept.join(', ') + ' opens with Hi Team,.'
            : 'Saved - a new email to ' + kept.join(', ') + ' opens with Hi Team,. Anything not kept was one of our own addresses or not an address.'), 'success');
    } catch (e) {
      showMsg(axSharedMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      axSharedBtn.disabled = false;
      axSharedBtn.textContent = orig;
    }
  });
}
if (axDenyBtn && axDeny) {
  axDenyBtn.addEventListener('click', async function() {
    hideMsg(axDenyMsg);
    var list = axDeny.value.split(/[\n,;]+/).map(function(s) { return s.trim(); }).filter(Boolean);
    axDenyBtn.disabled = true;
    var orig = axDenyBtn.textContent;
    axDenyBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/abby-external-config', { denyTo: list });
      if (res && res.error) throw new Error(res.error);
      var kept = (res && res.denyTo) || [];
      if (axDeny) axDeny.value = kept.join('\n');
      if (arEnabled) arEnabled.checked = !!(res && res.replyRelease === true);
      /* ⚠️ The worker drops anything that is not an outside address (ours are refused regardless), so SAY
         what was kept rather than reporting a success over a list that quietly lost a line. */
      showMsg(axDenyMsg, kept.length === 0
        ? 'Saved — no addresses are blocked; any outside address your reply names is allowed.'
        : (kept.length === list.length
            ? 'Saved — Abby will never write to ' + kept.join(', ') + '.'
            : 'Saved — Abby will never write to ' + kept.join(', ') + '. Anything not kept was one of our own addresses or not an address.'), 'success');
    } catch (e) {
      showMsg(axDenyMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      axDenyBtn.disabled = false;
      axDenyBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_ABBYEXTERNAL_BY_CLAUDE */

/* CUSTOM_ENTITYGREETING_BY_CLAUDE (ONYX f3aa8802c856, Ryan 2026-10-08) - Admin: Company-Name Greetings. Loaded from the
   server, never defaulted in the markup, so a Save can never write words the page did not read. */
var bgWords = document.getElementById('settings-buyergreeting-words');
var bgLead = document.getElementById('settings-buyergreeting-leadwords');
var bgBtn = document.getElementById('settings-buyergreeting-btn');
var bgDefaultsBtn = document.getElementById('settings-buyergreeting-defaults');
var bgMsg = document.getElementById('settings-buyergreeting-msg');
var bgStatus = document.getElementById('settings-buyergreeting-status');
var bgLoaded = false;
var bgDefaults = null;
function bgApply(d) {
  var c = (d && d.config) || {};
  bgWords.value = (c.words || []).join(', ');
  bgLead.value = (c.leadWords || []).join(', ');
  if (d && d.defaults) bgDefaults = d.defaults;
  if (bgStatus) bgStatus.textContent = d && d.saved === false ? 'Using the built-in words (nothing saved yet).'
    : (d && d.updatedAt ? 'Last saved ' + new Date(d.updatedAt).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) + (d.updatedBy ? ' by ' + d.updatedBy : '') + '.' : '');
}
if (bgBtn && bgWords && bgLead) {
  (async function loadBg() {
    try {
      var data = await window.RepPortal.API.get('/admin/buyer-greeting-config');
      bgApply(data);
      bgLoaded = true;
    } catch (e) {
      showMsg(bgMsg, 'Could not load the current words - reload before saving.', 'error');
    }
  })();
  bgBtn.addEventListener('click', async function() {
    hideMsg(bgMsg);
    if (!bgLoaded) { showMsg(bgMsg, 'The current words never loaded - reload the page first.', 'error'); return; }
    bgBtn.disabled = true;
    var orig = bgBtn.textContent;
    bgBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/buyer-greeting-config', { words: String(bgWords.value || ''), leadWords: String(bgLead.value || '') });
      bgApply({ config: res.config, saved: true, updatedAt: new Date().toISOString() });
      showMsg(bgMsg, 'Saved. The next Abby email reads these words.', 'success');
    } catch (e) {
      showMsg(bgMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { bgBtn.disabled = false; bgBtn.textContent = orig; }
  });
  if (bgDefaultsBtn) bgDefaultsBtn.addEventListener('click', function() {
    if (!bgDefaults) return;
    bgWords.value = (bgDefaults.words || []).join(', ');
    bgLead.value = (bgDefaults.leadWords || []).join(', ');
    showMsg(bgMsg, 'The built-in words are in the boxes. Press Save to keep them.', 'success');
  });
}
/* END CUSTOM_ENTITYGREETING_BY_CLAUDE */

/* CUSTOM_ORDERWATCHDOG_BY_CLAUDE (ONYX card 794a478b9432) - Admin: Order Lifecycle Watchdog. Same load-from-server
   rule as every other panel here: nothing is defaulted in the markup, so a Save can never write a value the page
   did not read. */
var owEnabled = document.getElementById('settings-orderwatchdog-enabled');
var owBtn = document.getElementById('settings-orderwatchdog-btn');
var owMsg = document.getElementById('settings-orderwatchdog-msg');
var owLoaded = false;

if (owBtn && owEnabled) {
  (async function loadOw() {
    try {
      var data = await window.RepPortal.API.get('/admin/order-watchdog-config');
      owEnabled.checked = !!(data.config && data.config.enabled === true);
      owLoaded = true;
    } catch (e) {
      showMsg(owMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  owBtn.addEventListener('click', async function() {
    hideMsg(owMsg);
    if (!owLoaded) { showMsg(owMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    owBtn.disabled = true;
    var orig = owBtn.textContent;
    owBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/order-watchdog-config', { enabled: !!owEnabled.checked });
      owEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(owMsg, owEnabled.checked ? 'Saved - on. The next scheduled run (7:15 AM / 1:15 PM Mountain, weekdays) checks every deal.' : 'Saved - off. Nothing is checked, no rows open, no email sends.', 'success');
    } catch (e) {
      showMsg(owMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { owBtn.disabled = false; owBtn.textContent = orig; }
  });
}
/* END CUSTOM_ORDERWATCHDOG_BY_CLAUDE */

/* CUSTOM_WATCHDOGSNOOZE_BY_CLAUDE (ONYX card 2d8143d84533, Ryan 2026-10-27) - the hit list + Snooze. GET /order-watchdog
   is the same dry run an agent reads (works on or off, already drops snoozed hits); POST /order-watchdog-snooze takes
   the dedupKey the worker builds as order-watchdog:{REF}:{check}. Loads on the button only - every load is a full check. */
var owHitsBtn = document.getElementById('settings-orderwatchdog-hits-btn');
var owHits = document.getElementById('settings-orderwatchdog-hits');
var OW_TITLES = { 1: 'Signed PDF never recorded', 3: 'Signed, not paid yet, getting old', 4: 'Paid or sold, no next step', 5: 'Sold, nothing tracking it' };

function owHitRow(h) {
  var ref = String(h.ref || '').toUpperCase();
  var key = 'order-watchdog:' + ref + ':' + h.check;
  var why = String(h.reason || '').replace(/\s*\(POST [^)]*\)\.?$/, '');
  return '<div class="ow-hit" data-key="' + vslaEsc(key) + '" style="border: 1px solid var(--rq-border, #1e2a42); border-radius: 8px; padding: 8px 10px; margin: 0 0 6px;">'
    + '<div style="display: flex; gap: 8px; align-items: center; justify-content: space-between;">'
    + '<div style="font-size: 14px;"><strong>' + vslaEsc(ref) + '</strong> &middot; ' + vslaEsc(OW_TITLES[h.check] || 'Watchdog hit') + '</div>'
    + '<button type="button" class="rep-settings__submit ow-snooze-open" style="margin: 0; padding: 4px 12px;">Snooze</button></div>'
    + '<div style="font-size: 12px; color: var(--rq-text-secondary); margin-top: 4px;">' + vslaEsc(why) + '</div>'
    + '<div class="ow-snooze-form" style="display: none; margin-top: 8px;">'
    + '<input type="text" class="ow-snooze-reason" placeholder="Why snooze it (e.g. customer delayed install to Dec)" style="width: 100%; margin: 0 0 6px;">'
    + '<div style="font-size: 13px; margin: 0 0 6px;">For: '
    + [3, 7, 30].map(function(n) { return '<label style="margin-right: 10px;"><input type="radio" name="ow-days-' + vslaEsc(key) + '" value="' + n + '"' + (n === 3 ? ' checked' : '') + '> ' + n + ' days</label>'; }).join('')
    + '</div><button type="button" class="rep-settings__submit ow-snooze-go" style="margin: 0 6px 0 0; padding: 4px 12px;">Confirm snooze</button>'
    + '<button type="button" class="rep-settings__submit ow-snooze-cancel" style="margin: 0; padding: 4px 12px; opacity: 0.7;">Cancel</button>'
    + '<p class="rep-settings__message ow-snooze-msg"></p></div></div>';
}

if (owHitsBtn && owHits) {
  owHitsBtn.addEventListener('click', async function() {
    owHitsBtn.disabled = true;
    var orig = owHitsBtn.textContent;
    owHitsBtn.textContent = 'Checking every deal...';
    try {
      var d = await window.RepPortal.API.get('/order-watchdog');
      var hits = Array.isArray(d && d.hits) ? d.hits.filter(function(h) { return h && h.ref; }) : [];
      var head = '<div style="font-size: 12px; color: var(--rq-text-secondary); margin: 0 0 6px;">'
        + (d && d.dealsChecked != null ? d.dealsChecked + ' deals checked. ' : '')
        + (hits.length ? hits.length + ' would be flagged now. Snoozed ones are left out.' : 'Nothing would be flagged now.')
        + (d && d.partial ? ' The deal list is still being built, so this may be missing some.' : '') + '</div>';
      owHits.innerHTML = head + hits.map(owHitRow).join('');
    } catch (e) {
      owHits.innerHTML = '<p class="rep-settings__message"></p>';
      showMsg(owHits.firstChild, 'Could not load the list: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      owHits.style.display = '';
      owHitsBtn.disabled = false; owHitsBtn.textContent = orig;
    }
  });

  owHits.addEventListener('click', async function(ev) {
    var row = ev.target.closest('.ow-hit');
    if (!row) return;
    var form = row.querySelector('.ow-snooze-form');
    var msg = row.querySelector('.ow-snooze-msg');
    if (ev.target.closest('.ow-snooze-open')) { form.style.display = ''; row.querySelector('.ow-snooze-reason').focus(); return; }
    if (ev.target.closest('.ow-snooze-cancel')) { form.style.display = 'none'; hideMsg(msg); return; }
    var go = ev.target.closest('.ow-snooze-go');
    if (!go) return;
    hideMsg(msg);
    var reason = row.querySelector('.ow-snooze-reason').value.trim();
    if (reason.length < 4) { showMsg(msg, 'Write a short reason first (4 letters or more).', 'error'); return; }
    var picked = row.querySelector('input[type="radio"]:checked');
    var days = picked ? parseInt(picked.value, 10) : 3;
    go.disabled = true;
    try {
      var res = await window.RepPortal.API.post('/order-watchdog-snooze', { dedupKey: row.getAttribute('data-key'), reason: reason, days: days });
      var until = res && res.snoozed && res.snoozed.until;
      row.innerHTML = '<div style="font-size: 13px; color: var(--rq-text-secondary);">Snoozed <strong>' + vslaEsc(row.getAttribute('data-key').split(':')[1]) + '</strong> until '
        + vslaEsc(vslaWhen(until)) + ': ' + vslaEsc(reason) + '</div>';
    } catch (e) {
      showMsg(msg, 'Could not snooze: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      go.disabled = false;
    }
  });
}
/* END CUSTOM_WATCHDOGSNOOZE_BY_CLAUDE */

/* CUSTOM_VENDORCONTACTCAPTURE_BY_CLAUDE (ALFRED card 7db7cb4bce90) - Admin: Vendor Contact Capture. Same load-from-server
   rule as every other panel here: nothing is defaulted in the markup, so a Save can never write a value the page
   did not read. */
var vccEnabled = document.getElementById('settings-vendorcontactcapture-enabled');
var vccBtn = document.getElementById('settings-vendorcontactcapture-btn');
var vccMsg = document.getElementById('settings-vendorcontactcapture-msg');
var vccLoaded = false;

if (vccBtn && vccEnabled) {
  (async function loadVcc() {
    try {
      var data = await window.RepPortal.API.get('/admin/vendor-contact-capture-config');
      vccEnabled.checked = !!(data.config && data.config.enabled === true);
      vccLoaded = true;
    } catch (e) {
      showMsg(vccMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  vccBtn.addEventListener('click', async function() {
    hideMsg(vccMsg);
    if (!vccLoaded) { showMsg(vccMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    vccBtn.disabled = true;
    var orig = vccBtn.textContent;
    vccBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/vendor-contact-capture-config', { enabled: !!vccEnabled.checked });
      vccEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(vccMsg, vccEnabled.checked ? 'Saved - on. New supplier contacts from arriving mail are listed for Alfred to confirm.' : 'Saved - off. Nothing is read or listed.', 'success');
    } catch (e) {
      showMsg(vccMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { vccBtn.disabled = false; vccBtn.textContent = orig; }
  });
}
/* END CUSTOM_VENDORCONTACTCAPTURE_BY_CLAUDE */
/* CUSTOM_BOLUSPSCITY_BY_CLAUDE (ONYX card f3e6ea3bcc1a) - Admin: BOL City Check. Same load-from-server rule as every other
   panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var bcuEnabled = document.getElementById('settings-bolcityusps-enabled');
var bcuBtn = document.getElementById('settings-bolcityusps-btn');
var bcuMsg = document.getElementById('settings-bolcityusps-msg');
var bcuLoaded = false;

if (bcuBtn && bcuEnabled) {
  (async function loadBcu() {
    try {
      var data = await window.RepPortal.API.get('/admin/bol-city-usps-config');
      bcuEnabled.checked = !!(data.config && data.config.enabled === true);
      bcuLoaded = true;
    } catch (e) {
      showMsg(bcuMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  bcuBtn.addEventListener('click', async function() {
    hideMsg(bcuMsg);
    if (!bcuLoaded) { showMsg(bcuMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    bcuBtn.disabled = true;
    var orig = bcuBtn.textContent;
    bcuBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/bol-city-usps-config', { enabled: !!bcuEnabled.checked });
      bcuEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(bcuMsg, bcuEnabled.checked ? 'Saved - on. A Post Office city for the ZIP passes when the street and ZIP match.' : 'Saved - off. Any city difference holds the BOL email.', 'success');
    } catch (e) {
      showMsg(bcuMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { bcuBtn.disabled = false; bcuBtn.textContent = orig; }
  });
}
/* END CUSTOM_BOLUSPSCITY_BY_CLAUDE */
/* CUSTOM_BOLGATEPANEL_BY_CLAUDE (ONYX cards ae8bfdb2a2fd + 09fcc2bc93fa, Ryan 2026-10-26) - Admin: BOL Ship Gate. The switch
   lib/bol-ship-gate.js reads; it had no panel and was turned on from the console. Loaded from the server, never defaulted. */
var bsgEnabled = document.getElementById('settings-bolshipgate-enabled');
var bsgBtn = document.getElementById('settings-bolshipgate-btn');
var bsgMsg = document.getElementById('settings-bolshipgate-msg');
var bsgLoaded = false;

if (bsgBtn && bsgEnabled) {
  (async function loadBsg() {
    try {
      var data = await window.RepPortal.API.get('/admin/bol-ship-gate-config');
      bsgEnabled.checked = !!(data.config && data.config.enabled === true);
      bsgLoaded = true;
    } catch (e) {
      showMsg(bsgMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  bsgBtn.addEventListener('click', async function() {
    hideMsg(bsgMsg);
    if (!bsgLoaded) { showMsg(bsgMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    bsgBtn.disabled = true;
    var orig = bsgBtn.textContent;
    bsgBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/bol-ship-gate-config', { enabled: !!bsgEnabled.checked });
      bsgEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(bsgMsg, bsgEnabled.checked ? 'Saved - on. The ship-date email waits for a BOL on the deal.' : 'Saved - off. The ship-date email goes when the load is booked.', 'success');
    } catch (e) {
      showMsg(bsgMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { bsgBtn.disabled = false; bsgBtn.textContent = orig; }
  });
}

/* Admin: Freight Request Backfill (ONYX cards 9baa31abcad4 + 09fcc2bc93fa). The switch, a trial run that wakes nobody, and the
   real run, which the worker refuses while the switch is off. */
var frbEnabled = document.getElementById('settings-freightbackfill-enabled');
var frbBtn = document.getElementById('settings-freightbackfill-btn');
var frbTrial = document.getElementById('settings-freightbackfill-trial');
var frbRun = document.getElementById('settings-freightbackfill-run');
var frbMsg = document.getElementById('settings-freightbackfill-msg');
var frbOut = document.getElementById('settings-freightbackfill-out');
var frbLoaded = false;

function frbWhen(iso) {
  var t = Date.parse(iso || '');
  if (!isFinite(t)) return '';
  try { return new Date(t).toLocaleString('en-US', { timeZone: 'America/Denver', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) + ' MT'; } catch (_) { return ''; }
}

function frbRender(run, dry) {
  frbOut.textContent = '';
  if (!run) return;
  var head = document.createElement('p');
  head.style.margin = '0 0 6px';
  var n = Array.isArray(run.list) ? run.list.length : 0;
  var words = 'Read ' + (run.scanned || 0) + ' deals. ' + (run.candidates || 0) + ' have Request Freight pressed with a supplier still not asked. ';
  if (!n) words += 'Nobody was missed: every one of them is already with the Order Desk.';
  else if (dry) words += n + (n === 1 ? ' was' : ' were') + ' never handed to anybody. Run now would wake Onyx for ' + (n === 1 ? 'it' : 'each') + ':';
  else words += 'Woke Onyx for ' + (run.woke || 0) + ' of ' + n + ':';
  if (run.truncated) words += ' (Only part of the board was read; run it again for the rest.)';
  head.textContent = words;
  frbOut.appendChild(head);
  if (!n) return;
  var ul = document.createElement('ul');
  ul.style.margin = '0 0 0 18px';
  run.list.forEach(function(g) {
    var li = document.createElement('li');
    var others = (g.refs || []).filter(function(r) { return r !== g.lead; });
    li.textContent = g.lead + (others.length ? ' (with ' + others.join(', ') + ')' : '');
    ul.appendChild(li);
  });
  frbOut.appendChild(ul);
}

if (frbBtn && frbEnabled && frbTrial && frbRun && frbOut) {
  (async function loadFrb() {
    try {
      var data = await window.RepPortal.API.get('/admin/freight-request-backfill-config');
      frbEnabled.checked = !!(data.config && data.config.enabled === true);
      frbLoaded = true;
      var last = data.lastRun;
      if (last && last.at) showMsg(frbMsg, 'Last real run ' + frbWhen(last.at) + ': woke Onyx for ' + (last.woke || 0) + '.', 'success');
    } catch (e) {
      showMsg(frbMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  frbBtn.addEventListener('click', async function() {
    hideMsg(frbMsg);
    if (!frbLoaded) { showMsg(frbMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    frbBtn.disabled = true;
    var orig = frbBtn.textContent;
    frbBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/freight-request-backfill-config', { enabled: !!frbEnabled.checked });
      frbEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(frbMsg, frbEnabled.checked ? 'Saved - on. Run now will wake Onyx for each deal it finds.' : 'Saved - off. Run now is refused; Trial run still works.', 'success');
    } catch (e) {
      showMsg(frbMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { frbBtn.disabled = false; frbBtn.textContent = orig; }
  });

  frbTrial.addEventListener('click', async function() {
    hideMsg(frbMsg);
    frbTrial.disabled = true;
    var orig = frbTrial.textContent;
    frbTrial.textContent = 'Checking...';
    try {
      var res = await window.RepPortal.API.get('/admin/freight-request-backfill');
      frbRender(res.run, true);
    } catch (e) {
      showMsg(frbMsg, 'Trial run failed: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { frbTrial.disabled = false; frbTrial.textContent = orig; }
  });

  frbRun.addEventListener('click', async function() {
    hideMsg(frbMsg);
    if (!frbEnabled.checked) { showMsg(frbMsg, 'Tick "Allow the catch-up to wake Onyx" and Save first.', 'error'); return; }
    if (!window.confirm('Wake Onyx once for each deal the catch-up finds?')) return;
    frbRun.disabled = true;
    var orig = frbRun.textContent;
    frbRun.textContent = 'Running...';
    try {
      var res = await window.RepPortal.API.post('/admin/freight-request-backfill', {});
      frbRender(res.run, false);
    } catch (e) {
      showMsg(frbMsg, 'Run failed: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { frbRun.disabled = false; frbRun.textContent = orig; }
  });
}
/* END CUSTOM_BOLGATEPANEL_BY_CLAUDE */
/* CUSTOM_SIGNEDACKRELEASE_BY_CLAUDE (ONYX card 02090c069b26) - Admin: Signed-Proposal Auto-Reply. Same load-from-server rule as every
   other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var soaEnabled = document.getElementById('settings-signedorderack-enabled');
var soaBtn = document.getElementById('settings-signedorderack-btn');
var soaMsg = document.getElementById('settings-signedorderack-msg');
var soaLoaded = false;

if (soaBtn && soaEnabled) {
  (async function loadSoa() {
    try {
      var data = await window.RepPortal.API.get('/admin/signed-order-inbound-config');
      soaEnabled.checked = !!(data.config && data.config.enabled === true);
      soaLoaded = true;
    } catch (e) {
      showMsg(soaMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  soaBtn.addEventListener('click', async function() {
    hideMsg(soaMsg);
    if (!soaLoaded) { showMsg(soaMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    soaBtn.disabled = true;
    var orig = soaBtn.textContent;
    soaBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/signed-order-inbound-config', { enabled: !!soaEnabled.checked });
      soaEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(soaMsg, soaEnabled.checked ? 'Saved - on. A recorded signed proposal gets Abby\'s reply (a [TEST] to you first when another rep forwarded it).' : 'Saved - off. Nothing is sent; the agent replies itself.', 'success');
    } catch (e) {
      showMsg(soaMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { soaBtn.disabled = false; soaBtn.textContent = orig; }
  });
}
/* END CUSTOM_SIGNEDACKRELEASE_BY_CLAUDE */
/* CUSTOM_NEWVENDORRESET_BY_CLAUDE (AIOPS card db590fa31259) - Admin: New Vendor Reset. The switch (new-vendor-reset-config.enabled),
   the past-order count that arms it, and Ryan's per-vendor End / Extend. Same load-from-server rule as every other panel here:
   nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var nvrEnabled = document.getElementById('settings-newvendorreset-enabled');
var nvrBtn = document.getElementById('settings-newvendorreset-btn');
var nvrMsg = document.getElementById('settings-newvendorreset-msg');
var nvrStatus = document.getElementById('settings-newvendorreset-status');
var nvrList = document.getElementById('settings-newvendorreset-list');
var nvrSeedBtn = document.getElementById('settings-newvendorreset-seed');
var nvrVendor = document.getElementById('settings-newvendorreset-vendor');
var nvrOf = document.getElementById('settings-newvendorreset-of');
var nvrEndBtn = document.getElementById('settings-newvendorreset-end');
var nvrExtendBtn = document.getElementById('settings-newvendorreset-extend');
var nvrClearBtn = document.getElementById('settings-newvendorreset-clear');
var nvrLoaded = false;
function nvrEsc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

if (nvrBtn && nvrEnabled) {
  var nvrLoadBoard = async function() {
    try {
      var b = await window.RepPortal.API.get('/new-vendor-reset');
      if (nvrStatus) nvrStatus.textContent = b.seededAt
        ? 'Past orders counted ' + String(b.seededAt).slice(0, 10) + '. ' + (b.inReset || []).length + ' counted vendor(s) still new; a vendor with no portal order yet is new too.'
        : 'Past orders not counted yet: until they are, no vendor is treated as new. Press Count past orders first.';
      if (nvrList) nvrList.innerHTML = (b.inReset || []).length
        ? '<ul style="margin:6px 0 0 18px;padding:0;">' + b.inReset.map(function(v) { return '<li>' + nvrEsc(v.vendor) + ': ' + nvrEsc(v.label || '') + ' (' + nvrEsc(v.completed) + ' of ' + nvrEsc(v.of) + ' delivered or closed)</li>'; }).join('') + '</ul>'
        : '';
    } catch (e) {
      if (nvrStatus) nvrStatus.textContent = 'Could not read the vendor counts.';
    }
  };
  (async function loadNvr() {
    try {
      var data = await window.RepPortal.API.get('/admin/new-vendor-reset-config');
      nvrEnabled.checked = !!(data.config && data.config.enabled === true);
      nvrLoaded = true;
    } catch (e) {
      showMsg(nvrMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
    nvrLoadBoard();
  })();

  nvrBtn.addEventListener('click', async function() {
    hideMsg(nvrMsg);
    if (!nvrLoaded) { showMsg(nvrMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    nvrBtn.disabled = true;
    var orig = nvrBtn.textContent;
    nvrBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/new-vendor-reset-config', { enabled: !!nvrEnabled.checked });
      nvrEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(nvrMsg, nvrEnabled.checked ? 'Saved - on. Every email to a vendor on its first 3 orders comes to you as a [TEST] first.' : 'Saved - off. Every email goes at its type\'s normal level.', 'success');
    } catch (e) {
      showMsg(nvrMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { nvrBtn.disabled = false; nvrBtn.textContent = orig; }
  });

  if (nvrSeedBtn) nvrSeedBtn.addEventListener('click', async function() {
    hideMsg(nvrMsg);
    nvrSeedBtn.disabled = true;
    try {
      var r = await window.RepPortal.API.post('/new-vendor-reset/seed', {});
      showMsg(nvrMsg, 'Counted ' + r.sent + ' past purchase orders across ' + r.vendors + ' vendors; ' + (r.newVendors || []).length + ' still new.', 'success');
      nvrLoadBoard();
    } catch (e) {
      showMsg(nvrMsg, 'Could not count past orders: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { nvrSeedBtn.disabled = false; }
  });

  var nvrOverride = async function(action) {
    hideMsg(nvrMsg);
    var vendor = nvrVendor ? String(nvrVendor.value || '').trim() : '';
    if (!vendor) { showMsg(nvrMsg, 'Type the vendor name first.', 'error'); return; }
    var body = { vendor: vendor, action: action };
    if (action === 'extend') body.of = parseInt(nvrOf && nvrOf.value, 10);
    try {
      var r = await window.RepPortal.API.post('/new-vendor-reset/override', body);
      var s = r.newVendorReset || {};
      showMsg(nvrMsg, vendor + ': ' + (action === 'end' ? 'reset ended, its emails go at their normal level.' : action === 'extend' ? 'reset now runs for ' + body.of + ' orders. ' + (s.endsWhen || '') : 'back to the normal 3 orders. ' + (s.endsWhen || '')), 'success');
      nvrLoadBoard();
    } catch (e) {
      showMsg(nvrMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    }
  };
  if (nvrEndBtn) nvrEndBtn.addEventListener('click', function() { nvrOverride('end'); });
  if (nvrExtendBtn) nvrExtendBtn.addEventListener('click', function() { nvrOverride('extend'); });
  if (nvrClearBtn) nvrClearBtn.addEventListener('click', function() { nvrOverride('clear'); });
}
/* END CUSTOM_NEWVENDORRESET_BY_CLAUDE */
/* CUSTOM_TAXQUOTENEXUS_BY_CLAUDE (KAREN card 210d5a78496f) - Admin: Tax Quote Check. Same load-from-server rule as every
   other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var tqcEnabled = document.getElementById('settings-taxquotecheck-enabled');
var tqcBtn = document.getElementById('settings-taxquotecheck-btn');
var tqcMsg = document.getElementById('settings-taxquotecheck-msg');
var tqcLoaded = false;

if (tqcBtn && tqcEnabled) {
  (async function loadTqc() {
    try {
      var data = await window.RepPortal.API.get('/admin/tax-quote-check-config');
      tqcEnabled.checked = !!(data.config && data.config.enabled === true);
      tqcLoaded = true;
    } catch (e) {
      showMsg(tqcMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  tqcBtn.addEventListener('click', async function() {
    hideMsg(tqcMsg);
    if (!tqcLoaded) { showMsg(tqcMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    tqcBtn.disabled = true;
    var orig = tqcBtn.textContent;
    tqcBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/tax-quote-check-config', { enabled: !!tqcEnabled.checked });
      tqcEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(tqcMsg, tqcEnabled.checked ? 'Saved - on. A saved quote that would take its state to 80% or over the threshold wakes Karen.' : 'Saved - off. Quotes are not checked; the daily nexus alerts are unchanged.', 'success');
    } catch (e) {
      showMsg(tqcMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { tqcBtn.disabled = false; tqcBtn.textContent = orig; }
  });
}
/* END CUSTOM_TAXQUOTENEXUS_BY_CLAUDE */

/* CUSTOM_SAMEREFCHASE_BY_CLAUDE (ONYX card 5c8a172bef32) - Admin: Same-Deal Chase Guard. Same load-from-server rule as every
   other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var cgEnabled = document.getElementById('settings-chaseguard-enabled');
var cgDays = document.getElementById('settings-chaseguard-days');
var cgBtn = document.getElementById('settings-chaseguard-btn');
var cgMsg = document.getElementById('settings-chaseguard-msg');
var cgLoaded = false;

if (cgBtn && cgEnabled && cgDays) {
  (async function loadCg() {
    try {
      var data = await window.RepPortal.API.get('/admin/chase-guard-config');
      cgEnabled.checked = !!(data.config && data.config.enabled === true);
      cgDays.value = (data.config && data.config.businessDays) || 2;
      cgLoaded = true;
    } catch (e) {
      showMsg(cgMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  cgBtn.addEventListener('click', async function() {
    hideMsg(cgMsg);
    if (!cgLoaded) { showMsg(cgMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    var days = parseInt(cgDays.value, 10);
    if (!(days >= 1 && days <= 10)) { showMsg(cgMsg, 'Business days must be a whole number from 1 to 10.', 'error'); return; }
    cgBtn.disabled = true;
    var orig = cgBtn.textContent;
    cgBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/chase-guard-config', { enabled: !!cgEnabled.checked, businessDays: days });
      cgEnabled.checked = !!(res.config && res.config.enabled === true);
      cgDays.value = (res.config && res.config.businessDays) || days;
      showMsg(cgMsg, cgEnabled.checked ? 'Saved - on. An agent is stopped from a second email to the same person on a deal until they answer.' : 'Saved - off. Nothing is checked.', 'success');
    } catch (e) {
      showMsg(cgMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { cgBtn.disabled = false; cgBtn.textContent = orig; }
  });
}
/* END CUSTOM_SAMEREFCHASE_BY_CLAUDE */

/* CUSTOM_WAKECOALESCE_BY_CLAUDE (AIOPS card a9082cbe046a) - Admin: Deal Wake Bundling. Same load-from-server rule as every other
   panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var wcEnabled = document.getElementById('settings-wakecoalesce-enabled');
var wcBtn = document.getElementById('settings-wakecoalesce-btn');
var wcMsg = document.getElementById('settings-wakecoalesce-msg');
var wcLoaded = false;

if (wcBtn && wcEnabled) {
  (async function loadWc() {
    try {
      var data = await window.RepPortal.API.get('/admin/wake-coalesce-config');
      wcEnabled.checked = !!(data.config && data.config.enabled === true);
      wcLoaded = true;
    } catch (e) {
      showMsg(wcMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  wcBtn.addEventListener('click', async function() {
    hideMsg(wcMsg);
    if (!wcLoaded) { showMsg(wcMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    wcBtn.disabled = true;
    var orig = wcBtn.textContent;
    wcBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/wake-coalesce-config', { enabled: !!wcEnabled.checked });
      wcEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(wcMsg, wcEnabled.checked ? 'Saved - on. Repeat wakes about one deal within 5 minutes go to an agent as one.' : 'Saved - off. Every wake goes as it arrives.', 'success');
    } catch (e) {
      showMsg(wcMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { wcBtn.disabled = false; wcBtn.textContent = orig; }
  });
}
/* END CUSTOM_WAKECOALESCE_BY_CLAUDE */

/* CUSTOM_INFODIGEST_BY_CLAUDE (AIOPS card 0b13ddb0be79) - Admin: Info Notices To Morning Digest. Same load-from-server rule as every
   other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var idEnabled = document.getElementById('settings-infodigest-enabled');
var idBtn = document.getElementById('settings-infodigest-btn');
var idMsg = document.getElementById('settings-infodigest-msg');
var idLoaded = false;

if (idBtn && idEnabled) {
  (async function loadId() {
    try {
      var data = await window.RepPortal.API.get('/admin/info-digest-config');
      idEnabled.checked = !!(data.config && data.config.enabled === true);
      idLoaded = true;
    } catch (e) {
      showMsg(idMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  idBtn.addEventListener('click', async function() {
    hideMsg(idMsg);
    if (!idLoaded) { showMsg(idMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    idBtn.disabled = true;
    var orig = idBtn.textContent;
    idBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/info-digest-config', { enabled: !!idEnabled.checked });
      idEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(idMsg, idEnabled.checked ? 'Saved - on. Notices that ask an agent for nothing wait for its 7:30 AM digest.' : 'Saved - off. Every notice goes as it arrives.', 'success');
    } catch (e) {
      showMsg(idMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { idBtn.disabled = false; idBtn.textContent = orig; }
  });
}
/* END CUSTOM_INFODIGEST_BY_CLAUDE */

/* CUSTOM_TESTOVERLAP_BY_CLAUDE (BRENDON card 640a947d0f34) - Admin: TEST Overlap And Reply Matching. Same load-from-server rule as
   every other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var toCross = document.getElementById('settings-testoverlap-crossdoor');
var toNum = document.getElementById('settings-testoverlap-sendbynumber');
var toBtn = document.getElementById('settings-testoverlap-btn');
var toMsg = document.getElementById('settings-testoverlap-msg');
var toLoaded = false;

if (toBtn && toCross && toNum) {
  (async function loadTo() {
    try {
      var data = await window.RepPortal.API.get('/admin/test-overlap-config');
      toCross.checked = !!(data.config && data.config.crossDoor === true);
      toNum.checked = !!(data.config && data.config.sendByNumber === true);
      toLoaded = true;
    } catch (e) {
      showMsg(toMsg, 'Could not load the current settings - reload before saving.', 'error');
    }
  })();

  toBtn.addEventListener('click', async function() {
    hideMsg(toMsg);
    if (!toLoaded) { showMsg(toMsg, 'The current settings never loaded - reload the page first.', 'error'); return; }
    toBtn.disabled = true;
    var orig = toBtn.textContent;
    toBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/test-overlap-config', { crossDoor: !!toCross.checked, sendByNumber: !!toNum.checked });
      toCross.checked = !!(res.config && res.config.crossDoor === true);
      toNum.checked = !!(res.config && res.config.sendByNumber === true);
      showMsg(toMsg, 'Saved - cross-mailbox check ' + (toCross.checked ? 'on' : 'off') + ', send by TEST number ' + (toNum.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(toMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { toBtn.disabled = false; toBtn.textContent = orig; }
  });
}
/* END CUSTOM_TESTOVERLAP_BY_CLAUDE */

/* CUSTOM_RELATIVEDAY_BY_CLAUDE (ONYX card a1c7d2f85302) - Admin: Relative Day Words In TESTs. Same load-from-server rule as every
   other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var rlvStage = document.getElementById('settings-relativeday-stage');
var rlvRelease = document.getElementById('settings-relativeday-release');
var rlvRewrite = document.getElementById('settings-relativeday-rewrite'); // CUSTOM_DAYWORDSREWRITE_BY_CLAUDE
var rlvBtn = document.getElementById('settings-relativeday-btn');
var rlvMsg = document.getElementById('settings-relativeday-msg');
var rlvLoaded = false;

if (rlvBtn && rlvStage && rlvRelease) {
  (async function loadRlv() {
    try {
      var data = await window.RepPortal.API.get('/admin/relative-day-config');
      rlvStage.checked = !!(data.config && data.config.refuseAtStage === true);
      rlvRelease.checked = !!(data.config && data.config.holdAtRelease === true);
      if (rlvRewrite) rlvRewrite.checked = !!(data.config && data.config.rewriteAtRelease === true);
      rlvLoaded = true;
    } catch (e) {
      showMsg(rlvMsg, 'Could not load the current settings - reload before saving.', 'error');
    }
  })();

  rlvBtn.addEventListener('click', async function() {
    hideMsg(rlvMsg);
    if (!rlvLoaded) { showMsg(rlvMsg, 'The current settings never loaded - reload the page first.', 'error'); return; }
    rlvBtn.disabled = true;
    var orig = rlvBtn.textContent;
    rlvBtn.textContent = 'Saving...';
    try {
      var rlvBody = { refuseAtStage: !!rlvStage.checked, holdAtRelease: !!rlvRelease.checked };
      if (rlvRewrite) rlvBody.rewriteAtRelease = !!rlvRewrite.checked; // CUSTOM_DAYWORDSREWRITE_BY_CLAUDE
      var res = await window.RepPortal.API.post('/admin/relative-day-config', rlvBody);
      rlvStage.checked = !!(res.config && res.config.refuseAtStage === true);
      rlvRelease.checked = !!(res.config && res.config.holdAtRelease === true);
      if (rlvRewrite) rlvRewrite.checked = !!(res.config && res.config.rewriteAtRelease === true);
      showMsg(rlvMsg, 'Saved - refuse at staging ' + (rlvStage.checked ? 'on' : 'off') + ', hold at sending ' + (rlvRelease.checked ? 'on' : 'off') + (rlvRewrite ? ', Claude rewrites ' + (rlvRewrite.checked ? 'on' : 'off') : '') + '.', 'success');
    } catch (e) {
      showMsg(rlvMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rlvBtn.disabled = false; rlvBtn.textContent = orig; }
  });
}
/* END CUSTOM_RELATIVEDAY_BY_CLAUDE */

/* CUSTOM_POHOLD_BY_CLAUDE (ONYX card 35108f0450b5) - Admin: PO Hold. Same load-from-server rule as every other panel here: nothing
   is defaulted in the markup, so a Save can never write a value the page did not read. */
var phEnabled = document.getElementById('settings-pohold-enabled');
var phBtn = document.getElementById('settings-pohold-btn');
var phMsg = document.getElementById('settings-pohold-msg');
var phLoaded = false;

if (phBtn && phEnabled) {
  (async function loadPh() {
    try {
      var data = await window.RepPortal.API.get('/admin/po-hold-config');
      phEnabled.checked = !!(data.config && data.config.enabled === true);
      phLoaded = true;
    } catch (e) {
      showMsg(phMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  phBtn.addEventListener('click', async function() {
    hideMsg(phMsg);
    if (!phLoaded) { showMsg(phMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    phBtn.disabled = true;
    var orig = phBtn.textContent;
    phBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/po-hold-config', { enabled: !!phEnabled.checked });
      phEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(phMsg, 'Saved - PO hold ' + (phEnabled.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(phMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { phBtn.disabled = false; phBtn.textContent = orig; }
  });
}
/* END CUSTOM_POHOLD_BY_CLAUDE */

/* CUSTOM_OFFLINETAX_BY_CLAUDE (KAREN card 51cbd070eaac) - Admin: Offline Deal Sales Tax. Same load-from-server rule as every other
   panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var otEnabled = document.getElementById('settings-offlinetax-enabled');
var otBtn = document.getElementById('settings-offlinetax-btn');
var otMsg = document.getElementById('settings-offlinetax-msg');
var otLoaded = false;

if (otBtn && otEnabled) {
  (async function loadOt() {
    try {
      var data = await window.RepPortal.API.get('/admin/offline-tax-config');
      otEnabled.checked = !!(data.config && data.config.enabled === true);
      otLoaded = true;
    } catch (e) {
      showMsg(otMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  otBtn.addEventListener('click', async function() {
    hideMsg(otMsg);
    if (!otLoaded) { showMsg(otMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    otBtn.disabled = true;
    var orig = otBtn.textContent;
    otBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/offline-tax-config', { enabled: !!otEnabled.checked });
      otEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(otMsg, 'Saved - offline deal sales tax ' + (otEnabled.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(otMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { otBtn.disabled = false; otBtn.textContent = orig; }
  });
}
/* END CUSTOM_OFFLINETAX_BY_CLAUDE */

/* CUSTOM_FORWARDHANDLED_BY_CLAUDE (ONYX card 423da0ae0ccf) - Admin: Forwards Done Once Answered. Same load-from-server rule as every
   other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var fhEnabled = document.getElementById('settings-forwardhandled-enabled');
var fhBtn = document.getElementById('settings-forwardhandled-btn');
var fhMsg = document.getElementById('settings-forwardhandled-msg');
var fhLoaded = false;

if (fhBtn && fhEnabled) {
  (async function loadFh() {
    try {
      var data = await window.RepPortal.API.get('/admin/forward-handled-config');
      fhEnabled.checked = !!(data.config && data.config.enabled === true);
      fhLoaded = true;
    } catch (e) {
      showMsg(fhMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  fhBtn.addEventListener('click', async function() {
    hideMsg(fhMsg);
    if (!fhLoaded) { showMsg(fhMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    fhBtn.disabled = true;
    var orig = fhBtn.textContent;
    fhBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/forward-handled-config', { enabled: !!fhEnabled.checked });
      fhEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(fhMsg, 'Saved - forwards done once answered ' + (fhEnabled.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(fhMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { fhBtn.disabled = false; fhBtn.textContent = orig; }
  });
}
/* END CUSTOM_FORWARDHANDLED_BY_CLAUDE */

/* CUSTOM_REPLYQUOTE_BY_CLAUDE (BRENDON card 6a6b4fd4ce18) - Admin: Reply Quotes Without Internal Mail. Same load-from-server rule as
   every other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var rqEnabled = document.getElementById('settings-replyquote-enabled');
var rqBtn = document.getElementById('settings-replyquote-btn');
var rqMsg = document.getElementById('settings-replyquote-msg');
var rqLoaded = false;

if (rqBtn && rqEnabled) {
  (async function loadRq() {
    try {
      var data = await window.RepPortal.API.get('/admin/reply-quote-config');
      rqEnabled.checked = !!(data.config && data.config.enabled === true);
      rqLoaded = true;
    } catch (e) {
      showMsg(rqMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  rqBtn.addEventListener('click', async function() {
    hideMsg(rqMsg);
    if (!rqLoaded) { showMsg(rqMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    rqBtn.disabled = true;
    var orig = rqBtn.textContent;
    rqBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/reply-quote-config', { enabled: !!rqEnabled.checked });
      rqEnabled.checked = !!(res.config && res.config.enabled === true);
      showMsg(rqMsg, 'Saved - reply quotes without internal mail ' + (rqEnabled.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(rqMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { rqBtn.disabled = false; rqBtn.textContent = orig; }
  });
}
/* END CUSTOM_REPLYQUOTE_BY_CLAUDE */

/* CUSTOM_QUESTIONANSWERED_BY_CLAUDE (ONYX card 703559a08f8d) - Admin: Answer Acknowledgements. Same load-from-server rule as every
   other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var qaEnabled = document.getElementById('settings-replyowed-enabled');
var qaBtn = document.getElementById('settings-replyowed-btn');
var qaMsg = document.getElementById('settings-replyowed-msg');
var qaLoaded = false;

if (qaBtn && qaEnabled) {
  (async function loadQa() {
    try {
      var data = await window.RepPortal.API.get('/admin/reply-owed-config');
      qaEnabled.checked = !!(data && data.enabled === true);
      qaLoaded = true;
    } catch (e) {
      showMsg(qaMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  qaBtn.addEventListener('click', async function() {
    hideMsg(qaMsg);
    if (!qaLoaded) { showMsg(qaMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    qaBtn.disabled = true;
    var orig = qaBtn.textContent;
    qaBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/reply-owed-config', { enabled: !!qaEnabled.checked });
      qaEnabled.checked = !!(res && res.enabled === true);
      showMsg(qaMsg, 'Saved - answer acknowledgements ' + (qaEnabled.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(qaMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { qaBtn.disabled = false; qaBtn.textContent = orig; }
  });
}
/* END CUSTOM_QUESTIONANSWERED_BY_CLAUDE */

/* CUSTOM_SIGNPAUSE_BY_CLAUDE (ONYX card 54561ee1ee0d) - Admin: Pause Sign Reminders For A Seen Signed Copy. Same load-from-server
   rule as every other panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var spEnabled = document.getElementById('settings-signpause-enabled');
var spBtn = document.getElementById('settings-signpause-btn');
var spMsg = document.getElementById('settings-signpause-msg');
var spLoaded = false;

if (spBtn && spEnabled) {
  (async function loadSp() {
    try {
      var data = await window.RepPortal.API.get('/admin/sign-reminder-pause-config');
      spEnabled.checked = !!(data && data.config && data.config.enabled === true);
      spLoaded = true;
    } catch (e) {
      showMsg(spMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  spBtn.addEventListener('click', async function() {
    hideMsg(spMsg);
    if (!spLoaded) { showMsg(spMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    spBtn.disabled = true;
    var orig = spBtn.textContent;
    spBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/sign-reminder-pause-config', { enabled: !!spEnabled.checked });
      spEnabled.checked = !!(res && res.config && res.config.enabled === true);
      showMsg(spMsg, 'Saved - the pause for a seen signed copy is ' + (spEnabled.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(spMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { spBtn.disabled = false; spBtn.textContent = orig; }
  });
}
/* END CUSTOM_SIGNPAUSE_BY_CLAUDE */

/* CUSTOM_ROCKETRETRY_BY_CLAUDE (LOGAN card 726178d07925) - Admin: Freight Auto-Retry. Same load-from-server rule as every other
   panel here: nothing is defaulted in the markup, so a Save can never write a value the page did not read. */
var frEnabled = document.getElementById('settings-freightretry-enabled');
var frBtn = document.getElementById('settings-freightretry-btn');
var frMsg = document.getElementById('settings-freightretry-msg');
var frLoaded = false;

if (frBtn && frEnabled) {
  (async function loadFr() {
    try {
      var data = await window.RepPortal.API.get('/admin/freight-retry-config');
      frEnabled.checked = !!(data && data.config && data.config.enabled === true);
      frLoaded = true;
    } catch (e) {
      showMsg(frMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();

  frBtn.addEventListener('click', async function() {
    hideMsg(frMsg);
    if (!frLoaded) { showMsg(frMsg, 'The current setting never loaded - reload the page first.', 'error'); return; }
    frBtn.disabled = true;
    var orig = frBtn.textContent;
    frBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/freight-retry-config', { enabled: !!frEnabled.checked });
      frEnabled.checked = !!(res && res.config && res.config.enabled === true);
      showMsg(frMsg, 'Saved - freight auto-retry is ' + (frEnabled.checked ? 'on' : 'off') + '.', 'success');
    } catch (e) {
      showMsg(frMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { frBtn.disabled = false; frBtn.textContent = orig; }
  });
}
/* END CUSTOM_ROCKETRETRY_BY_CLAUDE */




  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAgentPanels);
  else initAgentPanels();
})();
